import { Component, EventEmitter, Inject, Input, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ProjectEditDialogComponent } from '../project/project-edit/project-edit.dialog.component';
import { ElectricalService } from '../services/electrical.service';
import {
  User,
  Project,
  Address,
  Drawing,
  Customer
} from '../../../core/auth';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { CustomersService } from '../services/customers.service';
import { UserService } from '../services/user.service';
import { ProjectService } from '../services/project.service';
import { map, startWith } from 'rxjs/operators';
import { TypesUtilsService } from '../../../core/_base/crud';
import { DrawingService } from '../services/drawing.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { delay } from 'rxjs/operators';
import { DepthOption, getDepthOptions } from '../../../core/auth/_models/depth-option.model';

@Component({
  selector: 'Wizard-dialog',
  templateUrl: './WizardDialog.component.html',
  styleUrls: ['./WizardDialog.component.scss'],
  providers: [DatePipe]
})
export class WizardDialogComponent implements OnInit {
  @Output() resultEmitter = new EventEmitter<any>();

  @Input() tableData: any[] = [];
  @Input() tableDataMCCB: any[] = [];
  nodeDataArray: { [key: string]: any }[] = [];
  initialNodeDataArray: any[] = [];
  AdditionalDoorDataArray: { [key: string]: any }[] = [];
  initialAdditionalDoorDataArray: any[] = [];
  incomers: any[] = [{}];
  currentPage: number = 1;
  currentIncomerPage: number = 1;
  currentOutGoingPage: number = 1;
  selectedManufacturer: string | null = null;
  selectedManufacturerMCCB: string | null = null;
  selectedRatedAmp: string | null = null;
  selectedRatedAmpMCCB: string | null = null;
  selectedFrameSize: string | null = null;
  selectedFrameSizeMCCB: string | null = null;
  selectedTripUnitMCCB: string | null = null;
  selectedOrderNumberMCCB: string | null = null;
  selectedPRFLevel: string | null = null;
  selectedPRFLevelMCCB: string | null = null;
  selectedShortCircuitIcs: string | null = null;
  selectedShortCircuitIcu: string | null = null;
  selectedShortCircuitIcuMCCB: string | null = null;
  selectedShortCircuitIcw: string | null = null;
  selectedType: string | null = null;
  selectedTypeMCCB: string | null = null;
  selectedRotation: string | null = 'Vertical';
  selectedBusbarType: string;
  selectedCableSize: number | null = null;
  selectedMinHeightApplication: string | null = '1C Applications';
  busbarTypeOptions: string[] = ["Busbar Support - Flat", "Busbar Support With Grooves"];
  matchingRow: any | null = null;
  matchingRowMCCB: any | null = null;
  imagePath: string = '';
  imagePathMCCB: string = '';
  selectedIncomer: any;
  selectedMaxTierHeight: number;
  maxTierHeightOptions: number[];
  showMCCB: boolean = false;
  showProjectDetails: boolean = false;
  tierHeight: number | null;
  selectedItem: string | null = 'selectedAcb';

  // Define your dropdown options here
  manufacturerOptions: string[] = [];
  manufacturerOptionsMCCB: string[] = [];
  typeOptions: string[] = [];
  typeOptionsMCCB: string[] = [];
  ratedAmpOptions: string[] = [];
  ratedAmpOptionsMCCB: string[] = [];
  shortCircuitIcuOptions: string[] = [];
  shortCircuitIcuOptionsMCCB: string[] = [];
  frameSizeOptions: string[] = [];
  frameSizeOptionsMCCB: string[] = [];
  prfLevelOptions: string[] = [];
  prfLevelOptionsMCCB: string[] = [];
  tripUnitOptionsMCCB: string[] = [];
  orderNumberOptionsMCCB: string[] = [];
  numberOfOutgoing: number = 1;


  project = new Project();
  project$: Observable<Project>;
  projectForm: FormGroup;
  formType: string[] = ['Form 1', 'Form 2a', 'Form 2b', 'Form 3a', 'Form 3b', 'Form 4a', 'Form 4b'];
  voltage: string[] = ['250A', '400A', '630A', '800A', '1000A', '1200A', '1600A', '2000A', '2500A', '3200A', '4000A', '5000A', '6300A'];
  busbarLocation: string[] = ['Back', 'Top', 'Bottom'];
  cabledirection: string[] = ['Top', 'Bottom', 'Top & Bottom'];
  shortCircuitTime: string[] = ['100kA/1S', '85kA/1S', '75kA/1S', '50kA/1S'];
  earthingSystem: string[] = ['TN-H', 'TN-C', 'TN', 'IT'];
  iecStandard: string[] = ['61439'];
  ipRating: string[] = ['IP42', 'IP43', 'IP54', 'IP55'];
  colour: string[] = ['RAL 7032', 'RAL 7035', 'RAL 2000', 'OTHER COLORS'];
  selectValue: any;
  updatedProject: Project;
  selectedItems: any;
  depth: DepthOption[] = getDepthOptions();

  CubiclesSizesVerticle = [
    { ampere: 160, width: 200, height: 600 },
    { ampere: 250, width: 300, height: 600 },
    { ampere: 400, width: 300, height: 600 },
    { ampere: 630, width: 300, height: 600 },
    { ampere: 800, width: 400, height: 600 },
    { ampere: 800, width: 400, height: 1000 },
    { ampere: 1000, width: 400, height: 600 },
    { ampere: 1000, width: 600, height: 1000 },
    { ampere: 1250, width: 400, height: 600 },
    { ampere: 1600, width: 400, height: 600 }
  ];

  CubiclesSizesHorizontal = [
    { ampere: 63, width: 400, height: 200 },
    { ampere: 160, width: 600, height: 200 },
    { ampere: 250, width: 600, height: 200 },
    { ampere: 400, width: 600, height: 300 },
    { ampere: 630, width: 600, height: 400 },
    { ampere: 800, width: 600, height: 400 }
  ];

  CubiclesSizes = [
    { ampere: 1600, width: 600, height: 600, depthWithESFixed: 300, depthWithESDrawOut: 300 },
    { ampere: 2000, width: 600, height: 600, depthWithESFixed: 300, depthWithESDrawOut: 300 },
    { ampere: 2500, width: 800, height: 600, depthWithESFixed: 300, depthWithESDrawOut: 400 },
    { ampere: 3200, width: 800, height: 600, depthWithESFixed: 300, depthWithESDrawOut: 400 },
    { ampere: 4000, width: 800, height: 600, depthWithESFixed: 300, depthWithESDrawOut: 400 },
    { ampere: 5000, width: 1200, height: 600, depthWithESFixed: 300, depthWithESDrawOut: 400 },
    { ampere: 6300, width: 1200, height: 600, depthWithESFixed: 300, depthWithESDrawOut: 400 } // Depth values not available in the table for 6500A
  ];

  busBarData = {
    mainHorizontal: [
      {
        ampere: 200,
        height: 200,
        busbarDepth: 400,
        des: '25 x 12 x 400 Single BBS',
        orderCode: 'BSS251204KFZN',
        img: '../../../../../assets/media/busbar-holder-image/BBH Single 25x12x400.jpg'
      },
      {
        ampere: 250,
        height: 200,
        busbarDepth: 400,
        des: '25 x 12 x 400 Single BBS',
        orderCode: 'BSS251204KFZN',
        img: '../../../../../assets/media/busbar-holder-image/BBH Single 25x12x400.jpg'
      },
      {
        ampere: 400,
        height: 200,
        busbarDepth: 400,
        des: '25 x 12 x 400 Single BBS',
        orderCode: 'BSS251204KFZN',
        img: '../../../../../assets/media/busbar-holder-image/BBH Single 25x12x400.jpg'
      },
      {
        ampere: 630,
        height: 200,
        busbarDepth: 400,
        des: '50 x 20 x 400 Single BBS',
        orderCode: 'BSS051204KIZP',
        img: '../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg'
      },
      {
        ampere: 800,
        height: 200,
        busbarDepth: 400,
        des: '50 x 20 x 400 Single BBS',
        orderCode: 'BSS051204KIZP',
        img: '../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg'
      },
      {
        ampere: 1000,
        height: 200,
        busbarDepth: 400,
        des: '50 x 20 x 400 Single BBS',
        orderCode: 'BSS050204KLZB',
        img: '../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg'
      },
      {
        ampere: 1250,
        height: 200,
        busbarDepth: 400,
        des: '50 x 20 x 400 Single BBS',
        orderCode: 'BSS050204KLZB',
        img: '../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg'
      },
      {
        ampere: 1600,
        height: 200,
        busbarDepth: 400,
        des: '50 x 20 x 400 Single BBS',
        orderCode: 'BSS050204KLZB',
        img: '../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg'
      },
      {
        ampere: 2000,
        height: 300,
        busbarDepth: 600,
        des: '50 x 20 x 500 Double BBS',
        orderCode: 'BSD050205KMZE',
        img: '../../../../../assets/media/busbar-holder-image/BBH Double 50x20x500.jpg'
      },
      {
        ampere: 2500,
        height: 300,
        busbarDepth: 600,
        des: '50 x 20 x 600 Double BBS',
        orderCode: 'BSD050206KNZF',
        img: '../../../../../assets/media/busbar-holder-image/BBH Double 50x20x600.jpg'
      },
      {
        ampere: 3200,
        height: 400,
        busbarDepth: 600,
        des: '50 x 35 x 600 Double BBS',
        orderCode: 'BSD053506KOZH',
        img: '../../../../../assets/media/busbar-holder-image/BBH Double 50x35x600.jpg'
      },
      {
        ampere: 4000,
        height: 400,
        busbarDepth: 600,
        des: '50 x 35 x 600 Double BBS',
        orderCode: 'BSD053506KPZH',
        img: '../../../../../assets/media/busbar-holder-image/BBH Double 50x35x600.jpg'
      },
      {
        ampere: 5000,
        height: 400,
        busbarDepth: 600,
        des: '50 x 35 x 600 Double BBS',
        orderCode: 'BSD053506KQZL',
        img: '../../../../../assets/media/busbar-holder-image/BBH Double 50x35x600.jpg'
      },
      {
        ampere: 6300,
        height: 600,
        busbarDepth: 800,
        des: '120 x 30 x 800 Double BBS',
        orderCode: 'BSD120308KSZL',
        img: '../../../../../assets/media/busbar-holder-image/BBH Double 120x30x800.jpg'
      }
    ],
    dropper: [
      {
        ampere: 400,
        busbarSize: '25 x 12 x 344',
        des: '25 x 12 x 344 Single BBS',
        height: 200,
        busbarDepth: 400
      },
      {
        ampere: 630,
        busbarSize: '25 x 12 x 344',
        des: '50 x 12 x 344 Single BBS',
        height: 200,
        busbarDepth: 400
      },
      {
        ampere: 800,
        busbarSize: '36 x 12 x 344',
        des: '50 x 12 x 344 Single BBS',
        height: 200,
        busbarDepth: 400
      },
      {
        ampere: 1000,
        busbarSize: '36 x 20 x 344',
        des: '50 x 20 x 344 Single BBS',
        height: 200,
        busbarDepth: 400
      },
      {
        ampere: 1250,
        busbarSize: '36 x 20 x 344',
        des: '50 x 20 x 344 Single BBS',
        height: 200,
        busbarDepth: 400
      },
      {
        ampere: 1600,
        height: 200,
        busbarDepth: 400,
        des: '25 x 40 x 425',
        orderCode: 'BSP250442KLZC',
        img: '../../../../../assets/media/busbar-holder-image/BBH Groves 60x600.jpg'
      },
      {
        ampere: 2000,
        height: 200,
        busbarDepth: 400,
        des: '30 x 50 x 450',
        orderCode: 'BSP030545KMZD',
        img: '../../../../../assets/media/busbar-holder-image/BBH Groves 75x600.jpg'
      },
      {
        ampere: 2500,
        height: 200,
        busbarDepth: 400,
        des: '30 x 50 x 450',
        orderCode: 'BSP030545KNZF',
        img: '../../../../../assets/media/busbar-holder-image/BBH Groves 100x600.jpg'
      },
      {
        ampere: 3200,
        height: 200,
        busbarDepth: 400,
        des: '25 x 40 x 425',
        orderCode: 'BSP254042KOZG',
        img: '../../../../../assets/media/busbar-holder-image/BBH Groves 120x600.jpg'
      },
      {
        ampere: 3200,
        height: 200,
        busbarDepth: 400,
        des: '30 x 50 x 450',
        orderCode: 'BSP030545KOZG',
        img: '../../../../../assets/media/busbar-holder-image/BBH Groves 120x600.jpg'
      },
      {
        ampere: 4000,
        height: 400,
        busbarDepth: 400,
        des: '30 x 45 x 584',
        orderCode: 'BSP034558KPZG',
        img: '../../../../../assets/media/busbar-holder-image/BBH Groves 120x800.jpg'
      },
      {
        ampere: 5000,
        height: 400,
        busbarDepth: 400,
        des: '30 x 45 x 584',
        orderCode: 'BSP034558KQZK',
        img: '../../../../../assets/media/busbar-holder-image/BBH Groves 160x800.jpg'
      },
      {
        ampere: 6000,
        height: 400,
        busbarDepth: 400,
        des: '30 x 45 x 584',
        orderCode: 'BSP034558KQZK',
        img: '../../../../../assets/media/busbar-holder-image/BBH Groves 160x800.jpg'
      }
    ]
  };


  cableSizeData = [
    { size: 4, minHeight1C: 200, minHeight4C: 200 },
    { size: 6, minHeight1C: 200, minHeight4C: 200 },
    { size: 16, minHeight1C: 200, minHeight4C: 200 },
    { size: 25, minHeight1C: 200, minHeight4C: 200 },
    { size: 35, minHeight1C: 250, minHeight4C: 250 },
    { size: 50, minHeight1C: 300, minHeight4C: 300 },
    { size: 70, minHeight1C: 300, minHeight4C: 300 },
    { size: 95, minHeight1C: 300, minHeight4C: 300 },
    { size: 120, minHeight1C: 350, minHeight4C: 350 },
    { size: 185, minHeight1C: 400, minHeight4C: 400 },
    { size: 240, minHeight1C: 600, minHeight4C: 350 },
    { size: 300, minHeight1C: 600, minHeight4C: 600 },
    { size: 400, minHeight1C: 600, minHeight4C: 600 },
    { size: 500, minHeight1C: 700, minHeight4C: 700 },
    { size: 600, minHeight1C: 800, minHeight4C: 800 }
  ];

  myDate = new Date();
  userName: any;
  filteredCustomers: Observable<Customer[]>;
  myControl = new FormControl('', [Validators.required]);
  role: string;
  loadedCustomers: Customer[] = [];
  email: any;
  user: User;
  salePersonCode = '';
  userid: any;
  distributorCompanyName: string;
  IsKikMember: boolean;
  isDirectCustomer: boolean;
  loadedProject: Project[];
  referenceId: string;
  selectedCustomerId: string | null = null;
  customerNameInputData: string = '';
  customerData;
  hasFormErrors = false;
  Wizard: boolean = true;
  oneBaseFrameWidth = 0;
  widthArray = [] as number[];
  widthArrayNextOutgoing = [] as number[];
  tempnumberOfOutgoing: any[] = [];
  incomerHistory: any[] = [];
  outgoingHistory: any[] = [];
  isMovingToPreviousIncomer: boolean = false;
  isMovingToPreviousOutgoing: boolean = false;
  animateNext = false;
  animatePrevious = false;
  constructor(
    public dialogRef: MatDialogRef<WizardDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private electricalService: ElectricalService,
    private dialog: MatDialog,
    private projectFB: FormBuilder,
    private datePipe: DatePipe,
    private customerService: CustomersService,
    private userService: UserService,
    public projectService: ProjectService,
    private cdr: ChangeDetectorRef,
    public typeUtil: TypesUtilsService,
    public drawingService: DrawingService,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.initializeMaxTierHeightOptions();
    this.projectService.getAll().subscribe(res => {
      this.loadedProject = res;
      this.referenceId = this.ProjectRefNo('KIK2D-' + this.datePipe.transform(this.myDate, 'yyyy-MM-dd') + '-', String(this.loadedProject.length + 1), '0', 3);

    });
    this.userid = localStorage.getItem('userId');
    this.userService
      .getUserById(this.userid)
      .subscribe(
        (user) => {
          this.role = user.role
          this.distributorCompanyName = user.distributorCompanyName
          this.IsKikMember = user.isKikMember
          this.isDirectCustomer = user.isDirectCustomer

        },
        (error) => {
          console.error(
            'Error fetching users by userId',
            error
          );
        }
      );

    this.customerList();
  }

  ngOnInit() {
    this.fetchTableData();
    this.fetchTableDataMCCB();
    this.customerList();
    this.filteredCustomers = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => value ? this._filterCustomers(value) : this.loadedCustomers.slice())
    );


    ///this.ProjectList();

    this.email = localStorage.getItem('email');
    this.userService.getUserByEmail(this.email).subscribe(
      res => {
        if (res) {
          this.user = res;
          this.user.fullname = res.fullname;
          this.salePersonCode = this.generateSalePersonCode(this.user.fullname);
        }

      }
    )
    this.userName = localStorage.getItem('username');
    this.initProject();
    if (this.data) {
      this.selectedManufacturer = this.data.MANUFACTUR || null;
      this.selectedRatedAmp = this.data.RATED_AMP || null;
      this.selectedFrameSize = this.data.FRAME_SIZE || null;
      this.selectedPRFLevel = this.data.PRF_LEVEL || null;
      this.selectedShortCircuitIcs = this.data['SHORTCU_(Ics)'] || null;
      this.selectedShortCircuitIcu = this.data['SHORTCU_(Icu)'] || null;
      this.selectedShortCircuitIcw = this.data['SHORTCU_(Icw)'] || null;
      this.selectedType = this.data.TYPE || null;
      this.fetchTableData();
      this.fetchTableDataMCCB();
    }
  }
  initProject() {
    this.createForm();
  }
  /**
   * Create form
   */
  createForm() {
    this.projectForm = this.projectFB.group({
      title: ['', [Validators.required]],
      designer: [],
      approvedBy: [],
      customerName: [''],
      // customerId: [],	
      address: this.projectFB.group({
        addressLine: ['', [Validators.required]],
        city: [],
        state: [],
        country: ['', [Validators.required]],
        email: [],
        postCode: [],
        telephone: ['', [Validators.required, this.validateTelephoneOrMobile]],
        mobile: [],
      }),
      telephone: [],
      mobile: [],
      earthingSystem: [],
      iecStandard: [],
      ipRating: [],
      orginDate: [],
      formType: ['', [Validators.required]],
      voltage: ['', [Validators.required]],
      busbarLocation: [],
      cabledirection: [],
      shortCircuitTime: [],
      version: [],
      colour: [],
      discount: [null],
      frightCharges: [],
      shipmentMode: [],
      portName: [],
      panelname: ['', [Validators.required]],
      specialNote: [],

      depthoption: ['', [Validators.required]],
    });

    this.setDefultValueOf();


  }
  setDefultValueOf() {
    // Find the maximum RATED_AMP value from this.nodeDataArray where text: "ACB"
    const nodesWithACB = this.nodeDataArray.filter(node => node.text === "ACB" || node.text === "MCCB");
    if (nodesWithACB.length === 0) {
      console.error('No nodes found with text "ACB"');
      return;
    }

    const maxRatedAmp = Math.max(
      ...nodesWithACB.map(node => Number(node.properties.RATED_AMP) || 0)
    );
    // Get the depthWithESDrawOut value from CubiclesSizes if properties.TYPE is "3P-W" or "4P-W"
    const cubicleSize = this.CubiclesSizes.find(cubicle => cubicle.ampere === maxRatedAmp);
    const maxAmpNode = nodesWithACB.find(node =>
      Number(node.properties.RATED_AMP) === maxRatedAmp
    );
    let componentDepth = 0;
    if (cubicleSize) {
      if (maxAmpNode) {
        const isType3P_W_or_4P_W = maxAmpNode.properties.TYPE === "3P-W" || maxAmpNode.properties.TYPE === "4P-W";

        componentDepth = isType3P_W_or_4P_W ? cubicleSize.depthWithESDrawOut : cubicleSize.depthWithESFixed;

      }
    }

    const busbarTypeOptions = maxAmpNode?.properties.busbarTypeOptions;

    let busbarDepth = 0;
    if (busbarTypeOptions === 'Busbar Support - Flat') {
      busbarDepth = this.busBarData.mainHorizontal.find(data => data.ampere === maxRatedAmp)?.busbarDepth || 0;
    } else if (busbarTypeOptions === 'Busbar Support With Grooves') {
      busbarDepth = this.busBarData.dropper.find(data => data.ampere === maxRatedAmp)?.busbarDepth || 0;
    }


    // Set the default depthoption
    const defaultDepthOption = this.depth.find(depth => depth.component === componentDepth && depth.busbar === busbarDepth);

    this.projectForm.patchValue({
      colour: this.colour[1] || 'defaultColour',
      earthingSystem: this.earthingSystem[1] || 'defaultEarthingSystem',
      formType: this.formType[4] || 'defaultFormType',
      busbarLocation: this.busbarLocation[1] || 'defaultBusbarLocation',
      cabledirection: this.cabledirection[1] || 'defaultCableDirection',
      shortCircuitTime: this.shortCircuitTime[0] || 'defaultShortCircuitTime',
      depthoption: defaultDepthOption || this.depth[3] || 'defaultDepthOption', // Set the default depthoption or a fallback
      voltage: this.voltage[5] || 'defaultVoltage',
      iecStandard: this.iecStandard[0] || 'defaultIECStandard',
      ipRating: this.ipRating[2] || 'defaultIPRating',
      orginDate: this.datePipe.transform(this.myDate, 'yyyy-MM-dd') || 'defaultDate'
    });
  }

  getComponentTitle() {
    let result = 'Project Information';
    if (!this.project || !this.project.uuid) {
      return result;
    }

    // result = `Edit project - ${this.project.title}`;
    result = 'Project Information';
    return result;
  }
  customerList() {
    this.customerService.getAllCustomers().subscribe(res => {
      //this.loadedCustomers =res.filter(o => o.email === 'kik@kik.lk');
      //this.loadedCustomers =res.filter(o => o.email === 'kik@kik.lk');
      var data = res;
      if (this.role === 'superadmin') {
        this.loadedCustomers = res
      } else {
        this.filterDataByRole(data);
      }
    });

  }
  private filterDataByRole(data: Customer[]): void {
    if (this.role === 'admin' || this.role === 'localuser') {
      this.filterDataForAdminAndLocalUser(data);
    } else {
      this.loadedCustomers = data.filter((o) => o.userId === this.userid);
    }
  }
  private filterDataForAdminAndLocalUser(data: Customer[]): void {
    const distributorCompanyName = this.distributorCompanyName;

    if (distributorCompanyName && distributorCompanyName.length) {
      this.filterDataByDistributionCompanyName(data, distributorCompanyName);
    } else if (this.IsKikMember === true) {
      const IsKikMember = this.IsKikMember
      if (IsKikMember !== null) {
        this.filterDataByKikMembers(data, IsKikMember);
      }
    } else {
      this.loadedCustomers = data.filter((o) => o.userId === this.userid);
    }
  }

  /**
   * Filter data by distribution company name
   */
  private filterDataByDistributionCompanyName(
    data: Customer[],
    distributorCompanyName: string
  ): void {
    this.userService
      .getUsersByDistributionCompanyName(distributorCompanyName)
      .subscribe(
        (users) => {
          let filteredUserIds: string[] = this.getFilteredUsersId(users);
          this.loadedCustomers = data.filter((customer) =>
            filteredUserIds.includes(customer.userId)
          );
        },
        (error) => {
          console.error(
            'Error fetching users by distribution company name',
            error
          );
        }
      );
  }

  private filterDataByKikMembers(data: Customer[], IsKikMember: boolean): void {
    this.userService.getKikMembers(IsKikMember).subscribe(
      (kikMembers) => {
        if (this.role === 'admin') {
          this.userService.getDirectCustomers(this.isDirectCustomer).subscribe(
            (directCustomers) => {
              const kikMemberUserIds = this.getFilteredUsersId(kikMembers);
              const directCustomerUserIds = this.getFilteredUsersId(directCustomers);
              let filteredUserIds: string[] = kikMemberUserIds.concat(directCustomerUserIds);
              this.loadedCustomers = data.filter((customer) =>
                filteredUserIds.includes(customer.userId)
              );
            },
            (error) => {
              console.error('Error fetching Direct customers', error);
            }
          );
        } else if (this.role === 'localuser') {
          const kikMemberUserIds = this.getFilteredUsersId(kikMembers);
          this.loadedCustomers = data.filter((customer) =>
            kikMemberUserIds.includes(customer.userId)
          );
        }
      },
      (error) => {
        console.error('Error fetching Kik members', error);
      }
    );
  }


  /**
   * Get filtered usernames based on user role
   */
  private getFilteredUsersId(users: any[]): string[] {
    let filteredUserIds: string[] = [];
    if (users !== null) {
      filteredUserIds = users.map((user) => user.uuid);
    }
    return filteredUserIds;
  }

  private _filterCustomers(value: string): Customer[] {
    const filterValue = value.toLowerCase().trim();
    return this.loadedCustomers.filter((customer) =>
      customer.customername.toLowerCase().includes(filterValue)
    );
  }

  displayFn(customer: Customer): string {
    return customer ? customer.customername : '';
  }
  generateSalePersonCode(fullname: string): string {
    const words = fullname.split(' ');

    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    } else if (words.length >= 2) {
      const initials = words.map(word => word.charAt(0).toUpperCase());
      return initials.join('');
    } else {
      return '';
    }
  }
  displaySelectedCustomer(customerId: string): string {
    const customerNameValue = this.projectForm.get('customerName').value?.toLowerCase();
    const selectedCustomer = this.loadedCustomers.find(
      customer => customer.customername?.toLowerCase() === customerNameValue
    );

    const customerName = selectedCustomer ? selectedCustomer.customername : '';
    return customerName;
  }

  onCustomerSelected(selectedCustomerId: string) {

    this.selectedCustomerId = selectedCustomerId;


    this.getCustomerDetail({ value: selectedCustomerId });
  }
  onCustomerNameInput(inputData: string) {
    if (this.selectedCustomerId) {
    } else {
      this.customerNameInputData = inputData;
    }
  }
  getCustomerDetail(event) {
    //console.log(event.value)
    this.customerService.getCustomerById(event.value).subscribe(
      res => { //


        this.customerData = res;
        // //console.log(this.customerAddres.phone)
        let address = {};
        address['addressLine'] = this.customerData.address.addressLine;
        address['city'] = this.customerData.address.city;
        address['state'] = this.customerData.address.state;
        address['country'] = this.customerData.address.country;
        address['postCode'] = this.customerData.address.postCode;
        address['email'] = this.customerData.address.email;
        address['telephone'] = this.customerData.phone;
        address['mobile'] = this.customerData.fax;

        this.projectForm.get('address').patchValue(address)
        this.projectForm.get('telephone').patchValue(this.customerData.phone)
        this.projectForm.get('mobile').patchValue(this.customerData.fax)
        this.projectForm.get('customerName').patchValue(this.customerData.customername)
        this.cdr.detectChanges();
        //this.projectForm.get('customerId').patchValue(this.customerAddres.uuid)



      },
      err => { console.log(err) }
    )
  }

  fetchTableData() {
    this.electricalService.getTableData().subscribe(
      (data: any[]) => {
        this.tableData = data;
        this.updateOptions();
        this.checkAndFindMatchingRow();
      },
      error => {
        console.error('Error fetching table data:', error);
      }
    );
  }
  fetchTableDataMCCB() {
    this.electricalService.getTableDataMCCB().subscribe(
      (data: any[]) => {
        this.tableDataMCCB = data;
        this.updateOptionsMCCB();
        this.checkAndFindMatchingRowMCCB();
      },
      error => {
        console.error('Error fetching table data:', error);
      }
    );
  }
  updateOptions() {
    this.manufacturerOptions = this.tableData.map(row => row.MANUFACTUR).filter((value, index, self) => self.indexOf(value) === index);
    this.typeOptions = this.tableData.map(row => row.TYPE).filter((value, index, self) => self.indexOf(value) === index);
    this.ratedAmpOptions = this.tableData.map(row => row.RATED_AMP).filter((value, index, self) => self.indexOf(value) === index);
    this.frameSizeOptions = this.tableData.map(row => row.FRAME_SIZE).filter((value, index, self) => self.indexOf(value) === index);
    this.prfLevelOptions = this.tableData.map(row => row.PRF_LEVEL).filter((value, index, self) => self.indexOf(value) === index);
    this.shortCircuitIcuOptions = this.tableData.map(row => row['SHORTCU_(Icu)']).filter((value, index, self) => self.indexOf(value) === index);
  }
  updateOptionsMCCB() {
    this.manufacturerOptionsMCCB = this.tableDataMCCB.map(row => row.MANUFACTUR).filter((value, index, self) => self.indexOf(value) === index);
    this.typeOptionsMCCB = this.tableDataMCCB.map(row => row.TYPE).filter((value, index, self) => self.indexOf(value) === index);
    this.ratedAmpOptionsMCCB = this.tableDataMCCB.map(row => row.RATED_AMP).filter((value, index, self) => self.indexOf(value) === index);
    this.frameSizeOptionsMCCB = this.tableDataMCCB.map(row => row.FRAME_SIZE).filter((value, index, self) => self.indexOf(value) === index);
    this.prfLevelOptionsMCCB = this.tableDataMCCB.map(row => row.PRF_LEVEL).filter((value, index, self) => self.indexOf(value) === index);
    this.shortCircuitIcuOptionsMCCB = this.tableDataMCCB.map(row => row['SHORTCU_(Icu)']).filter((value, index, self) => self.indexOf(value) === index);
    this.tripUnitOptionsMCCB = this.tableDataMCCB.map(row => row.TRIP_UNIT).filter((value, index, self) => self.indexOf(value) === index);
    this.orderNumberOptionsMCCB = this.tableDataMCCB.map(row => row.Order_number).filter((value, index, self) => self.indexOf(value) === index);
  }
  updateDropdownOptions() {
    let baseFilter = this.tableData;

    if (this.selectedManufacturer) {
      baseFilter = baseFilter.filter(row => row.MANUFACTUR === this.selectedManufacturer);
    }

    if (this.selectedType) {
      baseFilter = baseFilter.filter(row => row.TYPE === this.selectedType);
    }

    this.ratedAmpOptions = baseFilter
      .map(row => row.RATED_AMP)
      .filter((value, index, self) => self.indexOf(value) === index)
      .sort((a, b) => a - b);

    if (this.selectedRatedAmp) {
      baseFilter = baseFilter.filter(row => row.RATED_AMP === this.selectedRatedAmp);
    }

    this.frameSizeOptions = baseFilter.map(row => row.FRAME_SIZE).filter((value, index, self) => self.indexOf(value) === index);

    if (this.selectedFrameSize) {
      baseFilter = baseFilter.filter(row => row.FRAME_SIZE === this.selectedFrameSize);
    }

    this.prfLevelOptions = baseFilter.map(row => row.PRF_LEVEL).filter((value, index, self) => self.indexOf(value) === index);

    if (this.selectedPRFLevel) {
      baseFilter = baseFilter.filter(row => row.PRF_LEVEL === this.selectedPRFLevel);
    }

    this.shortCircuitIcuOptions = baseFilter.map(row => row['SHORTCU_(Icu)']).filter((value, index, self) => self.indexOf(value) === index);
    // Convert selectedRatedAmp to a number
    const selectedRatedAmpNum = this.selectedRatedAmp !== null ? Number(this.selectedRatedAmp) : NaN;

    const mainHorizontalAmpereValues = this.busBarData.mainHorizontal.map(item => Number(item.ampere));
    const dropperAmpereValues = this.busBarData.dropper.map(item => Number(item.ampere));

    const isInMainHorizontal = !isNaN(selectedRatedAmpNum) && mainHorizontalAmpereValues.includes(selectedRatedAmpNum);
    const isInDropper = !isNaN(selectedRatedAmpNum) && dropperAmpereValues.includes(selectedRatedAmpNum);

    let options: string[];
    if (isInMainHorizontal && isInDropper) {
      options = ["Busbar Support - Flat", "Busbar Support With Grooves"];
    } else if (isInMainHorizontal && !isInDropper) {
      options = ["Busbar Support - Flat"];
    } else {
      options = []; // or any other default value
    }

    this.busbarTypeOptions = options;
  }

  updateDropdownOptionsMCCB() {
    let baseFilter = this.tableDataMCCB;

    if (this.selectedManufacturerMCCB) {
      baseFilter = baseFilter.filter(row => row.MANUFACTUR === this.selectedManufacturerMCCB);
    }

    this.ratedAmpOptionsMCCB = baseFilter
      .map(row => row.RATED_AMP)
      .filter((value, index, self) => self.indexOf(value) === index)
      .sort((a, b) => a - b);

    if (this.selectedRatedAmpMCCB) {
      baseFilter = baseFilter.filter(row => row.RATED_AMP === this.selectedRatedAmpMCCB);
    }

    this.typeOptionsMCCB = baseFilter.map(row => row.TYPE).filter((value, index, self) => self.indexOf(value) === index);

    if (this.selectedTypeMCCB) {
      baseFilter = baseFilter.filter(row => row.TYPE === this.selectedTypeMCCB);
    }

    this.frameSizeOptionsMCCB = baseFilter.map(row => row.FRAME_SIZE).filter((value, index, self) => self.indexOf(value) === index);

    if (this.selectedFrameSizeMCCB) {
      baseFilter = baseFilter.filter(row => row.FRAME_SIZE === this.selectedFrameSizeMCCB);
    }

    this.prfLevelOptionsMCCB = baseFilter.map(row => row.PRF_LEVEL).filter((value, index, self) => self.indexOf(value) === index);

    if (this.selectedPRFLevelMCCB) {
      baseFilter = baseFilter.filter(row => row.PRF_LEVEL === this.selectedPRFLevelMCCB);
    }

    this.shortCircuitIcuOptionsMCCB = baseFilter.map(row => row.SHORTCU_CU).filter((value, index, self) => self.indexOf(value) === index);

    if (this.selectedShortCircuitIcuMCCB) {
      baseFilter = baseFilter.filter(row => row.SHORTCU_CU === this.selectedShortCircuitIcuMCCB);
    }

    this.tripUnitOptionsMCCB = baseFilter.map(row => row.TRIP_UNIT).filter((value, index, self) => self.indexOf(value) === index);

    if (this.selectedTripUnitMCCB) {
      baseFilter = baseFilter.filter(row => row.TRIP_UNIT === this.selectedTripUnitMCCB);
    }

    this.orderNumberOptionsMCCB = baseFilter.map(row => row.Order_number).filter((value, index, self) => self.indexOf(value) === index);
  }

  cancel() {
    this.dialogRef.close();
  }

  checkAndFindMatchingRow() {
    if (this.selectedManufacturer && this.selectedRatedAmp && this.selectedType && this.selectedFrameSize && this.selectedPRFLevel && this.selectedShortCircuitIcu && this.selectedBusbarType) {

      // Find the row based on the available properties
      let baseMatchingRow = this.tableData.find(row =>
        row.MANUFACTUR === this.selectedManufacturer &&
        row.RATED_AMP === this.selectedRatedAmp &&
        row.TYPE === this.selectedType &&
        row.FRAME_SIZE === this.selectedFrameSize &&
        row.PRF_LEVEL === this.selectedPRFLevel &&
        row['SHORTCU_(Icu)'] === this.selectedShortCircuitIcu
      );

      // If a base matching row is found, add busbarTypeOptions
      if (baseMatchingRow) {
        this.matchingRow = {
          ...baseMatchingRow,
          busbarTypeOptions: this.selectedBusbarType
        };
        this.setImagePath();
        this.matchingRow['ImagePath'] = this.imagePath;
        console.log('Matching row found:', this.matchingRow);
      } else {
        console.error('No matching row found.');
      }
    } else {
      console.error('Please select all options before finding the matching row.');
    }
  }

  checkAndFindMatchingRowMCCB() {
    if (this.selectedManufacturerMCCB && this.selectedRatedAmpMCCB && this.selectedTypeMCCB && this.selectedFrameSizeMCCB && this.selectedPRFLevelMCCB && this.selectedShortCircuitIcuMCCB && this.selectedTripUnitMCCB && this.selectedRotation && this.selectedOrderNumberMCCB) {
      this.matchingRowMCCB = this.tableDataMCCB.find(row =>
        row.MANUFACTUR === this.selectedManufacturerMCCB &&
        row.RATED_AMP === this.selectedRatedAmpMCCB &&
        row.TYPE === this.selectedTypeMCCB &&
        row.FRAME_SIZE === this.selectedFrameSizeMCCB &&
        row.PRF_LEVEL === this.selectedPRFLevelMCCB &&
        row.SHORTCU_CU === this.selectedShortCircuitIcuMCCB &&
        row.TRIP_UNIT === this.selectedTripUnitMCCB &&
        row.Order_number === this.selectedOrderNumberMCCB
      );
      this.setImagePathMCCB();
      if (this.matchingRowMCCB) {
        this.matchingRowMCCB['ROTATION'] = this.selectedRotation;
        this.matchingRowMCCB['ImagePath'] = this.imagePathMCCB;
        this.matchingRowMCCB = {
          ...this.matchingRowMCCB,
          busbarTypeOptions: this.selectedBusbarType
        };

      } else {
        console.error('No matching row found.');
      }
      console.log("this.matchingRowMCCB", this.matchingRowMCCB);
    } else {
      console.error('Please select all options before finding the matching row.');
    }
  }

  setImagePath() {
    // Your image switch logic goes here
    switch (true) {
      case this.matchingRow.TYPE === '3P-F' && this.matchingRow.MANUFACTUR === 'Schneider Electric' && this.matchingRow.FRAME_SIZE.startsWith('MTZ1'):
        this.imagePath = 'assets/media/diagram/MTZ SVG/MTZ1 SVG/MTZ1-3P-F.svg';
        break;
      case this.matchingRow.TYPE === '3P-W' && this.matchingRow.MANUFACTUR === 'Schneider Electric' && this.matchingRow.FRAME_SIZE.startsWith('MTZ1'):
        this.imagePath = 'assets/media/diagram/MTZ SVG/MTZ1 SVG/MTZ1-3P-W.svg';
        break;
      case this.matchingRow.TYPE === '4P-F' && this.matchingRow.MANUFACTUR === 'Schneider Electric' && this.matchingRow.FRAME_SIZE.startsWith('MTZ1'):
        this.imagePath = 'assets/media/diagram/MTZ SVG/MTZ1 SVG/MTZ1-4P-F.svg';
        break;
      case this.matchingRow.TYPE === '4P-W' && this.matchingRow.MANUFACTUR === 'Schneider Electric' && this.matchingRow.FRAME_SIZE.startsWith('MTZ1'):
        this.imagePath = 'assets/media/diagram/MTZ SVG/MTZ1 SVG/MTZ1-4P-W.svg';
        break;
      case this.matchingRow.TYPE === '3P-F' && this.matchingRow.MANUFACTUR === 'Schneider Electric' && this.matchingRow.FRAME_SIZE.startsWith('MTZ2'):
        this.imagePath = 'assets/media/diagram/MTZ SVG/MTZ 2 SVG/MTZ2-3P-F.svg';
        break;
      case this.matchingRow.TYPE === '3P-W' && this.matchingRow.MANUFACTUR === 'Schneider Electric' && this.matchingRow.FRAME_SIZE.startsWith('MTZ2'):
        this.imagePath = 'assets/media/diagram/MTZ SVG/MTZ 2 SVG/MTZ2-3P-W.svg';
        break;
      case this.matchingRow.TYPE === '4P-F' && this.matchingRow.MANUFACTUR === 'Schneider Electric' && this.matchingRow.FRAME_SIZE.startsWith('MTZ2'):
        this.imagePath = 'assets/media/diagram/MTZ SVG/MTZ 2 SVG/MTZ2-4P-F.svg';
        break;
      case this.matchingRow.TYPE === '4P-W' && this.matchingRow.MANUFACTUR === 'Schneider Electric' && this.matchingRow.FRAME_SIZE.startsWith('MTZ2'):
        this.imagePath = 'assets/media/diagram/MTZ SVG/MTZ 2 SVG/MTZ2-4P-W.svg';
        break;
      case this.matchingRow.TYPE === '3P-F' && this.matchingRow.MANUFACTUR === 'Schneider Electric' && this.matchingRow.FRAME_SIZE.startsWith('MTZ3'):
        this.imagePath = 'assets/media/diagram/MTZ SVG/MTZ3 SVG/MTZ3-3P-F.svg';
        break;
      case this.matchingRow.TYPE === '3P-W' && this.matchingRow.MANUFACTUR === 'Schneider Electric' && this.matchingRow.FRAME_SIZE.startsWith('MTZ3'):
        this.imagePath = 'assets/media/diagram/MTZ SVG/MTZ3 SVG/MTZ3-3P-W.svg';
        break;
      case this.matchingRow.TYPE === '4P-F' && this.matchingRow.MANUFACTUR === 'Schneider Electric' && this.matchingRow.FRAME_SIZE.startsWith('MTZ3'):
        this.imagePath = 'assets/media/diagram/MTZ SVG/MTZ3 SVG/MTZ3-4P-F.svg';
        break;
      case this.matchingRow.TYPE === '4P-W' && this.matchingRow.MANUFACTUR === 'Schneider Electric' && this.matchingRow.FRAME_SIZE.startsWith('MTZ3'):
        this.imagePath = 'assets/media/diagram/MTZ SVG/MTZ3 SVG/MTZ3-4P-W.svg';
        break;
      case this.matchingRow.TYPE === '3P-F' && this.matchingRow.MANUFACTUR === 'ABB' && this.matchingRow.FRAME_SIZE === 'E1.2':
        this.imagePath = 'assets/media/diagram/Abb ACB E/E1.2/E1.2-F-3P.svg';
        break;
      case this.matchingRow.TYPE === '3P-W' && this.matchingRow.MANUFACTUR === 'ABB' && this.matchingRow.FRAME_SIZE === 'E1.2':
        this.imagePath = 'assets/media/diagram/Abb ACB E/E1.2/E1.2-W-3P.svg';
        break;
      case this.matchingRow.TYPE === '4P-F' && this.matchingRow.MANUFACTUR === 'ABB' && this.matchingRow.FRAME_SIZE === 'E1.2':
        this.imagePath = 'assets/media/diagram/Abb ACB E/E1.2/E1.2-F-4P.svg';
        break;
      case this.matchingRow.TYPE === '4P-W' && this.matchingRow.MANUFACTUR === 'ABB' && this.matchingRow.FRAME_SIZE === 'E1.2':
        this.imagePath = 'assets/media/diagram/Abb ACB E/E1.2/E1.2-W-4P.svg';
        break;
      case this.matchingRow.TYPE === '3P-F' && this.matchingRow.MANUFACTUR === 'ABB' && this.matchingRow.FRAME_SIZE === 'E2.2':
        this.imagePath = 'assets/media/diagram/Abb ACB E/E2.2/E2.2-F-3P.svg';
        break;
      case this.matchingRow.TYPE === '3P-W' && this.matchingRow.MANUFACTUR === 'ABB' && this.matchingRow.FRAME_SIZE === 'E2.2':
        this.imagePath = 'assets/media/diagram/Abb ACB E/E2.2/E2.2-W-3P.svg';
        break;
      case this.matchingRow.TYPE === '4P-F' && this.matchingRow.MANUFACTUR === 'ABB' && this.matchingRow.FRAME_SIZE === 'E2.2':
        this.imagePath = 'assets/media/diagram/Abb ACB E/E2.2/E2.2-F-4P.svg';
        break;
      case this.matchingRow.TYPE === '4P-W' && this.matchingRow.MANUFACTUR === 'ABB' && this.matchingRow.FRAME_SIZE === 'E2.2':
        this.imagePath = 'assets/media/diagram/Abb ACB E/E2.2/E2.2-W-4P.svg';
        break;
      case this.matchingRow.TYPE === '3P-F' && this.matchingRow.MANUFACTUR === 'ABB' && this.matchingRow.FRAME_SIZE === 'E4.2':
        this.imagePath = 'assets/media/diagram/Abb ACB E/E4.2/E4.2-F-3p.svg';
        break;
      case this.matchingRow.TYPE === '3P-W' && this.matchingRow.MANUFACTUR === 'ABB' && this.matchingRow.FRAME_SIZE === 'E4.2':
        this.imagePath = 'assets/media/diagram/Abb ACB E/E4.2/E4.2-W-3p.svg';
        break;
      case this.matchingRow.TYPE === '4P-F' && this.matchingRow.MANUFACTUR === 'ABB' && this.matchingRow.FRAME_SIZE === 'E4.2':
        this.imagePath = 'assets/media/diagram/Abb ACB E/E4.2/E4.2-F-4p.svg';
        break;
      case this.matchingRow.TYPE === '4P-W' && this.matchingRow.MANUFACTUR === 'ABB' && this.matchingRow.FRAME_SIZE === 'E4.2':
        this.imagePath = 'assets/media/diagram/Abb ACB E/E4.2/E4.2-W-4p.svg';
        break;
      case this.matchingRow.TYPE === '3P-F' && this.matchingRow.MANUFACTUR === 'ABB' && this.matchingRow.FRAME_SIZE === 'E6.2':
        this.imagePath = 'assets/media/diagram/Abb ACB E/E6.2/E6.2-F-3P.svg';
        break;
      case this.matchingRow.TYPE === '3P-W' && this.matchingRow.MANUFACTUR === 'ABB' && this.matchingRow.FRAME_SIZE === 'E6.2':
        this.imagePath = 'assets/media/diagram/Abb ACB E/E6.2/E6.2-W-3P.svg';
        break;
      case this.matchingRow.TYPE === '4P-F' && this.matchingRow.MANUFACTUR === 'ABB' && this.matchingRow.FRAME_SIZE === 'E6.2':
        this.imagePath = 'assets/media/diagram/Abb ACB E/E6.2/E6.2-F-4P.svg';
        break;
      case this.matchingRow.TYPE === '4P-W' && this.matchingRow.MANUFACTUR === 'ABB' && this.matchingRow.FRAME_SIZE === 'E6.2':
        this.imagePath = 'assets/media/diagram/Abb ACB E/E6.2/E6.2-W-4P.svg';
        break;
      default:
        // Handle default case or set a default image path
        this.imagePath = 'assets/media/diagram/MTZ1-3P-W.svg';
        break;
    }
  }
  setImagePathMCCB() {
    // Your image switch logic goes here
    switch (true) {
      case this.matchingRowMCCB.TYPE === '1P' && this.matchingRowMCCB.MANUFACTUR === 'Schneider Electric' && (this.matchingRowMCCB.FRAME_SIZE === 'NSX 100' || this.matchingRowMCCB.FRAME_SIZE === 'NSX 160'):
        this.imagePathMCCB = 'assets/media/diagram/NSX/NSX 100-160 1P.svg';
        break;
      case this.matchingRowMCCB.TYPE === '2P' && this.matchingRowMCCB.MANUFACTUR === 'Schneider Electric' && (this.matchingRowMCCB.FRAME_SIZE === 'NSX 100' || this.matchingRowMCCB.FRAME_SIZE === 'NSX 160'):
        this.imagePathMCCB = 'assets/media/diagram/NSX/NSX 100-160 2P.svg';
        break;
      case this.matchingRowMCCB.TYPE === '3P' && this.matchingRowMCCB.MANUFACTUR === 'Schneider Electric' && (this.matchingRowMCCB.FRAME_SIZE === 'NSX 100' || this.matchingRowMCCB.FRAME_SIZE === 'NSX 160' || this.matchingRowMCCB.FRAME_SIZE === 'NSX 250'):
        this.imagePathMCCB = 'assets/media/diagram/NSX/NSX 100-160-250 3P.svg';
        break;
      case this.matchingRowMCCB.TYPE === '3P' && this.matchingRowMCCB.MANUFACTUR === 'Schneider Electric' && (this.matchingRowMCCB.FRAME_SIZE === 'NSX 400' || this.matchingRowMCCB.FRAME_SIZE === 'NSX 630'):
        this.imagePathMCCB = 'assets/media/diagram/NSX/NSX 400 - 630 3P.svg';
        break;
      case this.matchingRowMCCB.TYPE === '4P' && this.matchingRowMCCB.MANUFACTUR === 'Schneider Electric' && (this.matchingRowMCCB.FRAME_SIZE === 'NSX 100' || this.matchingRowMCCB.FRAME_SIZE === 'NSX 160' || this.matchingRowMCCB.FRAME_SIZE === 'NSX 250'):
        this.imagePathMCCB = 'assets/media/diagram/NSX/NSX 100-160-250 4P.svg';
        break;
      case this.matchingRowMCCB.TYPE === '4P' && this.matchingRowMCCB.MANUFACTUR === 'Schneider Electric' && (this.matchingRowMCCB.FRAME_SIZE === 'NSX 400' || this.matchingRowMCCB.FRAME_SIZE === 'NSX 630'):
        this.imagePathMCCB = 'assets/media/diagram/NSX/NSX 400-630 4P.svg';
        break;
      case this.matchingRowMCCB.TYPE === '3P' && this.matchingRowMCCB.MANUFACTUR === 'Schneider Electric' && (this.matchingRowMCCB.FRAME_SIZE === 'NS630b' || this.matchingRowMCCB.FRAME_SIZE === 'NS800' || this.matchingRowMCCB.FRAME_SIZE === 'NS1000' || this.matchingRowMCCB.FRAME_SIZE === 'NS1250' || this.matchingRowMCCB.FRAME_SIZE === 'NS1600') && (this.matchingRowMCCB.TRIP_UNIT === 'Fixed-MOD' || this.matchingRowMCCB.TRIP_UNIT === 'Fixed-EOD'):
        this.imagePathMCCB = 'assets/media/diagram/NS/NS 630b to 1600 3P fixed.svg';
        break;
      case this.matchingRowMCCB.TYPE === '4P' && this.matchingRowMCCB.MANUFACTUR === 'Schneider Electric' && (this.matchingRowMCCB.FRAME_SIZE === 'NS630b' || this.matchingRowMCCB.FRAME_SIZE === 'NS800' || this.matchingRowMCCB.FRAME_SIZE === 'NS1000' || this.matchingRow.FRAME_SIZE === 'NS1250' || this.matchingRowMCCB.FRAME_SIZE === 'NS1600') && (this.matchingRowMCCB.TRIP_UNIT === 'Fixed-MOD' || this.matchingRowMCCB.TRIP_UNIT === 'Fixed-EOD'):
        this.imagePathMCCB = 'assets/media/diagram/NS/NS 630b to 1600 4P fixed.svg';
        break;
      case this.matchingRowMCCB.TYPE === '3P' && this.matchingRowMCCB.MANUFACTUR === 'Schneider Electric' && (this.matchingRowMCCB.FRAME_SIZE === 'NS630b' || this.matchingRowMCCB.FRAME_SIZE === 'NS800' || this.matchingRowMCCB.FRAME_SIZE === 'NS1000' || this.matchingRowMCCB.FRAME_SIZE === 'NS1250' || this.matchingRow.FRAME_SIZE === 'NS1600') && (this.matchingRowMCCB.TRIP_UNIT === 'WD-EOD' || this.matchingRowMCCB.TRIP_UNIT === 'WD-MOD'):
        this.imagePathMCCB = 'assets/media/diagram/NS/NS 630b to 1600 3P WD.svg';
        break;
      case this.matchingRowMCCB.TYPE === '4P' && this.matchingRowMCCB.MANUFACTUR === 'Schneider Electric' && (this.matchingRowMCCB.FRAME_SIZE === 'NS630b' || this.matchingRowMCCB.FRAME_SIZE === 'NS800' || this.matchingRowMCCB.FRAME_SIZE === 'NS1000' || this.matchingRow.FRAME_SIZE === 'NS1250' || this.matchingRowMCCB.FRAME_SIZE === 'NS1600') && (this.matchingRowMCCB.TRIP_UNIT === 'WD-EOD' || this.matchingRowMCCB.TRIP_UNIT === 'WD-MOD'):
        this.imagePathMCCB = 'assets/media/diagram/NS/NS 630b to 1600 4P WD.svg';
        break;
      case this.matchingRowMCCB.TYPE === '3P' && this.matchingRowMCCB.MANUFACTUR === 'Schneider Electric' && (this.matchingRowMCCB.FRAME_SIZE === 'NS16000b' || this.matchingRowMCCB.FRAME_SIZE === 'NS2000' || this.matchingRowMCCB.FRAME_SIZE === 'NS2500' || this.matchingRow.FRAME_SIZE === 'NS3200') && (this.matchingRowMCCB.TRIP_UNIT === 'Fixed'):
        this.imagePathMCCB = 'assets/media/diagram/NS/NS 1600b to 3200 3P fixed.svg';
        break;
      case this.matchingRowMCCB.TYPE === '4P' && this.matchingRowMCCB.MANUFACTUR === 'Schneider Electric' && (this.matchingRowMCCB.FRAME_SIZE === 'NS16000b' || this.matchingRowMCCB.FRAME_SIZE === 'NS2000' || this.matchingRowMCCB.FRAME_SIZE === 'NS2500' || this.matchingRowMCCB.FRAME_SIZE === 'NS3200') && (this.matchingRowMCCB.TRIP_UNIT === 'Fixed'):
        this.imagePathMCCB = 'assets/media/diagram/NS/NS 1600b to 3200 4P fixed.svg';
        break;
      case this.matchingRowMCCB.TYPE === '3P' &&
        this.matchingRowMCCB.MANUFACTUR === 'Schneider Electric' &&
        (this.matchingRowMCCB.FRAME_SIZE === 'NS630b' || this.matchingRowMCCB.FRAME_SIZE === 'NS800' ||
          this.matchingRowMCCB.FRAME_SIZE === 'NS1000' || this.matchingRowMCCB.FRAME_SIZE === 'NS1250' ||
          this.matchingRowMCCB.FRAME_SIZE === 'NS1600') &&
        !(this.matchingRowMCCB.TRIP_UNIT === 'Fixed-MOD' || this.matchingRowMCCB.TRIP_UNIT === 'Fixed-EOD' ||
          this.matchingRowMCCB.TRIP_UNIT === 'WD-EOD' || this.matchingRowMCCB.TRIP_UNIT === 'WD-MOD'):
        this.imagePathMCCB = 'assets/media/diagram/NS/NS 630b to 1600 3P .svg';
        break;
      case this.matchingRowMCCB.TYPE === '4P' &&
        this.matchingRowMCCB.MANUFACTUR === 'Schneider Electric' &&
        (this.matchingRowMCCB.FRAME_SIZE === 'NS630b' || this.matchingRowMCCB.FRAME_SIZE === 'NS800' ||
          this.matchingRowMCCB.FRAME_SIZE === 'NS1000' || this.matchingRowMCCB.FRAME_SIZE === 'NS1250' ||
          this.matchingRowMCCB.FRAME_SIZE === 'NS1600') &&
        !(this.matchingRowMCCB.TRIP_UNIT === 'Fixed-MOD' || this.matchingRowMCCB.TRIP_UNIT === 'Fixed-EOD' ||
          this.matchingRowMCCB.TRIP_UNIT === 'WD-EOD' || this.matchingRowMCCB.TRIP_UNIT === 'WD-MOD'):
        this.imagePathMCCB = 'assets/media/diagram/NS/NS 630b to 1600 4P.svg';
        break;

      default:
        // Handle default case or set a default image path
        this.imagePathMCCB = 'assets/media/diagram/MCCB.svg';
        break;
    }
  }

  next() {
    const nodesWithACB = this.nodeDataArray.filter(node => node.text === "ACB" || node.text === "MCCB");
    let PreviousMaxbusBarChamberSizeHeight = 0;
    let busbarData;
    const isMCCB = Boolean(this.matchingRowMCCB); // Determine if it's MCCB or ACB
    if (nodesWithACB.length > 0) {
      console.log("nodesWithACB", nodesWithACB);

      const maxRatedAmp = Math.max(
        ...nodesWithACB.map(node => Number(node.properties.RATED_AMP) || 0)
      );
      console.log("maxRatedAmp", maxRatedAmp);
      console.log("this.selectedBusbarType", this.selectedBusbarType);
      const currentRatedAmp = parseInt(this.selectedRatedAmp || "0");
      const AmpereRate = Math.max(maxRatedAmp, currentRatedAmp);

      if (this.selectedBusbarType === 'Busbar Support - Flat') {
        busbarData = this.busBarData.mainHorizontal.find(busbar => busbar.ampere === AmpereRate);
      } else if (this.selectedBusbarType === 'Busbar Support With Grooves') {
        busbarData = this.busBarData.dropper.find(busbar => busbar.ampere === AmpereRate);
      } else {
        console.error('Invalid busbar type selected');
        return;
      }
      console.log("busbarData", busbarData);
      console.log('this.nodeDataArray', this.nodeDataArray)
      const nodesWithVerticalBusbar = this.nodeDataArray.filter(node => node.text === "Vertical Busbar");
      console.log('nodesWithVerticalBusbar', nodesWithVerticalBusbar)
      if (nodesWithVerticalBusbar) {
        nodesWithVerticalBusbar.forEach(node => {
          node.properties.busbarSize.amp = `${busbarData.ampere}A`;
          node.properties.busbarSize.des = busbarData.des;
          node.properties.busbarSize.orderCode = busbarData.orderCode;
          node.properties.busbarSize.img = busbarData.img;
        });
      }


      const nodesWithHorizontalBusbar = this.nodeDataArray.filter(node => node.category === "busbary");
      console.log("nodesWithHorizontalBusbar", nodesWithHorizontalBusbar);
      if (nodesWithHorizontalBusbar) {
        nodesWithHorizontalBusbar.forEach(node => {
          node.properties.busbarSize.amp = `${busbarData.ampere}A`;
          node.properties.busbarSize.des = busbarData.des;
          node.properties.busbarSize.orderCode = busbarData.orderCode;
          node.properties.busbarSize.img = busbarData.img;
        });
      }

      const maxAmpNode = nodesWithACB.find(node =>
        Number(node.properties.RATED_AMP) === maxRatedAmp
      );
      console.log("maxAmpNode", maxAmpNode);
      console.log("maxAmpNode?.properties", maxAmpNode?.properties);
      PreviousMaxbusBarChamberSizeHeight = this.getBusBarChamberSizeHeight(maxAmpNode?.properties);
      console.log("PreviousMaxbusBarChamberSizeHeight", PreviousMaxbusBarChamberSizeHeight);
    } else {
      const AmpereRate = parseInt(this.selectedRatedAmp || this.selectedRatedAmpMCCB || "0");
      console.log('AmpereRate', AmpereRate)
      if (this.selectedBusbarType === 'Busbar Support - Flat') {
        busbarData = this.busBarData.mainHorizontal.find(busbar => busbar.ampere === AmpereRate);
      } else if (this.selectedBusbarType === 'Busbar Support With Grooves') {
        busbarData = this.busBarData.dropper.find(busbar => busbar.ampere === AmpereRate);
      } else {
        console.error('Invalid busbar type selected');
        return;
      }
    }
    const selectedCable = this.cableSizeData.find(cable => cable.size === this.selectedCableSize);
    let minHeight = 0;
    if (selectedCable) {
      minHeight = this.selectedMinHeightApplication === '1C Applications' ? selectedCable.minHeight1C : selectedCable.minHeight4C;
    }
    console.log(`Selected Cable Size: ${this.selectedCableSize}`);
    console.log(`Selected Application: ${this.selectedMinHeightApplication}`);
    console.log(`Minimum Height: ${minHeight}`);
    if (this.currentIncomerPage === 1) {
      console.log('this.matchingRowMCCB:', this.matchingRowMCCB);

      const pictureWidth = Math.round(
        (this.matchingRow?.WIDTH || this.matchingRowMCCB?.WIDTH) / 50
      ) * 50;

      const pictureHeight = Math.round(
        (this.matchingRow?.HEIGHT || this.matchingRowMCCB?.HEIGHT) / 50
      ) * 50;

      console.log('Picture Width:', pictureWidth);
      console.log('Picture Height:', pictureHeight);

      const ratedAmp = parseInt(this.selectedRatedAmp || this.selectedRatedAmpMCCB || "0"); // Provide a default value if null
      let higherAmpRow;

      // Find the row with the nearest higher ampere value
      for (let i = 0; i < this.CubiclesSizes.length; i++) {
        const row = this.CubiclesSizes[i];
        if (row.ampere >= ratedAmp) {
          higherAmpRow = row;
          break;
        }
      }
      console.log('Higher Amp Row:', higherAmpRow);
      if (higherAmpRow) {
        // Set the width and height based on the matching row
        if (this.matchingRow) {
          this.matchingRow['cubicleWidth'] = higherAmpRow.width;
          this.matchingRow['cubicleHeight'] = higherAmpRow.height;
        }

        // Check if this.matchingRowMCCB exists and assign width and height
        if (this.matchingRowMCCB) {
          this.matchingRowMCCB['cubicleWidth'] = higherAmpRow.width;
          this.matchingRowMCCB['cubicleHeight'] = higherAmpRow.height;
        }

        const shapeWidth = higherAmpRow.width;
        const shapeHeight = higherAmpRow.height;

        const selectedMaxTierHeight = this.selectedMaxTierHeight ?? 0;
        console.log("selectedMaxTierHeight", selectedMaxTierHeight);
        const BaseFrameRow = {
          "uuid": this.uniqueKey(),
          "text": "Base Frame",
          "color": "#bdae91",
          "isGroup": true,
          "size": `${shapeWidth} ${selectedMaxTierHeight}`,
          "type": "rectangle",
          "category": "outerProfile",
          "tool": "main",
          "selectedOption": null,
          "pos": "-1000 -1100",
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Base_Frame.svg",
          "loc": "-950 -1050"
        };


        const busBarChamberSizeHeight = this.getBusBarChamberSizeHeight(this.matchingRow || this.matchingRowMCCB);
        if (shapeWidth < 1000) {
          const BusBarChamber = {
            "uuid": "254134ba1dad",
            "text": "Busbar Chamber",
            "color": "#bdae91",
            "size": `${shapeWidth} ${busBarChamberSizeHeight}`,
            "type": "rectangle",
            "category": "busbarChamber",
            "top": false, "side": false,
            "innerProfile": false,
            "tool": "main",
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
            "pos": "-1000 -1100",
            'group': this.uniqueKey()
          }

          // Calculate the remaining height for ControlSection
          const remainingHeight = selectedMaxTierHeight - (shapeHeight + minHeight + parseInt(BusBarChamber.size.split(' ')[1]));
          if (remainingHeight < 200) {
            this.toastr.error('This Tier Height is not enough. Please increase the size.', 'Error');
            return;
          }
          console.log('remainingHeight1', remainingHeight)
          const ControlSection = {
            "uuid": "4279ceba1dad",
            "text": "CONTROL SEC",
            "color": "#bdae91",
            "size": `${shapeWidth} ${remainingHeight}`,
            "type": "square",
            "category": "door",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
            "pos": `-1000 ${parseInt(BusBarChamber.pos.split(' ')[1]) + busBarChamberSizeHeight}`,
            'group': this.uniqueKey()
          }

          const AcbRow = {
            'uuid': 'f6a7c8b3e2d1',
            'text': isMCCB ? 'MCCB' : 'ACB', // Dynamically set text
            'color': '#bdae91',
            'size': `${shapeWidth} ${shapeHeight}`, // Update size
            'tool': 'main',
            'type': 'rectangle',
            'category': isMCCB ? 'electricalMCCB' : 'electricalACB',
            'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
            'pos': `-1000 ${parseInt(ControlSection.pos.split(' ')[1]) + remainingHeight}`,
            'group': this.uniqueKey(),
            'properties': isMCCB ? { ...this.matchingRowMCCB } : { ...this.matchingRow }, // Dynamically set properties
            ...(!isMCCB && {
              'railProperties': { des: "50x25x300", orderCode: "AMR052503AEKC" },
            }), // Conditionally add railProperties
            "ports": [{}],
            'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
            'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
            'innerProfile': false
          }
          AcbRow.properties.imagePath = AcbRow.properties.ImagePath;
          const CablingSection = {
            "uuid": "2541ceba1dad",
            "text": "Cover",
            "color": "#bdae91",
            "size": `${shapeWidth} ${minHeight}`,
            "type": "rectangle",
            "category": "cover",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cover.svg",
            "pos": `-1000 ${parseInt(AcbRow.pos.split(' ')[1]) + shapeHeight}`,
            'group': this.uniqueKey()
          };
          this.nodeDataArray.push(AcbRow);
          this.nodeDataArray.push(BusBarChamber);
          this.nodeDataArray.push(ControlSection);
          this.nodeDataArray.push(CablingSection);

        } else {
          const BusBarChamber = {
            "uuid": "254134ba1dad",
            "text": "Busbar Chamber",
            "color": "#bdae91",
            "size": `${shapeWidth} ${busBarChamberSizeHeight}`,
            "type": "rectangle",
            "category": "busbarChamber",
            "top": false, "side": false,
            "innerProfile": false,
            "tool": "main",
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
            "pos": "-1000 -1100",
            'group': this.uniqueKey()
          }

          // Calculate the remaining height for ControlSection
          const remainingHeight = selectedMaxTierHeight - (shapeHeight + minHeight + parseInt(BusBarChamber.size.split(' ')[1]));
          if (remainingHeight < 200) {
            this.toastr.error('This Tier Height is not enough. Please increase the size.', 'Error');
            return;
          }
          console.log('remainingHeight2', remainingHeight)
          const ControlSection = {
            "uuid": "2541ceba1dad",
            "text": "CONTROL SEC",
            "color": "#bdae91",
            "size": `${shapeWidth} ${remainingHeight}`,
            "type": "rectangle",
            "category": "cover",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cover.svg",
            "pos": `-1000 ${parseInt(BusBarChamber.pos.split(' ')[1]) + busBarChamberSizeHeight}`,
            'group': this.uniqueKey()
          }

          const AcbRow = {
            'uuid': 'f6a7c8b3e2d1',
            'text': isMCCB ? 'MCCB' : 'ACB', // Dynamically set text
            'color': '#bdae91',
            'size': `${shapeWidth} ${shapeHeight}`, // Update size
            'tool': 'main',
            'type': 'rectangle',
            'category': isMCCB ? 'electricalMCCB' : 'electricalACB',
            'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
            'pos': `-1000 ${parseInt(ControlSection.pos.split(' ')[1]) + remainingHeight}`,
            'group': this.uniqueKey(),
            'properties': isMCCB ? { ...this.matchingRowMCCB } : { ...this.matchingRow }, // Dynamically set properties
            ...(!isMCCB && {
              'railProperties': { des: "50x25x300", orderCode: "AMR052503AEKC" },
            }), // Conditionally add railProperties
            "ports": [{}],
            'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
            'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
            'innerProfile': false
          }
          AcbRow.properties.imagePath = AcbRow.properties.ImagePath;
          const CablingSection = {
            "uuid": "2541ceba1dad",
            "text": "Cover",
            "color": "#bdae91",
            "size": `${shapeWidth} ${minHeight}`,
            "type": "rectangle",
            "category": "cover",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cover.svg",
            "pos": `-1000 ${parseInt(AcbRow.pos.split(' ')[1]) + shapeHeight}`,
            'group': this.uniqueKey()
          };
          this.nodeDataArray.push(AcbRow);
          this.nodeDataArray.push(BusBarChamber);
          this.nodeDataArray.push(ControlSection);
          this.nodeDataArray.push(CablingSection);
        }
        console.log('busbarData', busbarData)
        const verticalBusBar = {
          "uuid": "9974ceba1dad",
          "text": "Vertical Busbar",
          "color": "#bdae91",
          "size": "20 1000",
          "type": "square",
          "category": "busbarx",
          "tool": "main",
          "properties": {
            "busbarSize": {
              "amp": `${busbarData.ampere}A`,
              "des": busbarData.des,
              "orderCode": busbarData.orderCode,
              "img": busbarData.img
            }, "busbarLength": 500, "innerProfile": 400
          },
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_VR.svg",
          "pos": `${-1000 + (shapeWidth / 2)} -1100`
        }

        const horizontalBusBar = {
          "uuid": "5432ceba1dad",
          "text": "Horizontal Busbar",
          "color": "#bdae91",
          "size": `${shapeWidth} 20`,
          "type": "square",
          "category": "busbary",
          "tool": "main",
          "properties": {
            "busbarSize": {
              "amp": `${busbarData.ampere}A`,
              "des": busbarData.des,
              "orderCode": busbarData.orderCode,
              "img": busbarData.img
            }, "busbarLength": 500, "innerProfile": 400
          },
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
          "pos": "-1000 -1000"
        }
        // Push the new rows into nodeDataArray

        this.nodeDataArray.push(BaseFrameRow);
        this.nodeDataArray.push(verticalBusBar);
        this.nodeDataArray.push(horizontalBusBar);


        this.currentPage++
        // const dialogRef = this.dialog.open(ProjectEditDialogComponent, {
        //   data: {
        //     Wizard: true,
        //     selectedItems: this.nodeDataArray,
        //   },
        //   height: '90%',
        //   width: '80%'
        // });

        // dialogRef.afterClosed().subscribe((result: Project) => {
        //   if (result) {
        //     // Handle the result returned from the dialog
        //   }
        // });
      } else {
        console.error('No cubicle size found for the selected rated ampere.');
      }
    } else {
      // Execute default logic when currentIncomerPage is not 1
      let pictureWidth = Math.round(this.matchingRow?.WIDTH || this.matchingRowMCCB?.WIDTH / 50) * 50;
      let pictureHeight = Math.round(this.matchingRow?.HEIGHT || this.matchingRowMCCB?.HEIGHT / 50) * 50;
      const ratedAmp = parseInt(this.selectedRatedAmp || "0"); // Provide a default value if null
      let higherAmpRow;

      // Find the row with the nearest higher ampere value
      for (let i = 0; i < this.CubiclesSizes.length; i++) {
        const row = this.CubiclesSizes[i];
        if (row.ampere >= ratedAmp) {
          higherAmpRow = row;
          break;
        }
      }

      if (higherAmpRow) {
        // Set the width and height based on the matching row
        // Set the width and height based on the matching row
        if (this.matchingRow) {
          this.matchingRow['cubicleWidth'] = higherAmpRow.width;
          this.matchingRow['cubicleHeight'] = higherAmpRow.height;
        }

        // Check if this.matchingRowMCCB exists and assign width and height
        if (this.matchingRowMCCB) {
          this.matchingRowMCCB['cubicleWidth'] = higherAmpRow.width;
          this.matchingRowMCCB['cubicleHeight'] = higherAmpRow.height;
        }
        const shapeWidth = higherAmpRow.width;
        const shapeHeight = higherAmpRow.height;
        let baseFrameWidth = 0;
        let baseFrameHeight = 0;
        if (this.nodeDataArray && this.nodeDataArray.length > 0) {
          // Check if an element with the text "Base Frame" exists
          const baseFrameElement = this.nodeDataArray.find(element => element.category === "outerProfile");
          if (baseFrameElement) {
            const sizeParts = baseFrameElement.size.split(' '); // Split size string by whitespace
            baseFrameWidth = parseFloat(sizeParts[0]); // Parse the width part to a float
            baseFrameHeight = parseFloat(sizeParts[1]);

            if (!isNaN(baseFrameWidth)) {
              // Check if parsing was successful
              let baseWidth = shapeWidth + baseFrameWidth;
              sizeParts[0] = baseWidth.toString(); // Update the first part of sizeParts array
              baseFrameElement.size = sizeParts.join(' ');
              // Update the value in the array
            } else {
              // Handle the case where width is not a valid number
              // For example:
              // shapeWidth += defaultValue; // Add a default value
            }
          }

        }

        const busBarChamberCurrentSizeHeight = this.getBusBarChamberSizeHeight(this.matchingRow || this.matchingRowMCCB);
        const busBarChamberSizeHeight = Math.max(busBarChamberCurrentSizeHeight, PreviousMaxbusBarChamberSizeHeight);
        this.nodeDataArray.forEach(node => {
          if (node.text === "Busbar Chamber") {
            const sizeArray = node.size.split(' ');
            sizeArray[1] = busBarChamberSizeHeight.toString();
            node.size = sizeArray.join(' ');
          }
        });

        this.nodeDataArray.forEach(node => {
          if (node.text === "CONTROL SEC") {
            console.log("baseFrameHeight", baseFrameHeight);
            console.log("node.ACBheight", node.ACBheight);
            console.log("busBarChamberSizeHeight", busBarChamberSizeHeight);

            // Convert node.ACBheight to a number before using it in calculations
            const acbHeight = Number(node.ACBheight) || 0;
            const coverHeight = Number(node.minHeight) || 0;
            // Calculate controlSecHeight
            const controlSecHeight = baseFrameHeight - (acbHeight + coverHeight + busBarChamberSizeHeight);
            console.log("controlSecHeight", controlSecHeight);

            // Update size
            const sizeArray = node.size.split(' ');
            sizeArray[1] = controlSecHeight.toString();
            node.size = sizeArray.join(' ');

            // Update pos
            const posArray = node.pos.split(' ');
            posArray[1] = (-1100 + busBarChamberSizeHeight).toString();
            node.pos = posArray.join(' ');
          }
        });


        if (shapeWidth < 1000) {
          const BusBarChamber = {
            "uuid": "254134ba1dad",
            "text": "Busbar Chamber",
            "color": "#bdae91",
            "size": `${shapeWidth} ${busBarChamberSizeHeight}`,
            "type": "rectangle",
            "category": "busbarChamber",
            "top": false, "side": false,
            "innerProfile": false,
            "tool": "main",
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
            "pos": `${-1000 + baseFrameWidth} -1100`,
            'group': this.uniqueKey()
          }

          // Calculate the remaining height for ControlSection
          const remainingHeight = baseFrameHeight - (shapeHeight + minHeight + busBarChamberSizeHeight);
          if (remainingHeight < 200) {
            this.toastr.error('This Tier Height is not enough. Please increase the size.', 'Error');
            return;
          }
          console.log('remainingHeight3', remainingHeight)
          const ControlSection = {
            "uuid": "4279ceba1dad",
            "text": "CONTROL SEC",
            "color": "#bdae91",
            "size": `${shapeWidth} ${remainingHeight}`,
            "type": "square",
            "category": "door",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
            "pos": `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber.pos.split(' ')[1]) + busBarChamberSizeHeight}`,
            'group': this.uniqueKey()
          }

          const AcbRow = {
            'uuid': 'f6a7c8b3e2d1',
            'text': isMCCB ? 'MCCB' : 'ACB', // Dynamically set text
            'color': '#bdae91',
            'size': `${shapeWidth} ${shapeHeight}`, // Update size
            'tool': 'main',
            'type': 'rectangle',
            'category': isMCCB ? 'electricalMCCB' : 'electricalACB',
            'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
            'pos': `${-1000 + baseFrameWidth} ${parseInt(ControlSection.pos.split(' ')[1]) + remainingHeight}`,
            'group': this.uniqueKey(),
            'properties': isMCCB ? { ...this.matchingRowMCCB } : { ...this.matchingRow }, // Dynamically set properties
            ...(!isMCCB && {
              'railProperties': { des: "50x25x300", orderCode: "AMR052503AEKC" },
            }), // Conditionally add railProperties
            "ports": [{}],
            'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
            'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
            'innerProfile': false
          };
          AcbRow.properties.imagePath = AcbRow.properties.ImagePath;

          const CablingSection = {
            "uuid": "2541ceba1dad",
            "text": "Cover",
            "color": "#bdae91",
            "size": `${shapeWidth} ${minHeight}`,
            "type": "rectangle",
            "category": "cover",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cover.svg",
            "pos": `${-1000 + baseFrameWidth} ${parseInt(AcbRow.pos.split(' ')[1]) + shapeHeight}`,
            'group': this.uniqueKey()
          };
          this.nodeDataArray.push(AcbRow);
          this.nodeDataArray.push(CablingSection);
          this.nodeDataArray.push(BusBarChamber);
          this.nodeDataArray.push(ControlSection);
        } else {
          const BusBarChamber = {
            "uuid": "254134ba1dad",
            "text": "Busbar Chamber",
            "color": "#bdae91",
            "size": `${shapeWidth} ${busBarChamberSizeHeight}`,
            "type": "rectangle",
            "category": "busbarChamber",
            "top": false, "side": false,
            "innerProfile": false,
            "tool": "main",
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
            "pos": `${-1000 + baseFrameWidth} -1100`,
            'group': this.uniqueKey()
          }

          // Calculate the remaining height for ControlSection
          const remainingHeight = baseFrameHeight - (shapeHeight + minHeight + parseInt(BusBarChamber.size.split(' ')[1]));
          if (remainingHeight < 200) {
            this.toastr.error('This Tier Height is not enough. Please increase the size.', 'Error');
            return;
          }
          console.log('remainingHeight4', remainingHeight)
          const ControlSection = {
            "uuid": "4279ceba1dad",
            "text": "CONTROL SEC",
            "color": "#bdae91",
            "size": `${shapeWidth} ${remainingHeight}`,
            "type": "rectangle",
            "category": "cover",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
            "pos": `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber.pos.split(' ')[1]) + busBarChamberSizeHeight}`,
            'group': this.uniqueKey()
          }

          const AcbRow = {
            'uuid': 'f6a7c8b3e2d1',
            'text': isMCCB ? 'MCCB' : 'ACB', // Dynamically set text
            'color': '#bdae91',
            'size': `${shapeWidth} ${shapeHeight}`, // Update size
            'tool': 'main',
            'type': 'rectangle',
            'category': isMCCB ? 'electricalMCCB' : 'electricalACB',
            'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
            'pos': `${-1000 + baseFrameWidth} ${parseInt(ControlSection.pos.split(' ')[1]) + remainingHeight}`,
            'group': this.uniqueKey(),
            'properties': isMCCB ? { ...this.matchingRowMCCB } : { ...this.matchingRow }, // Dynamically set properties
            ...(!isMCCB && {
              'railProperties': { des: "50x25x300", orderCode: "AMR052503AEKC" },
            }), // Conditionally add railProperties
            "ports": [{}],
            'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
            'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
            'innerProfile': false
          };
          AcbRow.properties.imagePath = AcbRow.properties.ImagePath;

          const CablingSection = {
            "uuid": "2541ceba1dad",
            "text": "Cover",
            "color": "#bdae91",
            "size": `${shapeWidth} ${minHeight}}`,
            "type": "rectangle",
            "category": "cover",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cover.svg",
            "pos": `${-1000 + baseFrameWidth} ${parseInt(AcbRow.pos.split(' ')[1]) + shapeHeight}`,
            'group': this.uniqueKey()
          };
          this.nodeDataArray.push(AcbRow);
          this.nodeDataArray.push(CablingSection);
          this.nodeDataArray.push(BusBarChamber);
          this.nodeDataArray.push(ControlSection);
        }


        const verticalBusBar = {
          "uuid": "9974ceba1dad",
          "text": "Vertical Busbar",
          "color": "#bdae91",
          "size": "20 1000",
          "type": "square",
          "category": "busbarx",
          "tool": "main",
          "properties": {
            "busbarSize": {
              "amp": `${busbarData.ampere}A`,
              "des": busbarData.des,
              "orderCode": busbarData.orderCode,
              "img": busbarData.img
            }, "busbarLength": 500, "innerProfile": 400
          },
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_VR.svg",
          "pos": `${-1000 + baseFrameWidth + (shapeWidth / 2)} -1100`,
        }

        const horizontalBusBar = {
          "uuid": "5432ceba1dad",
          "text": "Horizontal Busbar",
          "color": "#bdae91",
          "size": `${shapeWidth} 20`,
          "type": "square",
          "category": "busbary",
          "tool": "main",
          "properties": {
            "busbarSize": {
              "amp": `${busbarData.ampere}A`,
              "des": busbarData.des,
              "orderCode": busbarData.orderCode,
              "img": busbarData.img
            }, "busbarLength": 500, "innerProfile": 400
          },
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
          "pos": `${-1000 + baseFrameWidth} -1000`,
        }
        // Push the new rows into nodeDataArray
        this.nodeDataArray.push(verticalBusBar);
        this.nodeDataArray.push(horizontalBusBar);


        this.currentPage++
        // const dialogRef = this.dialog.open(ProjectEditDialogComponent, {
        //   data: {
        //     Wizard: true,
        //     selectedItems: this.nodeDataArray,
        //   },
        //   height: '90%',
        //   width: '80%'
        // });

        // dialogRef.afterClosed().subscribe((result: Project) => {
        //   if (result) {
        //     // Handle the result returned from the dialog
        //   }
        // });
      } else {
        console.error('No cubicle size found for the selected rated ampere.');
      }
    }
    this.animateNext = true;
    this.animatePrevious = false;
    this.showMCCB = true;
    this.resetAnimationFlags();
    this.resetSelections();
    this.addPorts();
    console.log("this.nodeDataArray", this.nodeDataArray);
  }






  onSelectionChange() {
    this.updateDropdownOptions();
    this.checkAndFindMatchingRow();
  }
  onSelectionChangeMCCB() {
    this.updateDropdownOptionsMCCB();
    this.checkAndFindMatchingRowMCCB();
    this.updateRotationBasedOnRatedAmp(); // New method to update rotation
  }
  addIncomer() {
    const isMCCB = Boolean(this.matchingRowMCCB); // Determine if it's MCCB or ACB

    const currentIncomerDetails = {
      selectedManufacturer: this.selectedManufacturer,
      selectedRatedAmp: this.selectedRatedAmp,
      selectedType: this.selectedType,
      selectedFrameSize: this.selectedFrameSize,
      selectedPRFLevel: this.selectedPRFLevel,
      selectedShortCircuitIcu: this.selectedShortCircuitIcu,
      selectedMaxTierHeight: this.selectedMaxTierHeight,
      matchingRow: isMCCB ? this.matchingRowMCCB : this.matchingRow,
      imagePath: this.imagePath
    };

    this.tierHeight = currentIncomerDetails.selectedMaxTierHeight
    this.incomerHistory.push(currentIncomerDetails);
    console.log("this.incomerHistory", this.incomerHistory);
    console.log("this.incomerHistory.length", this.incomerHistory.length);
    const pictureWidth = Math.round(
      (this.matchingRow?.WIDTH || this.matchingRowMCCB?.WIDTH || 50) / 50
    ) * 50;

    const pictureHeight = Math.round(
      (this.matchingRow?.HEIGHT || this.matchingRowMCCB?.HEIGHT || 50) / 50
    ) * 50;
    const ratedAmp = parseInt(this.selectedRatedAmp || "0"); // Provide a default value if null
    let higherAmpRow;

    // Find the row with the nearest higher ampere value
    for (let i = 0; i < this.CubiclesSizes.length; i++) {
      const row = this.CubiclesSizes[i];
      if (row.ampere >= ratedAmp) {
        higherAmpRow = row;
        break;
      }
    }

    if (higherAmpRow) {
      // Set the width and height based on the matching row
      // Set the width and height based on the matching row
      if (this.matchingRow) {
        this.matchingRow['cubicleWidth'] = higherAmpRow.width;
        this.matchingRow['cubicleHeight'] = higherAmpRow.height;
      }

      // Check if this.matchingRowMCCB exists and assign width and height
      if (this.matchingRowMCCB) {
        this.matchingRowMCCB['cubicleWidth'] = higherAmpRow.width;
        this.matchingRowMCCB['cubicleHeight'] = higherAmpRow.height;
      }
      const shapeWidth = higherAmpRow.width;
      const shapeHeight = higherAmpRow.height;

      const selectedCable = this.cableSizeData.find(cable => cable.size === this.selectedCableSize);
      let minHeight = 0;
      if (selectedCable) {
        minHeight = this.selectedMinHeightApplication === '1C Applications' ? selectedCable.minHeight1C : selectedCable.minHeight4C;
      }
      console.log("minHeight", minHeight);
      console.log("minHeight data type:", typeof minHeight);
      // Additional logic for adding the incomer
      let selectedMaxTierHeight = this.selectedMaxTierHeight ?? 0;
      console.log("this.selectedMaxTierHeight", this.selectedMaxTierHeight);
      if (this.currentIncomerPage === 1) {
        const BaseFrameRow = {
          "uuid": this.uniqueKey(),
          "text": "Base Frame",
          "color": "#bdae91",
          "isGroup": true,
          "size": `${shapeWidth} ${selectedMaxTierHeight}`,
          "type": "rectangle",
          "category": "outerProfile",
          "tool": "main",
          "selectedOption": null,
          "pos": "-1000 -1100",
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Base_Frame.svg",
          "loc": "-950 -1050"
        };


        const busBarChamberSizeHeight = this.getBusBarChamberSizeHeight(this.matchingRow || this.matchingRowMCCB);
        if (shapeWidth < 1000) {
          const BusBarChamber = {
            "uuid": "254134ba1dad",
            "text": "Busbar Chamber",
            "color": "#bdae91",
            "size": `${shapeWidth} ${busBarChamberSizeHeight}`,
            "type": "rectangle",
            "category": "busbarChamber",
            "top": false, "side": false,
            "innerProfile": false,
            "tool": "main",
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
            "pos": "-1000 -1100",
            'group': this.uniqueKey()
          }

          // Calculate the remaining height for ControlSection
          console.log("selectedMaxTierHeight", selectedMaxTierHeight);
          console.log("selectedMaxTierHeight", typeof selectedMaxTierHeight);
          console.log("shapeHeight", shapeHeight);
          console.log("shapeHeight", typeof shapeHeight);
          console.log("BusBarChamber", parseInt(BusBarChamber.size.split(' ')[1]));
          console.log("BusBarChamber", typeof parseInt(BusBarChamber.size.split(' ')[1]));

          const remainingHeight = selectedMaxTierHeight - (shapeHeight + minHeight + parseInt(BusBarChamber.size.split(' ')[1]));
          console.log("remainingHeight", remainingHeight);
          console.log("remainingHeight", typeof remainingHeight);
          if (remainingHeight < 200) {
            this.toastr.error('This Tier Height is not enough. Please increase the size.', 'Error');
            return;
          }
          const ControlSection = {
            "uuid": "4279ceba1dad",
            "text": "CONTROL SEC",
            "color": "#bdae91",
            "size": `${shapeWidth} ${remainingHeight}`,
            "type": "square",
            "category": "door",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
            "pos": `-1000 ${parseInt(BusBarChamber.pos.split(' ')[1]) + busBarChamberSizeHeight}`,
            'group': this.uniqueKey(),
            "ACBheight": `${shapeHeight}`,
            "minHeight": `${minHeight}`,
          }

          const AcbRow = {
            'uuid': 'f6a7c8b3e2d1',
            'text': isMCCB ? 'MCCB' : 'ACB', // Dynamically set text
            'color': '#bdae91',
            'size': `${shapeWidth} ${shapeHeight}`, // Update size
            'tool': 'main',
            'type': 'rectangle',
            'category': isMCCB ? 'electricalMCCB' : 'electricalACB',
            'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
            'pos': `-1000 ${parseInt(ControlSection.pos.split(' ')[1]) + remainingHeight}`,
            'group': this.uniqueKey(),
            'properties': isMCCB ? { ...this.matchingRowMCCB } : { ...this.matchingRow }, // Dynamically set properties
            ...(!isMCCB && {
              'railProperties': { des: "50x25x300", orderCode: "AMR052503AEKC" },
            }),
            "ports": [{}],
            'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
            'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
            'innerProfile': false
          };
          AcbRow.properties.imagePath = AcbRow.properties.ImagePath;

          const CablingSection = {
            "uuid": "2541ceba1dad",
            "text": "Cover",
            "color": "#bdae91",
            "size": `${shapeWidth} ${minHeight}`,
            "type": "rectangle",
            "category": "cover",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cover.svg",
            "pos": `-1000 ${parseInt(AcbRow.pos.split(' ')[1]) + shapeHeight}`,
            'group': this.uniqueKey()
          };
          this.nodeDataArray.push(AcbRow);
          this.nodeDataArray.push(CablingSection);
          this.nodeDataArray.push(BusBarChamber);
          this.nodeDataArray.push(ControlSection);
        } else {
          const BusBarChamber = {
            "uuid": "254134ba1dad",
            "text": "Busbar Chamber1772525",
            "color": "#bdae91",
            "size": `${shapeWidth} ${busBarChamberSizeHeight}`,
            "type": "rectangle",
            "category": "cover",
            "top": false, "side": false,
            "innerProfile": false,
            "tool": "main",
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
            "pos": "-1000 -1100",
            'group': this.uniqueKey()
          }

          // Calculate the remaining height for ControlSection
          const remainingHeight = selectedMaxTierHeight - (shapeHeight + minHeight + parseInt(BusBarChamber.size.split(' ')[1]));
          if (remainingHeight < 200) {
            this.toastr.error('This Tier Height is not enough. Please increase the size.', 'Error');
            return;
          }
          console.log("remainingHeight", remainingHeight);
          console.log("remainingHeight", typeof remainingHeight);
          const ControlSection = {
            "uuid": "4279ceba1dad",
            "text": "CONTROL SEC",
            "color": "#bdae91",
            "size": `${shapeWidth} ${remainingHeight}`,
            "type": "rectangle",
            "category": "cover",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
            "pos": `-1000 ${parseInt(BusBarChamber.pos.split(' ')[1]) + busBarChamberSizeHeight}`,
            'group': this.uniqueKey(),
            "ACBheight": `${shapeHeight}`,
            "minHeight": `${minHeight}`,
          }

          const AcbRow = {
            'uuid': 'f6a7c8b3e2d1',
            'text': isMCCB ? 'MCCB' : 'ACB', // Dynamically set text
            'color': '#bdae91',
            'size': `${shapeWidth} ${shapeHeight}`, // Update size
            'tool': 'main',
            'type': 'rectangle',
            'category': isMCCB ? 'electricalMCCB' : 'electricalACB',
            'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
            'pos': `-1000 ${parseInt(ControlSection.pos.split(' ')[1]) + remainingHeight}`,
            'group': this.uniqueKey(),
            'properties': isMCCB ? { ...this.matchingRowMCCB } : { ...this.matchingRow }, // Dynamically set properties
            ...(!isMCCB && {
              'railProperties': { des: "50x25x300", orderCode: "AMR052503AEKC" },
            }),
            "ports": [{}],
            'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
            'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
            'innerProfile': false
          };
          AcbRow.properties.imagePath = AcbRow.properties.ImagePath;

          const CablingSection = {
            "uuid": "2541ceba1dad",
            "text": "Cover",
            "color": "#bdae91",
            "size": `${shapeWidth} ${minHeight}`,
            "type": "rectangle",
            "category": "cover",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cover.svg",
            "pos": `-1000 ${parseInt(AcbRow.pos.split(' ')[1]) + shapeHeight}`,
            'group': this.uniqueKey()
          };
          this.nodeDataArray.push(AcbRow);
          this.nodeDataArray.push(CablingSection);
          this.nodeDataArray.push(BusBarChamber);
          this.nodeDataArray.push(ControlSection);
        }



        const verticalBusBar = {
          "uuid": "9974ceba1dad",
          "text": "Vertical Busbar",
          "color": "#bdae91",
          "size": "20 1000",
          "type": "square",
          "category": "busbarx",
          "tool": "main",
          "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_VR.svg",
          "pos": `${-1000 + (shapeWidth / 2)} -1100`
        }

        const horizontalBusBar = {
          "uuid": "5432ceba1dad",
          "text": "Horizontal Busbar",
          "color": "#bdae91",
          "size": `${shapeWidth} 20`,
          "type": "square",
          "category": "busbary",
          "tool": "main",
          "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
          "pos": "-1000 -1000"
        }
        // Push the new rows into nodeDataArray

        this.nodeDataArray.push(BaseFrameRow);
        this.nodeDataArray.push(verticalBusBar);
        this.nodeDataArray.push(horizontalBusBar);
      } else {
        let baseFrameWidth = 0;
        if (this.nodeDataArray && this.nodeDataArray.length > 0) {
          // Check if an element with the text "Base Frame" exists
          const baseFrameElement = this.nodeDataArray.find(element => element.category === "outerProfile");
          if (baseFrameElement) {
            const sizeParts = baseFrameElement.size.split(' '); // Split size string by whitespace
            baseFrameWidth = parseFloat(sizeParts[0]); // Parse the width part to a float
            selectedMaxTierHeight = parseFloat(sizeParts[1]);
            if (!isNaN(baseFrameWidth)) {
              // Check if parsing was successful
              let baseWidth = shapeWidth + baseFrameWidth;
              sizeParts[0] = baseWidth.toString(); // Update the first part of sizeParts array
              baseFrameElement.size = sizeParts.join(' ');
              // Update the value in the array
            } else {
              // Handle the case where width is not a valid number
              // For example:
              // shapeWidth += defaultValue; // Add a default value
            }
          }

        }

        const busBarChamberSizeHeight = this.getBusBarChamberSizeHeight(this.matchingRow || this.matchingRowMCCB);
        if (shapeWidth < 1000) {
          const BusBarChamber = {
            "uuid": "254134ba1dad",
            "text": "Busbar Chamber",
            "color": "#bdae91",
            "size": `${shapeWidth} ${busBarChamberSizeHeight}`,
            "type": "rectangle",
            "category": "busbarChamber",
            "top": false, "side": false,
            "innerProfile": false,
            "tool": "main",
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
            "pos": `${-1000 + baseFrameWidth} -1100`,
            'group': this.uniqueKey()
          }
          console.log("selectedMaxTierHeight", selectedMaxTierHeight);
          // Calculate the remaining height for ControlSection
          const remainingHeight = selectedMaxTierHeight - (shapeHeight + minHeight + parseInt(BusBarChamber.size.split(' ')[1]));
          if (remainingHeight < 200) {
            this.toastr.error('This Tier Height is not enough. Please increase the size.', 'Error');
            return;
          }
          const ControlSection = {
            "uuid": "4279ceba1dad",
            "text": "CONTROL SEC",
            "color": "#bdae91",
            "size": `${shapeWidth} ${remainingHeight}`,
            "type": "square",
            "category": "door",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
            "pos": `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber.pos.split(' ')[1]) + busBarChamberSizeHeight}`,
            'group': this.uniqueKey(),
            "ACBheight": `${shapeHeight}`,
            "minHeight": `${minHeight}`,
          }

          const AcbRow = {
            'uuid': 'f6a7c8b3e2d1',
            'text': isMCCB ? 'MCCB' : 'ACB', // Dynamically set text
            'color': '#bdae91',
            'size': `${shapeWidth} ${shapeHeight}`, // Update size
            'tool': 'main',
            'type': 'rectangle',
            'category': isMCCB ? 'electricalMCCB' : 'electricalACB',
            'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
            'pos': `${-1000 + baseFrameWidth} ${parseInt(ControlSection.pos.split(' ')[1]) + remainingHeight}`,
            'group': this.uniqueKey(),
            'properties': isMCCB ? { ...this.matchingRowMCCB } : { ...this.matchingRow }, // Dynamically set properties
            ...(!isMCCB && {
              'railProperties': { des: "50x25x300", orderCode: "AMR052503AEKC" },
            }),
            "ports": [{}],
            'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
            'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
            'innerProfile': false
          };
          AcbRow.properties.imagePath = AcbRow.properties.ImagePath;

          const CablingSection = {
            "uuid": "2541ceba1dad",
            "text": "Cover",
            "color": "#bdae91",
            "size": `${shapeWidth} ${minHeight}`,
            "type": "rectangle",
            "category": "cover",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cover.svg",
            "pos": `${-1000 + baseFrameWidth} ${parseInt(AcbRow.pos.split(' ')[1]) + shapeHeight}`,
            'group': this.uniqueKey()
          };
          this.nodeDataArray.push(AcbRow);
          this.nodeDataArray.push(CablingSection);
          this.nodeDataArray.push(BusBarChamber);
          this.nodeDataArray.push(ControlSection);
        } else {
          const BusBarChamber = {
            "uuid": "254134ba1dad",
            "text": "Busbar Chamber242589",
            "color": "#bdae91",
            "size": `${shapeWidth} ${busBarChamberSizeHeight}`,
            "type": "rectangle",
            "category": "cover",
            "top": false, "side": false,
            "innerProfile": false,
            "tool": "main",
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
            "pos": `${-1000 + baseFrameWidth} -1100`,
            'group': this.uniqueKey()
          }

          // Calculate the remaining height for ControlSection
          const remainingHeight = selectedMaxTierHeight - (shapeHeight + minHeight + parseInt(BusBarChamber.size.split(' ')[1]));
          if (remainingHeight < 200) {
            this.toastr.error('This Tier Height is not enough. Please increase the size.', 'Error');
            return;
          }
          const ControlSection = {
            "uuid": "4279ceba1dad",
            "text": "CONTROL SEC",
            "color": "#bdae91",
            "size": `${shapeWidth} ${remainingHeight}`,
            "type": "rectangle",
            "category": "cover",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
            "pos": `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber.pos.split(' ')[1]) + busBarChamberSizeHeight}`,
            'group': this.uniqueKey(),
            "ACBheight": `${shapeHeight}`,
            "minHeight": `${minHeight}`,
          }

          const AcbRow = {
            'uuid': 'f6a7c8b3e2d1',
            'text': isMCCB ? 'MCCB' : 'ACB', // Dynamically set text
            'color': '#bdae91',
            'size': `${shapeWidth} ${shapeHeight}`, // Update size
            'tool': 'main',
            'type': 'rectangle',
            'category': isMCCB ? 'electricalMCCB' : 'electricalACB',
            'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
            'pos': `${-1000 + baseFrameWidth} ${parseInt(ControlSection.pos.split(' ')[1]) + remainingHeight}`,
            'group': this.uniqueKey(),
            'properties': isMCCB ? { ...this.matchingRowMCCB } : { ...this.matchingRow }, // Dynamically set properties
            ...(!isMCCB && {
              'railProperties': { des: "50x25x300", orderCode: "AMR052503AEKC" },
            }),
            "ports": [{}],
            'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
            'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
            'innerProfile': false
          };
          AcbRow.properties.imagePath = AcbRow.properties.ImagePath;

          const CablingSection = {
            "uuid": "2541ceba1dad",
            "text": "Cover",
            "color": "#bdae91",
            "size": `${shapeWidth} ${minHeight}`,
            "type": "rectangle",
            "category": "cover",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cover.svg",
            "pos": `${-1000 + baseFrameWidth} ${parseInt(AcbRow.pos.split(' ')[1]) + shapeHeight}`,
            'group': this.uniqueKey()
          };
          this.nodeDataArray.push(AcbRow);
          this.nodeDataArray.push(CablingSection);
          this.nodeDataArray.push(BusBarChamber);
          this.nodeDataArray.push(ControlSection);
        }


        const verticalBusBar = {
          "uuid": "9974ceba1dad",
          "text": "Vertical Busbar",
          "color": "#bdae91",
          "size": "20 1000",
          "type": "square",
          "category": "busbarx",
          "tool": "main",
          "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_VR.svg",
          "pos": `${-1000 + baseFrameWidth + (shapeWidth / 2)} -1100`
        }

        const horizontalBusBar = {
          "uuid": "5432ceba1dad",
          "text": "Horizontal Busbar",
          "color": "#bdae91",
          "size": `${shapeWidth} 20`,
          "type": "square",
          "category": "busbary",
          "tool": "main",
          "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
          "pos": `${-1000 + baseFrameWidth} -1000`,
        }
        // Push the new rows into nodeDataArray

        this.nodeDataArray.push(verticalBusBar);
        this.nodeDataArray.push(horizontalBusBar);
      }

      this.currentIncomerPage++;
      this.animateNext = true;
      this.animatePrevious = false;
      this.resetSelections();
      this.resetAnimationFlags()
      this.addPorts();
      this.cdr.detectChanges();
    } else {
      console.error('No cubicle size found for the selected rated ampere.');
    }
    console.log("this.nodeDataArray", this.nodeDataArray);
  }

  getBusBarChamberSizeHeight(row) {
    let data;
    console.log('Type of busbarTypeOptions:', typeof row.busbarTypeOptions);
    console.log('Busbar type:', row.busbarTypeOptions);
    console.log("row.RATED_AMP", row.RATED_AMP);
    console.log('row:', row);

    if (row.busbarTypeOptions === 'Busbar Support - Flat') {
      data = this.busBarData.mainHorizontal;
    } else if (row.busbarTypeOptions === 'Busbar Support With Grooves') {
      data = this.busBarData.dropper;
    } else {
      throw new Error('Invalid type');
    }

    // Convert row.RATED_AMP to a number if it is a string
    const ratedAmp = typeof row.RATED_AMP === 'string' ? parseInt(row.RATED_AMP, 10) : row.RATED_AMP;
    console.log('ratedAmp', ratedAmp)
    const entry = data.find(item => item.ampere === ratedAmp);
    console.log('entry', entry)
    if (!entry) {
      throw new Error('Ampere rating not found in the table');
    }

    return entry.height;
  }


  initializeMaxTierHeightOptions() {
    // Generate options from 1200 to 2400 with increments of 100
    this.maxTierHeightOptions = Array.from({ length: 13 }, (_, i) => 1200 + i * 100);
  }
  resetSelections() {
    const isMCCB = Boolean(this.matchingRowMCCB);
    if (isMCCB) {
      this.selectedManufacturerMCCB = null;
      this.selectedRatedAmpMCCB = null;
      this.selectedTypeMCCB = null;
      this.selectedFrameSizeMCCB = null;
      this.selectedPRFLevelMCCB = null;
      this.selectedShortCircuitIcuMCCB = null;
      this.matchingRowMCCB = null;
      this.selectedMaxTierHeight = null;
      this.selectedTripUnitMCCB = null;
      this.selectedOrderNumberMCCB = null;
    } else {
      this.selectedManufacturer = null;
      this.selectedRatedAmp = null;
      this.selectedType = null;
      this.selectedFrameSize = null;
      this.selectedPRFLevel = null;
      this.selectedShortCircuitIcu = null;
      this.matchingRow = null;
      this.selectedMaxTierHeight = null;
    }
  }

  resetAnimationFlags() {
    setTimeout(() => {
      this.animateNext = false;
      this.animatePrevious = false;
      this.cdr.detectChanges();
    }, 500); // Adjust the timeout duration to match your animation duration
  }



  nextOutgoingButton() {
    this.outgoingHistory.push(this.matchingRowMCCB);
    console.log("this.outgoingHistory", this.outgoingHistory);
    console.log("this.nodeDataArray", this.nodeDataArray);
    let BusBarChamberHeight = 0;
    const nodesWithACB = this.nodeDataArray.filter(node => node.text === "ACB" || node.text === "MCCB");
    if (nodesWithACB.length === 0) {
      console.error('No nodes found with text "ACB"');
      return;
    }
    console.log("nodesWithACB", nodesWithACB);

    const maxRatedAmp = Math.max(
      ...nodesWithACB.map(node => Number(node.properties.RATED_AMP) || 0)
    );
    console.log("maxRatedAmp", maxRatedAmp);
    if (this.currentOutGoingPage === 1) {
      let pictureWidth = Math.round(this.matchingRowMCCB.WIDTH / 50) * 50;
      let pictureHeight = Math.round(this.matchingRowMCCB.HEIGHT / 50) * 50;
      const ratedAmp = parseInt(this.matchingRowMCCB.RATED_AMP || "0"); // Provide a default value if null
      let higherAmpRow;

      // Find the row with the nearest higher ampere value
      if (this.matchingRowMCCB.ROTATION === 'Vertical') {
        for (let i = 0; i < this.CubiclesSizesVerticle.length; i++) {
          const row = this.CubiclesSizesVerticle[i];
          if (row.ampere >= ratedAmp) {
            higherAmpRow = row;
            break;
          }
        }
      } else if (this.matchingRowMCCB.ROTATION === 'Horizontal') {
        for (let i = 0; i < this.CubiclesSizesHorizontal.length; i++) {
          const row = this.CubiclesSizesHorizontal[i];
          // Check if ratedAmp is more than 800
          if (ratedAmp > 800) {
            higherAmpRow = this.CubiclesSizesHorizontal.find(r => r.ampere === 800) || null;
            break;
          }

          if (row.ampere >= ratedAmp) {
            higherAmpRow = row;
            break;
          }
        }
      }
      console.log("higherAmpRow", higherAmpRow);

      if (higherAmpRow) {
        // Set shapeWidth and shapeHeight to the values from the higherAmpRow
        const shapeWidth = higherAmpRow.width;
        const shapeHeight = higherAmpRow.height;


        // Set these values to the properties in your component if needed
        this.matchingRowMCCB['cubicleWidth'] = shapeWidth;
        this.matchingRowMCCB['cubicleHeight'] = shapeHeight;
        let selectedMaxTierHeight = this.selectedMaxTierHeight ?? 0;
        let baseFrameWidth = 0;
        let totalWidth = 0;
        let baseFrameHeight = 0;
        this.widthArray = [];
        console.log("this.nodeDataArray", this.nodeDataArray);
        if (this.nodeDataArray && this.nodeDataArray.length > 0) {
          // Check if an element with the text "Base Frame" exists
          const baseFrameElement = this.nodeDataArray.find(element => element.category === "outerProfile");
          console.log("baseFrameElement", baseFrameElement);
          if (baseFrameElement) {
            const sizeParts = baseFrameElement.size.split(' '); // Split size string by whitespace
            baseFrameWidth = parseFloat(sizeParts[0]); // Parse the width part to a float
            baseFrameHeight = parseFloat(sizeParts[1]);
            if (!isNaN(baseFrameWidth)) {
              // Check if parsing was successful
              let baseWidth = shapeWidth + baseFrameWidth;
              sizeParts[0] = baseWidth.toString(); // Update the first part of sizeParts array
              baseFrameElement.size = sizeParts.join(' ');
              // Update the value in the array
            } else {
              // Handle the case where width is not a valid number
              // For example:
              // shapeWidth += defaultValue; // Add a default value
            }
          }
          const BusBarChamberElement = this.nodeDataArray.find(element => element.category === "busbarChamber");
          if (BusBarChamberElement) {
            const sizeParts = BusBarChamberElement.size.split(' '); // Split size string by whitespace
            BusBarChamberHeight = parseFloat(sizeParts[1]); // Parse the width part to a float
          }
        }


        const BusBarChamber = {
          "uuid": "254134ba1dad",
          "text": "Busbar Chamber",
          "color": "#bdae91",
          "size": `${shapeWidth} ${BusBarChamberHeight}`,
          "type": "rectangle",
          "category": "busbarChamber",
          "top": false, "side": false,
          "innerProfile": false,
          "tool": "main",
          "ports": [{}],
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
          "pos": `${-1000 + baseFrameWidth} -1100`,
          'group': this.uniqueKey(),
          "page": `${this.currentOutGoingPage}`,
          "tire": "Outgoing",
          "join": "nextOutgoing"
        }

        // Calculate the remaining height for ControlSection

        const MccbRow = {
          'uuid': '9a4b5c6d7e8f',
          'text': 'MCCB',
          'color': '#bdae91',
          'size': `${shapeWidth} ${shapeHeight}`, // Update size
          'tool': 'main',
          'type': 'rectangle',
          'category': 'electricalMCCB',
          'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
          "pos": `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber.pos.split(' ')[1]) + BusBarChamberHeight}`,
          'group': this.uniqueKey(),
          'properties': { ...this.matchingRowMCCB },
          "ports": [{}],
          'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
          'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
          'innerProfile': false,
          "page": `${this.currentOutGoingPage}`,
          "tire": "Outgoing",
          "join": "nextOutgoing",
          "mccbcont": `${this.numberOfOutgoing}`
        };
        MccbRow.properties.imagePath = MccbRow.properties.ImagePath;

        const horizontalBusBar = {
          "uuid": "5432ceba1dad",
          "text": "Horizontal Busbar",
          "color": "#bdae91",
          "size": `${shapeWidth} 20`,
          "type": "square",
          "category": "busbary",
          "with": "mccb",
          "tool": "main",
          "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
          "pos": `${-1000 + baseFrameWidth} -1000`,
          "page": `${this.currentOutGoingPage}`,
          "tire": "Outgoing",
          "join": "nextOutgoing"
        }
        // Push the new rows into nodeDataArray
        let totalMccbRowHeight = 0;
        let totalMccbCountOFFirstTier = 0;
        let remainingMccbCount = 0;
        if (this.numberOfOutgoing > 1) {
          let previousMccbRowSize = 0;
          let CurrenttotalMccbRowHeight = 0;
          let addCableChamber = false;
          for (let i = 0; i < this.numberOfOutgoing; i++) {
            const currentMccbRow = { ...MccbRow }; // Create a copy of MccbRow

            // Adjust pos based on previousMccbRowSize
            currentMccbRow.pos = `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber.pos.split(' ')[1]) + BusBarChamberHeight + previousMccbRowSize}`;
            CurrenttotalMccbRowHeight += currentMccbRow.shapeSize.height;
            // Push the created MccbRow into the nodeDataArray
            if (CurrenttotalMccbRowHeight <= baseFrameHeight - parseInt(BusBarChamber.size.split(' ')[1])) {
              this.nodeDataArray.push(currentMccbRow);
              totalMccbRowHeight += currentMccbRow.shapeSize.height;
              totalMccbCountOFFirstTier++;
            } else {
              addCableChamber = true;
              // currentMccbRow.pos = `${-1000 + baseFrameWidth + shapeWidth} ${parseInt(BusBarChamber.pos.split(' ')[1]) + BusBarChamberHeight + previousMccbRowSize}`;
              // this.nodeDataArray.push(currentMccbRow);
            }


            // Update previousMccbRowSize for the next iteration
            previousMccbRowSize += currentMccbRow.shapeSize.height;
          }
          remainingMccbCount = this.numberOfOutgoing - totalMccbCountOFFirstTier;
          const verticalBusBar = {
            "uuid": "9974ceba1dad",
            "text": "Vertical Busbar",
            "color": "#bdae91",
            "size": `20 ${totalMccbRowHeight}`,
            "type": "square",
            "category": "busbarx",
            "with": "mccb",
            "tool": "main",
            "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_VR.svg",
            "pos": `${-1000 + baseFrameWidth + (shapeWidth / 2)} -1100`,
            "page": `${this.currentOutGoingPage}`,
            "tire": "Outgoing",
            "join": "nextOutgoing"
          }
          const remainingHeight = baseFrameHeight - (totalMccbRowHeight + parseInt(BusBarChamber.size.split(' ')[1]));
          if (remainingHeight > 0) {
            const Door = {
              "uuid": "4279ceba1dad",
              "text": "Door",
              "color": "#bdae91",
              "size": `${shapeWidth} ${remainingHeight}`,
              "type": "square",
              "category": "door",
              "tool": "main",
              "top": false,
              "side": false,
              "innerProfile": false,
              "ports": [{}],
              "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
              'pos': `${-1000 + baseFrameWidth} ${parseInt(MccbRow.pos.split(' ')[1]) + totalMccbRowHeight}`,
              'group': this.uniqueKey(),
              "page": `${this.currentOutGoingPage}`,
              "tire": "Outgoing",
              "join": "nextOutgoing"
            }
            this.nodeDataArray.push(Door);
            if (remainingHeight === 100) {
              this.adjustLastPushedDoor()
            } else {
              this.AdditionalDoorDataArray.push(Door);
            }
          }
          console.log("remainingMccbCount", remainingMccbCount);
          if (remainingMccbCount > 0) {
            let remainingMccbTierCount = Math.ceil(Math.ceil(remainingMccbCount) / totalMccbCountOFFirstTier);
            let remainingMccbCountForOneTier = totalMccbCountOFFirstTier;
            let totalMccbRowHeightMCCB = 0;
            let totalSetPositionedMccbCountMCCB = 0;

            for (let i = 0; i < remainingMccbTierCount; i++) {
              // if (i ===0){

              // }else{

              //   }
              // }
              // Check if parsing was successful
              const baseFrameElement = this.nodeDataArray.find(element => element.category === "outerProfile");
              if (baseFrameElement) {
                const sizeParts = baseFrameElement.size.split(' '); // Split size string by whitespace
                baseFrameWidth = parseFloat(sizeParts[0]); // Parse the width part to a float
                baseFrameHeight = parseFloat(sizeParts[1]);
                if (!isNaN(baseFrameWidth)) {
                  // Check if parsing was successful
                  let baseWidth = shapeWidth + baseFrameWidth;
                  totalWidth = baseWidth;
                  this.oneBaseFrameWidth = baseWidth;
                  if (this.oneBaseFrameWidth < 2400) {
                    this.oneBaseFrameWidth = totalWidth
                  } else {
                    if (this.widthArray.length === 0) {  // Fixing the comparison operator to '==='
                      this.oneBaseFrameWidth = totalWidth - shapeWidth;
                      if (this.oneBaseFrameWidth <= 2400) {
                        this.widthArray.push(this.oneBaseFrameWidth);
                      } else {
                        // Calculate how many times 2400 fits into oneBaseFrameWidth
                        let fullTimes = Math.floor(this.oneBaseFrameWidth / 2400);
                        // Push 2400 fullTimes number of times
                        for (let i = 0; i < fullTimes; i++) {
                          this.widthArray.push(2400);
                        }
                        // Calculate the remaining part and push it if it's greater than 0
                        let remainder = this.oneBaseFrameWidth % 2400;
                        if (remainder > 0) {
                          this.widthArray.push(remainder);
                        }
                      }
                      this.oneBaseFrameWidth = 0;
                    } else {
                      // If widthArray is not empty
                      let lastBaseFrameWidth = this.widthArray.reduce((acc, val) => acc + val, 0);
                      let difference = totalWidth - lastBaseFrameWidth - shapeWidth;
                      if (totalWidth - lastBaseFrameWidth > 2400) {
                        if (difference <= 2400) {
                          this.widthArray.push(difference);
                        }
                      }
                    }
                  }
                  sizeParts[0] = baseWidth.toString(); // Update the first part of sizeParts array
                  baseFrameElement.size = sizeParts.join(' ');


                  // Update the value in the array
                } else {
                  // Handle the case where width is not a valid number
                  // For example:
                  // shapeWidth += defaultValue; // Add a default value
                }
              }

              const BusBarChamberInChemberTier = {
                "uuid": "254134ba1dad",
                "text": "Busbar Chamber",
                "color": "#bdae91",
                "size": `${shapeWidth} ${BusBarChamberHeight}`,
                "type": "rectangle",
                "category": "busbarChamber",
                "top": false, "side": false,
                "innerProfile": false,
                "tool": "main",
                "ports": [{}],
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
                "pos": `${-1000 + baseFrameWidth} -1100`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing"
              }
              const horizontalBusBarChamberInChemberTier = {
                "uuid": "5432ceba1dad",
                "text": "Horizontal Busbar",
                "color": "#bdae91",
                "size": `${shapeWidth} 20`,
                "type": "square",
                "category": "busbary",
                "with": "mccb",
                "tool": "main",
                "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
                "pos": `${-1000 + baseFrameWidth} -1000`,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing"
              }
              const remainingHeightCableChamber = baseFrameHeight - parseInt(BusBarChamberInChemberTier.size.split(' ')[1]);

              const CableChamber = {
                "uuid": "6549ceba1dad",
                "text": "Cable Chamber",
                "color": "#bdae91",
                "size": `${shapeWidth} ${remainingHeightCableChamber}`,
                "type": "rectangle",
                "category": "cableChamber",
                "chamberType": "Cover",
                "top": false,
                "tool": "main",
                "side": false,
                "innerProfile": true,
                "ports": [{}],
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cable_CH.svg",
                "pos": `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber.pos.split(' ')[1]) + BusBarChamberHeight}`,
                'group': this.uniqueKey(),
                "glandData": { "properties": { "GlandPlateAThickness": "3.0mm", "view": "top" } },
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing"
              };

              this.nodeDataArray.push(horizontalBusBarChamberInChemberTier);
              this.nodeDataArray.push(BusBarChamberInChemberTier);
              this.nodeDataArray.push(CableChamber);

              if (baseFrameElement) {

                const sizeParts = baseFrameElement.size.split(' '); // Split size string by whitespace
                baseFrameWidth = parseFloat(sizeParts[0]); // Parse the width part to a float
                console.log("baseFrameWidth<><><><><", baseFrameWidth);
                baseFrameHeight = parseFloat(sizeParts[1]);
                if (!isNaN(baseFrameWidth)) {
                  // Check if parsing was successful
                  let baseWidth = shapeWidth + baseFrameWidth;
                  totalWidth = baseWidth;
                  this.oneBaseFrameWidth = baseWidth;
                  if (this.oneBaseFrameWidth < 2400) {
                    this.oneBaseFrameWidth = totalWidth
                  } else {
                    if (this.widthArray.length === 0) {  // Fixing the comparison operator to '==='
                      this.oneBaseFrameWidth = totalWidth - shapeWidth;
                      if (this.oneBaseFrameWidth <= 2400) {
                        this.widthArray.push(this.oneBaseFrameWidth);
                      } else {
                        // Calculate how many times 2400 fits into oneBaseFrameWidth
                        let fullTimes = Math.floor(this.oneBaseFrameWidth / 2400);
                        // Push 2400 fullTimes number of times
                        for (let i = 0; i < fullTimes; i++) {
                          this.widthArray.push(2400);
                        }
                        // Calculate the remaining part and push it if it's greater than 0
                        let remainder = this.oneBaseFrameWidth % 2400;
                        if (remainder > 0) {
                          this.widthArray.push(remainder);
                        }
                      }
                      this.oneBaseFrameWidth = 0;
                    } else {
                      // If widthArray is not empty
                      let lastBaseFrameWidth = this.widthArray.reduce((acc, val) => acc + val, 0);
                      let difference = totalWidth - lastBaseFrameWidth - shapeWidth;
                      if (totalWidth - lastBaseFrameWidth > 2400) {
                        if (difference <= 2400) {
                          this.widthArray.push(difference);
                        }
                      }
                    }
                  }
                  sizeParts[0] = baseWidth.toString(); // Update the first part of sizeParts array
                  baseFrameElement.size = sizeParts.join(' ');


                  // Update the value in the array
                } else {
                  // Handle the case where width is not a valid number
                  // For example:
                  // shapeWidth += defaultValue; // Add a default value
                }
              }
              const BusBarChamber1 = {
                "uuid": "254134ba1dad",
                "text": "Busbar Chamber",
                "color": "#bdae91",
                "size": `${shapeWidth} ${BusBarChamberHeight}`,
                "type": "rectangle",
                "category": "busbarChamber",
                "top": false, "side": false,
                "innerProfile": false,
                "tool": "main",
                "ports": [{}],
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
                "pos": `${-1000 + baseFrameWidth} -1100`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing"
              }
              const horizontalBusBar1 = {
                "uuid": "5432ceba1dad",
                "text": "Horizontal Busbar",
                "color": "#bdae91",
                "size": `${shapeWidth} 20`,
                "type": "square",
                "category": "busbary",
                "with": "mccb",
                "tool": "main",
                "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
                "pos": `${-1000 + baseFrameWidth} -1000`,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing"
              }
              const MccbRow1 = {
                'uuid': '9a4b5c6d7e8f',
                'text': 'MCCB',
                'color': '#bdae91',
                'size': `${shapeWidth} ${shapeHeight}`, // Update size
                'tool': 'main',
                'type': 'rectangle',
                'category': 'electricalMCCB',
                'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
                "pos": `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight}`,
                'group': this.uniqueKey(),
                'properties': { ...this.matchingRowMCCB },
                "ports": [{}],
                'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
                'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
                'innerProfile': false,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing",
                "mccbcont": `${this.numberOfOutgoing}`
              };
              MccbRow1.properties.imagePath = MccbRow1.properties.ImagePath;
              let previousMccbRowSize = 0;
              let CurrenttotalMccbRowHeight = 0;
              totalMccbRowHeightMCCB = 0;
              let remainingHeighttoDoor1 = 0;
              for (let j = 0; j < remainingMccbCountForOneTier; j++) {
                const currentMccbRow = { ...MccbRow1 };

                // Adjust pos based on previousMccbRowSize
                currentMccbRow.pos = `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight + previousMccbRowSize}`;
                CurrenttotalMccbRowHeight += currentMccbRow.shapeSize.height;
                // Push the created MccbRow into the nodeDataArray
                if ((CurrenttotalMccbRowHeight <= baseFrameHeight - parseInt(BusBarChamber1.size.split(' ')[1])) && (totalSetPositionedMccbCountMCCB < remainingMccbCount)) {
                  this.nodeDataArray.push(currentMccbRow);
                  totalMccbRowHeightMCCB += currentMccbRow.shapeSize.height;
                  totalSetPositionedMccbCountMCCB++;
                } else {
                  addCableChamber = true;
                }


                // Update previousMccbRowSize for the next iteration
                previousMccbRowSize += currentMccbRow.shapeSize.height;
              }
              remainingHeighttoDoor1 = baseFrameHeight - (totalMccbRowHeightMCCB + BusBarChamberHeight)

              const Door1 = {
                "uuid": "4279ceba1dad",
                "text": "Door",
                "color": "#bdae91",
                "size": `${shapeWidth} ${remainingHeighttoDoor1}`,
                "type": "square",
                "category": "door",
                "tool": "main",
                "top": false,
                "side": false,
                "innerProfile": false,
                "ports": [{}],
                "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
                'pos': `${-1000 + baseFrameWidth} ${parseInt(MccbRow1.pos.split(' ')[1]) + totalMccbRowHeightMCCB}`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing"
              }
              const verticalBusBar1 = {
                "uuid": "9974ceba1dad",
                "text": "Vertical Busbar",
                "color": "#bdae91",
                "size": `20 ${totalMccbRowHeightMCCB}`,
                "type": "square",
                "category": "busbarx",
                "with": "mccb",
                "tool": "main",
                "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_VR.svg",
                "pos": `${-1000 + baseFrameWidth + (shapeWidth / 2)} -1100`,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing"
              }
              if (remainingHeighttoDoor1 > 0) {
                this.nodeDataArray.push(Door1);
                if (remainingHeighttoDoor1 === 100) {
                  this.adjustLastPushedDoor()
                } else {
                  this.AdditionalDoorDataArray.push(Door1);
                }
              }
              this.nodeDataArray.push(verticalBusBar1);
              this.nodeDataArray.push(BusBarChamber1);
              this.nodeDataArray.push(horizontalBusBar1);
            }
          } else {
            const baseFrameElement = this.nodeDataArray.find(element => element.category === "outerProfile");
            if (baseFrameElement) {
              const sizeParts = baseFrameElement.size.split(' '); // Split size string by whitespace
              baseFrameWidth = parseFloat(sizeParts[0]); // Parse the width part to a float
              console.log("baseFrameWidth<><><><><", baseFrameWidth);
              baseFrameHeight = parseFloat(sizeParts[1]);
              if (!isNaN(baseFrameWidth)) {

                let baseWidth = shapeWidth + baseFrameWidth;
                totalWidth = baseWidth;
                this.oneBaseFrameWidth = baseWidth;
                console.log("this.oneBaseFrameWidth", this.oneBaseFrameWidth);
                console.log("this.widthArray", this.widthArray);
                if (this.oneBaseFrameWidth < 2400) {
                  this.oneBaseFrameWidth = totalWidth
                } else {
                  if (this.widthArray.length === 0) {  // Fixing the comparison operator to '==='
                    console.log("totalWidth", totalWidth);
                    console.log("shapeWidth", shapeWidth);

                    this.oneBaseFrameWidth = totalWidth - shapeWidth;
                    console.log("this.oneBaseFrameWidth>>>>", this.oneBaseFrameWidth);

                    if (this.oneBaseFrameWidth <= 2400) {
                      this.widthArray.push(this.oneBaseFrameWidth);
                    } else {
                      // Calculate how many times 2400 fits into oneBaseFrameWidth
                      let fullTimes = Math.floor(this.oneBaseFrameWidth / 2400);
                      console.log("fullTimes", fullTimes);
                      // Push 2400 fullTimes number of times
                      for (let i = 0; i < fullTimes; i++) {
                        this.widthArray.push(2400);
                      }
                      // Calculate the remaining part and push it if it's greater than 0
                      let remainder = this.oneBaseFrameWidth % 2400;
                      if (remainder > 0) {
                        this.widthArray.push(remainder);
                      }
                    }
                    this.oneBaseFrameWidth = 0;
                  } else {
                    // If widthArray is not empty
                    let lastBaseFrameWidth = this.widthArray.reduce((acc, val) => acc + val, 0);
                    let difference = totalWidth - lastBaseFrameWidth - shapeWidth;
                    if (totalWidth - lastBaseFrameWidth > 2400) {
                      if (difference <= 2400) {
                        this.widthArray.push(difference);
                      }
                    }
                  }
                }
              }
            }
            const BusBarChamberInChemberTier = {
              "uuid": "254134ba1dad",
              "text": "Busbar Chamber",
              "color": "#bdae91",
              "size": `${shapeWidth} ${BusBarChamberHeight}`,
              "type": "rectangle",
              "category": "busbarChamber",
              "top": false, "side": false,
              "innerProfile": false,
              "tool": "main",
              "ports": [{}],
              "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
              "pos": `${-1000 + baseFrameWidth} -1100`,
              'group': this.uniqueKey(),
              "page": `${this.currentOutGoingPage}`,
              "tire": "Outgoing",
              "join": "nextOutgoing"
            }
            const remainingHeightCableChamber = baseFrameHeight - parseInt(BusBarChamberInChemberTier.size.split(' ')[1]);
            const CableChamber = {
              "uuid": "6549ceba1dad",
              "text": "Cable Chamber",
              "color": "#bdae91",
              "size": `${shapeWidth} ${remainingHeightCableChamber}`,
              "type": "rectangle",
              "category": "cableChamber",
              "chamberType": "Cover",
              "top": false,
              "tool": "main",
              "side": false,
              "innerProfile": true,
              "ports": [{}],
              "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cable_CH.svg",
              "pos": `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber.pos.split(' ')[1]) + BusBarChamberHeight}`,
              'group': this.uniqueKey(),
              "glandData": { "properties": { "GlandPlateAThickness": "3.0mm", "view": "top" } },
              "page": `${this.currentOutGoingPage}`,
              "tire": "Outgoing",
              "join": "nextOutgoing"
            };
            const horizontalBusBar1 = {
              "uuid": "5432ceba1dad",
              "text": "Horizontal Busbar",
              "color": "#bdae91",
              "size": `${shapeWidth} 20`,
              "type": "square",
              "category": "busbary",
              "with": "mccb",
              "tool": "main",
              "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
              "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
              "pos": `${-1000 + baseFrameWidth} -1000`,
              "page": `${this.currentOutGoingPage}`,
              "tire": "Outgoing",
              "join": "nextOutgoing"
            }
            this.nodeDataArray.push(horizontalBusBar1);
            this.nodeDataArray.push(BusBarChamberInChemberTier);
            this.nodeDataArray.push(CableChamber);
            console.log(" this.nodeDataArray>>>>", this.nodeDataArray);


          }
          this.nodeDataArray.push(verticalBusBar);
          let arraySum = this.widthArray.reduce((acc, val) => acc + val, 0);
          console.log("arraySum", arraySum);
          // Check if the sum equals totalWidth
          if (arraySum !== totalWidth) {
            // Calculate the difference
            let difference = totalWidth - arraySum;
            console.log("totalWidth", totalWidth);
            console.log("difference", difference);
            // Add the difference to the array
            if (difference <= 2400) {
              this.widthArray.push(difference);
            }
          }
          const baseFrameElement = this.nodeDataArray.find(element => element.category === "outerProfile");
          console.log("baseFrameElement", baseFrameElement);
          if (baseFrameElement) {
            const sizeParts = baseFrameElement.size.split(' ');
            selectedMaxTierHeight = parseFloat(sizeParts[1]);
          }
          const baseFrameIndex = this.nodeDataArray.findIndex(element => element.category === "outerProfile");

          // If a Base Frame element was found, remove it from the array
          if (baseFrameIndex !== -1) {
            this.nodeDataArray.splice(baseFrameIndex, 1);
          }

          const initialPosX = -1000;  // Initial x position for the first BaseFrameRow
          const posY = -1100;         // Constant y position for all BaseFrameRows
          let currentPosX = initialPosX;  // Variable to track the current x position
          console.log("selectedMaxTierHeight", selectedMaxTierHeight);
          console.log("this.widthArray", this.widthArray);
          for (let i = 0; i < this.widthArray.length; i++) {
            const width = this.widthArray[i];
            console.log("this.widthArray[i]", this.widthArray[i]);

            // Create a new BaseFrameRow object
            const newBaseFrameRow = {
              uuid: this.uniqueKey(),  // Generate a unique UUID for each row as needed
              text: "Base Frame",
              color: "#bdae91",
              isGroup: true,
              size: `${width} ${selectedMaxTierHeight}`,
              type: "rectangle",
              category: "outerProfile",
              tool: "main",
              selectedOption: null,
              pos: `${currentPosX} ${posY}`,
              image: ".../../../../assets/media/icons/kikcad_2D_Icon_Base_Frame.svg",
              loc: `${currentPosX + 50} ${posY + 50}`,  // Adjusted loc based on pos
              tire: "Outgoing",
              page: `${this.currentOutGoingPage}`,
              join: "nextOutgoing"
            };

            // Push the new object to the nodeDataArray
            this.nodeDataArray.push(newBaseFrameRow);

            // Update the currentPosX for the next BaseFrameRow
            currentPosX += width;
          }
        } else {
          totalMccbRowHeight = shapeHeight;
          // Your existing logic for creating a single MccbRow here
          // Push the created MccbRow into the nodeDataArray
          this.nodeDataArray.push(MccbRow);
          console.log("baseFrameHeight", baseFrameHeight);
          const remainingHeight = baseFrameHeight - (totalMccbRowHeight + parseInt(BusBarChamber.size.split(' ')[1]));
          const ControlSection = {
            "uuid": "4279ceba1dad",
            "text": "Door",
            "color": "#bdae91",
            "size": `${shapeWidth} ${remainingHeight}`,
            "type": "square",
            "category": "door",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
            'pos': `${-1000 + baseFrameWidth} ${parseInt(MccbRow.pos.split(' ')[1]) + totalMccbRowHeight}`,
            'group': this.uniqueKey(),
            "page": `${this.currentOutGoingPage}`,
            "tire": "Outgoing",
            "join": "nextOutgoing"
          }
          const verticalBusBar1 = {
            "uuid": "9974ceba1dad",
            "text": "Vertical Busbar",
            "color": "#bdae91",
            "size": `20 ${totalMccbRowHeight}`,
            "type": "square",
            "category": "busbarx",
            "with": "mccb",
            "tool": "main",
            "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_VR.svg",
            "pos": `${-1000 + baseFrameWidth + (shapeWidth / 2)} -1100`,
            "page": `${this.currentOutGoingPage}`,
            "tire": "Outgoing",
            "join": "nextOutgoing"
          }
          this.nodeDataArray.push(ControlSection);
          this.nodeDataArray.push(verticalBusBar1);
          const baseFrameElement = this.nodeDataArray.find(element => element.category === "outerProfile");
          if (baseFrameElement) {
            const sizeParts = baseFrameElement.size.split(' '); // Split size string by whitespace
            baseFrameWidth = parseFloat(sizeParts[0]); // Parse the width part to a float
            baseFrameHeight = parseFloat(sizeParts[1]);
            if (!isNaN(baseFrameWidth)) {
              // Check if parsing was successful
              let baseWidth = shapeWidth + baseFrameWidth;
              totalWidth = baseWidth;
              this.oneBaseFrameWidth = baseWidth;
              if (this.oneBaseFrameWidth < 2400) {
                this.oneBaseFrameWidth = totalWidth
              } else {
                if (this.widthArray.length === 0) {  // Fixing the comparison operator to '==='
                  this.oneBaseFrameWidth = totalWidth - shapeWidth;
                  if (this.oneBaseFrameWidth <= 2400) {
                    this.widthArray.push(this.oneBaseFrameWidth);
                  } else {
                    // Calculate how many times 2400 fits into oneBaseFrameWidth
                    let fullTimes = Math.floor(this.oneBaseFrameWidth / 2400);
                    // Push 2400 fullTimes number of times
                    for (let i = 0; i < fullTimes; i++) {
                      this.widthArray.push(2400);
                    }
                    // Calculate the remaining part and push it if it's greater than 0
                    let remainder = this.oneBaseFrameWidth % 2400;
                    if (remainder > 0) {
                      this.widthArray.push(remainder);
                    }
                  }
                  this.oneBaseFrameWidth = 0;
                } else {
                  // If widthArray is not empty
                  let lastBaseFrameWidth = this.widthArray.reduce((acc, val) => acc + val, 0);
                  let difference = totalWidth - lastBaseFrameWidth - shapeWidth;
                  if (totalWidth - lastBaseFrameWidth > 2400) {
                    if (difference <= 2400) {
                      this.widthArray.push(difference);
                    }
                  }
                }
              }
              sizeParts[0] = baseWidth.toString(); // Update the first part of sizeParts array
              baseFrameElement.size = sizeParts.join(' ');


              // Update the value in the array
            } else {
              // Handle the case where width is not a valid number
              // For example:
              // shapeWidth += defaultValue; // Add a default value
            }
          }
          const BusBarChamberInChemberTier = {
            "uuid": "254134ba1dad",
            "text": "Busbar Chamber",
            "color": "#bdae91",
            "size": `${shapeWidth} ${BusBarChamberHeight}`,
            "type": "rectangle",
            "category": "busbarChamber",
            "top": false, "side": false,
            "innerProfile": false,
            "tool": "main",
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
            "pos": `${-1000 + baseFrameWidth} -1100`,
            'group': this.uniqueKey(),
            "page": `${this.currentOutGoingPage}`,
            "tire": "Outgoing",
            "join": "nextOutgoing"
          }
          const remainingHeightCableChamber = baseFrameHeight - parseInt(BusBarChamberInChemberTier.size.split(' ')[1]);
          const CableChamber = {
            "uuid": "6549ceba1dad",
            "text": "Cable Chamber",
            "color": "#bdae91",
            "size": `${shapeWidth} ${remainingHeightCableChamber}`,
            "type": "rectangle",
            "category": "cableChamber",
            "chamberType": "Cover",
            "top": false,
            "tool": "main",
            "side": false,
            "innerProfile": true,
            "ports": [{}],
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cable_CH.svg",
            "pos": `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber.pos.split(' ')[1]) + BusBarChamberHeight}`,
            'group': this.uniqueKey(),
            "glandData": { "properties": { "GlandPlateAThickness": "3.0mm", "view": "top" } },
            "page": `${this.currentOutGoingPage}`,
            "tire": "Outgoing",
            "join": "nextOutgoing"
          };
          const horizontalBusBar1 = {
            "uuid": "5432ceba1dad",
            "text": "Horizontal Busbar",
            "color": "#bdae91",
            "size": `${shapeWidth} 20`,
            "type": "square",
            "category": "busbary",
            "with": "mccb",
            "tool": "main",
            "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
            "pos": `${-1000 + baseFrameWidth} -1000`,
            "page": `${this.currentOutGoingPage}`,
            "tire": "Outgoing",
            "join": "nextOutgoing"
          }
          this.nodeDataArray.push(BusBarChamberInChemberTier);
          this.nodeDataArray.push(CableChamber);
          this.nodeDataArray.push(horizontalBusBar1);

          let arraySum = this.widthArray.reduce((acc, val) => acc + val, 0);

          // Check if the sum equals totalWidth
          if (arraySum !== totalWidth) {
            // Calculate the difference
            let difference = totalWidth - arraySum;

            // Add the difference to the array
            if (difference <= 2400) {
              this.widthArray.push(difference);
            }
          }
          if (baseFrameElement) {
            const sizeParts = baseFrameElement.size.split(' ');
            selectedMaxTierHeight = parseFloat(sizeParts[1]);
          }
          const baseFrameIndex = this.nodeDataArray.findIndex(element => element.category === "outerProfile");

          // If a Base Frame element was found, remove it from the array
          if (baseFrameIndex !== -1) {
            this.nodeDataArray.splice(baseFrameIndex, 1);
          }

          const initialPosX = -1000;  // Initial x position for the first BaseFrameRow
          const posY = -1100;         // Constant y position for all BaseFrameRows
          let currentPosX = initialPosX;  // Variable to track the current x position

          for (let i = 0; i < this.widthArray.length; i++) {
            const width = this.widthArray[i];
            console.log("this.widthArray[i]", this.widthArray[i]);
            // Create a new BaseFrameRow object
            const newBaseFrameRow = {
              uuid: this.uniqueKey(),  // Generate a unique UUID for each row as needed
              text: "Base Frame",
              color: "#bdae91",
              isGroup: true,
              size: `${width} ${selectedMaxTierHeight}`,
              type: "rectangle",
              category: "outerProfile",
              tool: "main",
              selectedOption: null,
              pos: `${currentPosX} ${posY}`,
              image: ".../../../../assets/media/icons/kikcad_2D_Icon_Base_Frame.svg",
              loc: `${currentPosX + 50} ${posY + 50}`,  // Adjusted loc based on pos
              tire: "Outgoing",
              page: `${this.currentOutGoingPage}`,
              join: "nextOutgoing"
            };

            // Push the new object to the nodeDataArray
            this.nodeDataArray.push(newBaseFrameRow);

            // Update the currentPosX for the next BaseFrameRow
            currentPosX += width;
          }
        }

        this.nodeDataArray.push(BusBarChamber);
        this.nodeDataArray.push(horizontalBusBar);

        this.selectedItems = this.nodeDataArray
        this.currentPage++
        this.showMCCB = false;
        this.showProjectDetails = true;
      }
    } else {
      let pictureWidth = Math.round(this.matchingRowMCCB.WIDTH / 50) * 50;
      let pictureHeight = Math.round(this.matchingRowMCCB.HEIGHT / 50) * 50;
      const ratedAmp = parseInt(this.matchingRowMCCB.RATED_AMP || "0"); // Provide a default value if null
      let higherAmpRow;

      // Find the row with the nearest higher ampere value
      if (this.matchingRowMCCB.ROTATION === 'Vertical') {
        for (let i = 0; i < this.CubiclesSizesVerticle.length; i++) {
          const row = this.CubiclesSizesVerticle[i];
          if (row.ampere >= ratedAmp) {
            higherAmpRow = row;
            break;
          }
        }
      } else if (this.matchingRowMCCB.ROTATION === 'Horizontal') {
        for (let i = 0; i < this.CubiclesSizesHorizontal.length; i++) {
          const row = this.CubiclesSizesHorizontal[i];
          // Check if ratedAmp is more than 800
          if (ratedAmp > 800) {
            higherAmpRow = this.CubiclesSizesHorizontal.find(r => r.ampere === 800) || null;
            break;
          }

          if (row.ampere >= ratedAmp) {
            higherAmpRow = row;
            break;
          }
        }
      }


      if (higherAmpRow) {
        // Set shapeWidth and shapeHeight to the values from the higherAmpRow
        const shapeWidth = higherAmpRow.width;
        const shapeHeight = higherAmpRow.height;

        const BusBarChamberElement = this.nodeDataArray.find(element => element.category === "busbarChamber");
        if (BusBarChamberElement) {
          const sizeParts = BusBarChamberElement.size.split(' '); // Split size string by whitespace
          BusBarChamberHeight = parseFloat(sizeParts[1]); // Parse the width part to a float
        }
        // Set these values to the properties in your component if needed
        this.matchingRowMCCB['cubicleWidth'] = shapeWidth;
        this.matchingRowMCCB['cubicleHeight'] = shapeHeight;
        let selectedMaxTierHeight = this.selectedMaxTierHeight ?? 0;
        let baseFrameWidth = 0;
        let totalWidth = 0;
        let baseFrameHeight = 0;
        let totalBaseFrameWidth = 0;
        let LastBaseFrameWidth = 0;
        let maximumMCCBInTier = 0;
        let TotalMCCBTiers = 0;
        let NewMCCBCountAddBottom = 0
        console.log("this.nodeDataArray", this.nodeDataArray);
        if (this.nodeDataArray && this.nodeDataArray.length > 0) {
          // Check if an element with the text "Base Frame" exists
          const baseFrameElement = this.nodeDataArray.find(element => element.category === "outerProfile");
          if (baseFrameElement) {
            const sizeParts = baseFrameElement.size.split(' ');
            baseFrameHeight = parseFloat(sizeParts[1]);

          }

        }
        if (this.AdditionalDoorDataArray.length > 0) {
          console.log("this.AdditionalDoorDataArray", this.AdditionalDoorDataArray);
          console.log("shapeHeight", shapeHeight);

          // Extract the height from the size attribute (assuming size is "width height")
          const sizeParts = this.AdditionalDoorDataArray[0].size.split(" ");
          const doorHeight = parseInt(sizeParts[1], 10);
          const doorWidth = parseInt(sizeParts[0], 10);
          const posParts = this.AdditionalDoorDataArray[0].pos.split(" ");
          const pos0 = parseInt(posParts[0], 10);
          const pos1 = parseInt(posParts[1], 10);



          // Check if the door height is greater than shapeHeight
          if (doorHeight >= shapeHeight) {
            console.log("doorHeight", doorHeight);
            console.log("shapeHeight", shapeHeight);
            this.AdditionalDoorDataArray = [];
            // Calculate how many times shapeHeight fits into doorHeight
            NewMCCBCountAddBottom = Math.floor(doorHeight / shapeHeight);
            console.log("NewMCCBCountAddBottom", NewMCCBCountAddBottom);
            const MccbRow = {
              'uuid': '9a4b5c6d7e8f',
              'text': 'MCCB',
              'color': '#bdae91',
              'size': `${shapeWidth} ${shapeHeight}`, // Update size
              'tool': 'main',
              'type': 'rectangle',
              'category': 'electricalMCCB',
              'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
              "pos": `${pos0} ${pos1}`,
              'group': this.uniqueKey(),
              'properties': { ...this.matchingRowMCCB },
              "ports": [{}],
              'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
              'shapeSize': { width: doorWidth, height: shapeHeight }, // Update shapeSize
              'innerProfile': false,
              "page": `${this.currentOutGoingPage}`,
              "tire": "Outgoing",
              "join": "nextOutgoing",
              "mccbcont": `${this.numberOfOutgoing}`
            };
            MccbRow.properties.imagePath = MccbRow.properties.ImagePath;
            // Loop the calculated number of times
            let CurrenttotalMccbRowHeight = 0;
            let previousMccbRowSize = 0;
            let lastMCCBPos = 0;
            if (NewMCCBCountAddBottom > this.numberOfOutgoing) {
              for (let i = 0; i < this.numberOfOutgoing; i++) {
                const currentMccbRow = { ...MccbRow }; // Create a copy of MccbRow
                currentMccbRow.pos = `${pos0} ${pos1 + previousMccbRowSize}`;

                // Push the created MccbRow into the nodeDataArray
                this.nodeDataArray.push(currentMccbRow);

                // Update previousMccbRowSize for the next iteration
                previousMccbRowSize += currentMccbRow.shapeSize.height;
                lastMCCBPos = pos1 + previousMccbRowSize;
              }
              this.numberOfOutgoing = 0;
            } else {
              for (let i = 0; i < NewMCCBCountAddBottom; i++) {
                const currentMccbRow = { ...MccbRow }; // Create a copy of MccbRow
                currentMccbRow.pos = `${pos0} ${pos1 + previousMccbRowSize}`;

                // Push the created MccbRow into the nodeDataArray
                this.nodeDataArray.push(currentMccbRow);

                // Update previousMccbRowSize for the next iteration
                previousMccbRowSize += currentMccbRow.shapeSize.height;
                lastMCCBPos = pos1 + previousMccbRowSize;
              }
              this.numberOfOutgoing = this.numberOfOutgoing - NewMCCBCountAddBottom;
            }


            console.log(" previousMccbRowSize", previousMccbRowSize)
            console.log("pos1 ", pos1)
            console.log("pos1 + previousMccbRowSize", pos1 + previousMccbRowSize)
            // After the loop, calculate the remaining height
            const filteredNodes = this.nodeDataArray.filter(node => {
              const nodePosParts = node.pos.split(" ");
              if (node.category !== "outerProfile" && node.category !== "busbary" && node.category !== "busbarx" && node.category !== "door") {
                return parseInt(nodePosParts[0], 10) === pos0;
              } else {
                return false;
              }
            });
            console.log("filteredNodes", filteredNodes);
            const totalHeight = filteredNodes.reduce((sum, node) => {
              const nodeSizeParts = node.size.split(" ");
              return sum + parseInt(nodeSizeParts[1], 10);
            }, 0);
            console.log("totalHeight", totalHeight);

            const remainingHeight = baseFrameHeight - totalHeight;
            console.log("remainingHeight", remainingHeight);

            this.nodeDataArray = this.nodeDataArray.filter(item => {
              const itemPos = item.pos.split(' ')[0]; // Extract pos[0]
              return !(item.category === "door" && itemPos === `${pos0}`);
            });
            console.log("pos0", pos0);

            if (remainingHeight > 0) {

              console.log('Remaining Height:', remainingHeight);
              const Door1 = {
                "uuid": "4279ceba1dad",
                "text": "Door",
                "color": "#bdae91",
                "size": `${doorWidth} ${remainingHeight}`,
                "type": "square",
                "category": "door",
                "tool": "main",
                "top": false,
                "side": false,
                "innerProfile": false,
                "ports": [{}],
                "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
                'pos': `${pos0} ${pos1 + previousMccbRowSize}`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing"
              }
              this.nodeDataArray.push(Door1);
              this.DoorShiftUndertheTier(pos0, selectedMaxTierHeight);
              if (remainingHeight === 100) {
                this.adjustLastPushedDoor()
              } else {
                this.AdditionalDoorDataArray.push(Door1);
              }
            }

            const mccbChangeTierallElemnts = this.nodeDataArray.filter(node => {
              const nodePosParts = node.pos.split(" ");
              if (node.category !== "outerProfile" && node.category !== "busbarx") {
                return parseInt(nodePosParts[0], 10) === pos0;
              } else {
                return false;
              }
            });
            console.log("mccbChangeTierallElemnts", mccbChangeTierallElemnts);
            // Step 1: Filter the elements that have category "electricalMCCB"
            const mccbElements = mccbChangeTierallElemnts.filter(node => node.category === "electricalMCCB");

            // Step 2: Find the maximum size[0] value from the "electricalMCCB" elements
            const maxSize0 = Math.max(...mccbElements.map(node => parseInt(node.size.split(" ")[0], 10)));

            // Step 3: Set the maximum size[0] value to all elements in filteredNodes
            mccbChangeTierallElemnts.forEach(mccbChangeTierallElemntsnode => {
              const sizeParts = mccbChangeTierallElemntsnode.size.split(" "); // Split the size string
              sizeParts[0] = maxSize0.toString(); // Set the size[0] to the maximum value
              mccbChangeTierallElemntsnode.size = sizeParts.join(" "); // Join the parts back into a string

              // Update cubicleWidth if the category is "electricalMCCB"
              if (mccbChangeTierallElemntsnode.category === "electricalMCCB") {
                mccbChangeTierallElemntsnode.properties.cubicleWidth = maxSize0; // Set cubicleWidth to size[0]
              }
            });

            // Now all elements in filteredNodes will have the maximum size[0] value
            console.log("Updated mccbChangeTierallElemnts:", mccbChangeTierallElemnts);


            // Step 4: Update the original this.nodeDataArray based on matching category and pos
            this.nodeDataArray = this.nodeDataArray.map(node => {
              // Check if the node matches in category and pos with the filteredNodes
              const matchingNode = mccbChangeTierallElemnts.find(filteredNode =>
                filteredNode.category === node.category && filteredNode.pos === node.pos
              );
              if (matchingNode) {
                console.log("matchingNode", matchingNode);
                return matchingNode; // Return the updated node from filteredNodes
              }
              return node; // Return the original node if it doesn't need updating
            });

            // Now all elements in filteredNodes will have the maximum size[0] value
            console.log("Updated this.nodeDataArray:", this.nodeDataArray);

            const BusBarChamberMCCBChangingPlace = mccbChangeTierallElemnts.filter(node => node.category === "busbarChamber");
            let busbarChamberWidthmccbChangepos;
            let nextbusbarChamberWidth;
            // Loop through the filtered "busbarChamber" nodes to calculate StartPositionX and EndPositionX
            BusBarChamberMCCBChangingPlace.forEach(busBarNode => {
              const busBarPosParts = busBarNode.pos.split(" ");
              const busBarSizeParts = busBarNode.size.split(" ");

              const StartPositionX = parseInt(busBarPosParts[0], 10); // Extract pos[0]
              busbarChamberWidthmccbChangepos = parseInt(busBarSizeParts[0], 10)
              const EndPositionX = StartPositionX + busbarChamberWidthmccbChangepos; // Calculate EndPositionX

              // Find nodes in this.nodeDataArray with pos[0] between StartPositionX and EndPositionX
              this.nodeDataArray.forEach(node => {
                const nodePosParts = node.pos.split(" ");
                const nodePosX = parseInt(nodePosParts[0], 10);
                const nodeSize = busBarNode.size.split(" ");
                let nodeWidth = parseInt(nodeSize[0], 10);
                // Check if the node category is "busbarChamber" or "cableChamber"
                if (
                  (node.category === "busbarChamber" || node.category === "cableChamber" || node.category === "busbary") &&
                  nodePosX > StartPositionX && nodePosX < EndPositionX
                ) {

                  if
                    (node.category === "busbarChamber") {
                    const nodeSizeParts = node.size.split(" ");
                    nextbusbarChamberWidth = parseInt(nodeSizeParts[0], 10);

                    console.log('node', node);
                    console.log('nodeWidth', nodeWidth);
                  }
                  // Update pos[0] to EndPositionX
                  nodePosParts[0] = EndPositionX.toString();
                  node.pos = nodePosParts.join(" "); // Rejoin the position parts back into the pos string
                }
              });
            });
            console.log("busbarChamberWidthmccbChangepos", busbarChamberWidthmccbChangepos);
            console.log("nextbusbarChamberWidth", nextbusbarChamberWidth);
            console.log("busbarChamberWidthmccbChangepos+nextbusbarChamberWidth", busbarChamberWidthmccbChangepos + nextbusbarChamberWidth);
            // Filter mccbChangeTierBaseFrame based on "outerProfile" and position match
            const mccbChangeTierBaseFrame = this.nodeDataArray.filter(node => {
              const nodePosParts = node.pos.split(" ");
              if (node.category === "outerProfile") {
                return parseInt(nodePosParts[0], 10) === pos0;
              } else {
                return false;
              }
            });

            // Calculate the new width
            const newWidth = busbarChamberWidthmccbChangepos + nextbusbarChamberWidth;

            // Update the size[0] for each node in mccbChangeTierBaseFrame
            mccbChangeTierBaseFrame.forEach(baseFrameNode => {
              const sizeParts = baseFrameNode.size.split(" "); // Split size into parts
              sizeParts[0] = newWidth.toString(); // Update size[0] with the new width
              baseFrameNode.size = sizeParts.join(" "); // Join the size parts back into a string
            });

            // Update the original this.nodeDataArray with the modified mccbChangeTierBaseFrame nodes
            this.nodeDataArray = this.nodeDataArray.map(node => {
              // Check if the node matches any of the updated mccbChangeTierBaseFrame nodes
              const matchingNode = mccbChangeTierBaseFrame.find(baseFrameNode =>
                baseFrameNode.category === node.category && baseFrameNode.pos === node.pos
              );

              if (matchingNode) {
                return matchingNode; // Return the updated node
              }
              return node; // Return the original node if it doesn't match
            });

          } else {
            // If the door height is not greater than shapeHeight, push the data to nodeDataArray
            this.nodeDataArray.push(this.AdditionalDoorDataArray[0]);
            console.log('Added to nodeDataArray:', this.AdditionalDoorDataArray[0]);
            this.AdditionalDoorDataArray = [];

          }
        } console.log(' this.nodeDataArray', this.nodeDataArray)
        this.nodeDataArray.forEach(element => {
          if (element.category === "outerProfile") {
            console.log('element', element)
            const sizeParts = element.size.split(' '); // Split size string by whitespace
            let width = parseFloat(sizeParts[0]); // Parse the width part to a float
            console.log("Original width>>>", width);

            // If width is negative, update it to positive
            if (width < 0) {
              width = Math.abs(width); // Convert to positive
              sizeParts[0] = width.toString(); // Update the width part in the size string
              element.size = sizeParts.join(' '); // Update the size string in the node
              console.log("Updated size>>>", element.size);
            }

            baseFrameHeight = parseFloat(sizeParts[1]); // Parse the height part
            selectedMaxTierHeight = baseFrameHeight;

            if (!isNaN(width)) {
              totalBaseFrameWidth += width; // Sum up the widths
              console.log("totalBaseFrameWidth", totalBaseFrameWidth);
            }
          }
        });

        console.log("totalBaseFrameWidth>>>>>", totalBaseFrameWidth);

        const LastbaseFrameElement = this.nodeDataArray.slice().reverse().find(element => element.category === "outerProfile");
        console.log("LastbaseFrameElement", LastbaseFrameElement);
        if (LastbaseFrameElement) {
          const sizeParts = LastbaseFrameElement.size.split(' ');
          const width = parseFloat(sizeParts[0]);
          console.log("width", width);
          maximumMCCBInTier = Math.floor((selectedMaxTierHeight - BusBarChamberHeight) / shapeHeight);
          console.log("maximumMCCBInTier", maximumMCCBInTier);
          console.log("this.numberOfOutgoing", this.numberOfOutgoing);
          TotalMCCBTiers = Math.ceil(this.numberOfOutgoing / maximumMCCBInTier);
          console.log("TotalMCCBTiers", TotalMCCBTiers);
          const busbarChamberElements = this.nodeDataArray
            .filter(element => element.category === "busbarChamber") // Filter elements with text "Busbar Chamber"
            .filter((element, index, self) =>
              // Ensure the position is unique by checking its index in the filtered array
              self.findIndex(e => e.pos === element.pos) === index
            );
          console.log('Busbar Chamber Elements:', busbarChamberElements);

          // Calculate total width of existing Busbar Chambers
          const BusbarChambertotalWidth = busbarChamberElements.reduce((sum, element) => {
            const width = parseInt(element.size?.split(' ')[0], 10) || 0; // Split the string and parse the first number as width
            return sum + width;
          }, 0);

          console.log('Total Width of Busbar Chambers:', BusbarChambertotalWidth);


          const DoorPosX = this.nodeDataArray
            .filter((item) => item.category === "electricalMCCB") // Filter elements with category "electricalMCCB"
            .reduce((maxPosX, currentItem) => {
              const currentPosX = Number(currentItem.pos.split(" ")[0]); // Extract pos[0] as a number
              return currentPosX > maxPosX ? currentPosX : maxPosX; // Find the maximum pos[0]
            }, Number.NEGATIVE_INFINITY); // Initialize with the smallest possible number

          console.log("Maximum pos[0] for electricalMCCB:", DoorPosX);


          const cableChamberPosX = this.nodeDataArray
            .filter((item) => item.category === "cableChamber") // Filter elements with category "electricalMCCB"
            .reduce((maxPosX, currentItem) => {
              const currentPosX = Number(currentItem.pos.split(" ")[0]); // Extract pos[0] as a number
              return currentPosX > maxPosX ? currentPosX : maxPosX; // Find the maximum pos[0]
            }, Number.NEGATIVE_INFINITY); // Initialize with the smallest possible number

          console.log("Maximum pos[0] for cableChamberPosX:", cableChamberPosX);


          let cumulativeXpos = -1000 + BusbarChambertotalWidth; // Starting position for Xpos
          let RemainsMCCBcount = 0;
          console.log("cumulativeXpos", cumulativeXpos);
          for (let i = 0; i < TotalMCCBTiers; i++) {

            let busbarChamberData = this.nodeDataArray
              .filter((item) => item.category === "busbarChamber") // Filter elements with category "busbarChamber"
              .reduce(
                (maxData, currentItem) => {
                  const currentPosX = Number(currentItem.pos.split(" ")[0]); // Extract pos[0] as a number
                  const currentSizeX = Number(currentItem.size.split(" ")[0]); // Extract size[0] as a number

                  if (currentPosX > maxData.maxPosX) {
                    // Update maxPosX and its corresponding sizeX
                    return { maxPosX: currentPosX, maxSizeX: currentSizeX };
                  }

                  return maxData; // Keep the existing maximum if currentPosX is smaller
                },
                { maxPosX: Number.NEGATIVE_INFINITY, maxSizeX: 0 } // Initialize with default values
              );

            let StartPositionNextTier = busbarChamberData.maxPosX + busbarChamberData.maxSizeX;

            console.log("Maximum pos[0] for busbarChamber:", busbarChamberData.maxPosX);
            console.log("Maximum size[0] for corresponding busbarChamber:", busbarChamberData.maxSizeX);
            console.log("StartPositionNextTier:", StartPositionNextTier);
            const BusBarChamber1 = {
              "uuid": "254134ba1dad",
              "text": "Busbar Chamber",
              "color": "#bdae91",
              "size": `${shapeWidth} ${BusBarChamberHeight}`,
              "type": "rectangle",
              "category": "busbarChamber",
              "top": false, "side": false,
              "innerProfile": false,
              "tool": "main",
              "ports": [{}],
              "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
              "pos": `${StartPositionNextTier} -1100`,
              'group': this.uniqueKey(),
              "page": `${this.currentOutGoingPage}`,
              "tire": "Outgoing",
              "join": "nextOutgoing"
            }
            this.nodeDataArray.push(BusBarChamber1);

            const MccbRow = {
              'uuid': '9a4b5c6d7e8f',
              'text': 'MCCB',
              'color': '#bdae91',
              'size': `${shapeWidth} ${shapeHeight}`, // Update size
              'tool': 'main',
              'type': 'rectangle',
              'category': 'electricalMCCB',
              'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
              "pos": `${StartPositionNextTier} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight}`,
              'group': this.uniqueKey(),
              'properties': { ...this.matchingRowMCCB },
              "ports": [{}],
              'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
              'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
              'innerProfile': false,
              "page": `${this.currentOutGoingPage}`,
              "tire": "Outgoing",
              "join": "nextOutgoing",
              "mccbcont": `${this.numberOfOutgoing}`
            };
            MccbRow.properties.imagePath = MccbRow.properties.ImagePath;
            let previousMccbRowSize = 0;
            let CurrenttotalMccbRowHeight = 0;
            let addCableChamber = false;
            let totalMccbRowHeight = 0;
            let totalMccbCountOFFirstTier = 0;
            for (let j = 0; j < this.numberOfOutgoing; j++) {
              const currentMccbRow = { ...MccbRow }; // Create a copy of MccbRow

              // Adjust pos based on previousMccbRowSize
              currentMccbRow.pos = `${cumulativeXpos} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight + previousMccbRowSize}`;
              CurrenttotalMccbRowHeight += currentMccbRow.shapeSize.height;
              // Push the created MccbRow into the nodeDataArray
              if (CurrenttotalMccbRowHeight <= baseFrameHeight - parseInt(BusBarChamber1.size.split(' ')[1])) {
                this.nodeDataArray.push(currentMccbRow);
                totalMccbRowHeight += currentMccbRow.shapeSize.height;
                totalMccbCountOFFirstTier++;
              } else {
                addCableChamber = true;
              }


              // Update previousMccbRowSize for the next iteration
              previousMccbRowSize += currentMccbRow.shapeSize.height;
            }
            console.log("totalMccbCountOFFirstTier", totalMccbCountOFFirstTier);
            this.numberOfOutgoing = this.numberOfOutgoing - totalMccbCountOFFirstTier;
            const horizontalBusBar1 = {
              "uuid": "5432ceba1dad",
              "text": "Horizontal Busbar",
              "color": "#bdae91",
              "size": `${shapeWidth} 20`,
              "type": "square",
              "category": "busbary",
              "with": "mccb",
              "tool": "main",
              "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
              "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
              "pos": `${StartPositionNextTier} -1000`,
              "page": `${this.currentOutGoingPage}`,
              "tire": "Outgoing",
              "join": "nextOutgoing"
            }
            let verticalBusBar1height = 0
            if (selectedMaxTierHeight > totalMccbRowHeight + BusBarChamberHeight) {
              verticalBusBar1height = totalMccbRowHeight - BusBarChamberHeight;
            } else {
              verticalBusBar1height = totalMccbRowHeight;
            }
            console.log("verticalBusBar1height", verticalBusBar1height);
            const verticalBusBar1 = {
              "uuid": "9974ceba1dad",
              "text": "Vertical Busbar",
              "color": "#bdae91",
              "size": `20 ${verticalBusBar1height}`,
              "type": "square",
              "category": "busbarx",
              "with": "mccb",
              "tool": "main",
              "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
              "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_VR.svg",
              "pos": `${StartPositionNextTier + (shapeWidth / 2)} -1100`,
              "page": `${this.currentOutGoingPage}`,
              "tire": "Outgoing",
              "join": "nextOutgoing"
            }

            let remainingHeightToDoor = baseFrameHeight - (parseInt(BusBarChamber1.size.split(' ')[1]) + totalMccbRowHeight);

            this.nodeDataArray.push(horizontalBusBar1);
            this.nodeDataArray.push(verticalBusBar1);
            const Door1 = {
              "uuid": "4279ceba1dad",
              "text": "Door",
              "color": "#bdae91",
              "size": `${shapeWidth} ${remainingHeightToDoor}`,
              "type": "square",
              "category": "door",
              "tool": "main",
              "top": false,
              "side": false,
              "innerProfile": false,
              "ports": [{}],
              "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
              'pos': `${StartPositionNextTier} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight + totalMccbRowHeight}`,
              'group': this.uniqueKey(),
              "page": `${this.currentOutGoingPage}`,
              "tire": "Outgoing",
              "join": "nextOutgoing"
            }
            console.log("totalMccbRowHeight", totalMccbRowHeight);
            const BusBarChamberInChemberTier = {
              "uuid": "254134ba1dad",
              "text": "Busbar Chamber",
              "color": "#bdae91",
              "size": `${shapeWidth} ${BusBarChamberHeight}`,
              "type": "rectangle",
              "category": "busbarChamber",
              "top": false, "side": false,
              "innerProfile": false,
              "tool": "main",
              "ports": [{}],
              "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
              "pos": `${StartPositionNextTier + shapeWidth} -1100`,
              'group': this.uniqueKey(),
              "page": `${this.currentOutGoingPage}`,
              "tire": "Outgoing",
              "join": "nextOutgoing"
            }
            const remainingHeightCableChamber = baseFrameHeight - parseInt(BusBarChamberInChemberTier.size.split(' ')[1]);
            const CableChamber = {
              "uuid": "6549ceba1dad",
              "text": "Cable Chamber",
              "color": "#bdae91",
              "size": `${shapeWidth} ${remainingHeightCableChamber}`,
              "type": "rectangle",
              "category": "cableChamber",
              "chamberType": "Cover",
              "top": false,
              "tool": "main",
              "side": false,
              "innerProfile": true,
              "ports": [{}],
              "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cable_CH.svg",
              "pos": `${StartPositionNextTier + shapeWidth} ${parseInt(BusBarChamberInChemberTier.pos.split(' ')[1]) + BusBarChamberHeight}`,
              'group': this.uniqueKey(),
              "glandData": { "properties": { "GlandPlateAThickness": "3.0mm", "view": "top" } },
              "page": `${this.currentOutGoingPage}`,
              "tire": "Outgoing",
              "join": "nextOutgoing"
            };
            const horizontalBusBarInChemberTier = {
              "uuid": "5432ceba1dad",
              "text": "Horizontal Busbar",
              "color": "#bdae91",
              "size": `${shapeWidth} 20`,
              "type": "square",
              "category": "busbary",
              "with": "mccb",
              "tool": "main",
              "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
              "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
              "pos": `${StartPositionNextTier + shapeWidth} -1000`,
              "page": `${this.currentOutGoingPage}`,
              "tire": "Outgoing",
              "join": "nextOutgoing"
            }
            console.log("cumulativeXpos", cumulativeXpos);
            this.nodeDataArray.push(BusBarChamberInChemberTier);
            this.nodeDataArray.push(CableChamber);
            // this.nodeDataArray.push(DoorinCableChamber);
            this.nodeDataArray.push(horizontalBusBarInChemberTier);
            console.log('cumulativeXpos', cumulativeXpos)
            if (remainingHeightToDoor > 0) {
              this.nodeDataArray.push(Door1);
              if (remainingHeightToDoor === 100) {
                this.DoorShiftUndertheTier(StartPositionNextTier, selectedMaxTierHeight);

                this.DoorShiftUndertheTier(StartPositionNextTier + shapeWidth, selectedMaxTierHeight);
                this.adjustLastPushedDoor()
              }
            }
            cumulativeXpos += shapeWidth * 2;

          }
          RemainsMCCBcount = this.numberOfOutgoing;
          console.log('RemainsMCCBcount', RemainsMCCBcount);
          if (RemainsMCCBcount > 0) {

            let lastBusbarChamberPositionx = 0;
            const BusbarChamberElement = this.nodeDataArray.slice().reverse().find(element => element.category === "busbarChamber");
            if (BusbarChamberElement) {
              const MccbRow = {
                'uuid': '9a4b5c6d7e8f',
                'text': 'MCCB',
                'color': '#bdae91',
                'size': `${shapeWidth} ${shapeHeight}`, // Update size
                'tool': 'main',
                'type': 'rectangle',
                'category': 'electricalMCCB',
                'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
                "pos": `${-1000} ${1000}`,
                'group': this.uniqueKey(),
                'properties': { ...this.matchingRowMCCB },
                "ports": [{}],
                'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
                'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
                'innerProfile': false,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing",
                "mccbcont": `${this.numberOfOutgoing}`
              };
              MccbRow.properties.imagePath = MccbRow.properties.ImagePath;
              const positionParts = BusbarChamberElement.pos.split(' ');
              lastBusbarChamberPositionx = parseFloat(positionParts[0]);
              const BusBarChamber1 = {
                "uuid": "254134ba1dad",
                "text": "Busbar Chamber",
                "color": "#bdae91",
                "size": `${shapeWidth} ${BusBarChamberHeight}`,
                "type": "rectangle",
                "category": "busbarChamber",
                "top": false, "side": false,
                "innerProfile": false,
                "tool": "main",
                "ports": [{}],
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
                "pos": `${lastBusbarChamberPositionx + shapeWidth} -1100`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing"
              }
              this.nodeDataArray.push(BusBarChamber1);
              let previousMccbRowSize = 0;
              let CurrenttotalMccbRowHeight = 0;
              let addCableChamber = false;
              let totalMccbRowHeight = 0;
              let totalMccbCountOFFirstTier = 0;
              for (let j = 0; j < RemainsMCCBcount; j++) {
                const currentMccbRow = { ...MccbRow }; // Create a copy of MccbRow

                // Adjust pos based on previousMccbRowSize
                currentMccbRow.pos = `${lastBusbarChamberPositionx + shapeWidth} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight + previousMccbRowSize}`;
                CurrenttotalMccbRowHeight += currentMccbRow.shapeSize.height;
                // Push the created MccbRow into the nodeDataArray
                if (CurrenttotalMccbRowHeight <= baseFrameHeight - parseInt(BusBarChamber1.size.split(' ')[1])) {
                  this.nodeDataArray.push(currentMccbRow);
                  totalMccbRowHeight += currentMccbRow.shapeSize.height;
                  totalMccbCountOFFirstTier++;
                } else {
                  addCableChamber = true;
                }


                // Update previousMccbRowSize for the next iteration
                previousMccbRowSize += currentMccbRow.shapeSize.height;
              }
              const horizontalBusBar1 = {
                "uuid": "5432ceba1dad",
                "text": "Horizontal Busbar",
                "color": "#bdae91",
                "size": `${shapeWidth} 20`,
                "type": "square",
                "category": "busbary",
                "with": "mccb",
                "tool": "main",
                "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
                "pos": `${lastBusbarChamberPositionx + shapeWidth} -1000`,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing"
              }

              const verticalBusBar1 = {
                "uuid": "9974ceba1dad",
                "text": "Vertical Busbar",
                "color": "#bdae91",
                "size": `20 ${totalMccbRowHeight}`,
                "type": "square",
                "category": "busbarx",
                "with": "mccb",
                "tool": "main",
                "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_VR.svg",
                "pos": `${lastBusbarChamberPositionx + shapeWidth + shapeWidth / 2} -1100`,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing"
              }
              let remainingHeightForRemainingDoor = baseFrameHeight - (BusBarChamberHeight + totalMccbRowHeight);
              const Door1 = {
                "uuid": "4279ceba1dad",
                "text": "Door",
                "color": "#bdae91",
                "size": `${shapeWidth} ${remainingHeightForRemainingDoor}`,
                "type": "square",
                "category": "door",
                "tool": "main",
                "top": false,
                "side": false,
                "innerProfile": false,
                "ports": [{}],
                "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
                'pos': `${lastBusbarChamberPositionx + shapeWidth} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight + previousMccbRowSize}`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing"
              }
              if (remainingHeightForRemainingDoor > 0) {
                this.nodeDataArray.push(Door1);
                if (remainingHeightForRemainingDoor === 100) {
                  this.adjustLastPushedDoor()
                }
              }
              this.nodeDataArray.push(horizontalBusBar1);
              this.nodeDataArray.push(verticalBusBar1);
              const BusBarChamberInChemberTier = {
                "uuid": "254134ba1dad",
                "text": "Busbar Chamber",
                "color": "#bdae91",
                "size": `${shapeWidth} ${BusBarChamberHeight}`,
                "type": "rectangle",
                "category": "busbarChamber",
                "top": false, "side": false,
                "innerProfile": false,
                "tool": "main",
                "ports": [{}],
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
                "pos": `${lastBusbarChamberPositionx + shapeWidth * 2} -1100`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing"
              }
              const remainingHeightCableChamber = baseFrameHeight - parseInt(BusBarChamberInChemberTier.size.split(' ')[1]);
              const CableChamber = {
                "uuid": "6549ceba1dad",
                "text": "Cable Chamber",
                "color": "#bdae91",
                "size": `${shapeWidth} ${remainingHeightCableChamber}`,
                "type": "rectangle",
                "category": "cableChamber",
                "chamberType": "Cover",
                "top": false,
                "tool": "main",
                "side": false,
                "innerProfile": true,
                "ports": [{}],
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cable_CH.svg",
                "pos": `${lastBusbarChamberPositionx + shapeWidth * 2} ${parseInt(BusBarChamberInChemberTier.pos.split(' ')[1]) + BusBarChamberHeight}`,
                'group': this.uniqueKey(),
                "glandData": { "properties": { "GlandPlateAThickness": "3.0mm", "view": "top" } },
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing"
              };
              const horizontalBusBarInChemberTier = {
                "uuid": "5432ceba1dad",
                "text": "Horizontal Busbar",
                "color": "#bdae91",
                "size": `${shapeWidth} 20`,
                "type": "square",
                "category": "busbary",
                "with": "mccb",
                "tool": "main",
                "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
                "pos": `${lastBusbarChamberPositionx + shapeWidth * 2} -1000`,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "join": "nextOutgoing"
              }
              this.nodeDataArray.push(BusBarChamberInChemberTier);
              this.nodeDataArray.push(CableChamber);
              this.nodeDataArray.push(horizontalBusBarInChemberTier);


            }
          }
          let LastbaseFrameElementPosX = parseInt(LastbaseFrameElement.pos.split(' ')[0]) + parseInt(LastbaseFrameElement.size.split(' ')[0])
          const LastBusbarChamberElement = this.nodeDataArray.slice().reverse().find(element => element.category === "busbarChamber");
          if (LastBusbarChamberElement) {
            let LastBusbarChamberElementPosX = parseInt(LastBusbarChamberElement.pos.split(' ')[0]) + parseInt(LastBusbarChamberElement.size.split(' ')[0]);;
            let fullWidthOfNewOutCommers = LastBusbarChamberElementPosX - LastbaseFrameElementPosX;
            this.widthArrayNextOutgoing = []
            if (fullWidthOfNewOutCommers <= 2400) {
              this.widthArrayNextOutgoing.push(fullWidthOfNewOutCommers);
            } else {
              // Calculate how many 2400 values are needed
              while (fullWidthOfNewOutCommers > 2400) {
                this.widthArrayNextOutgoing.push(2400);
                fullWidthOfNewOutCommers -= 2400;
              }
              // Push the remaining value if it's greater than 0
              if (fullWidthOfNewOutCommers > 0) {
                this.widthArrayNextOutgoing.push(fullWidthOfNewOutCommers);
              }
            }
            const initialPosX = LastbaseFrameElementPosX;  // Initial x position for the first BaseFrameRow
            const posY = -1100;         // Constant y position for all BaseFrameRows
            let currentPosX = initialPosX;  // Variable to track the current x position

            for (let i = 0; i < this.widthArrayNextOutgoing.length; i++) {
              const width = this.widthArrayNextOutgoing[i];

              // Create a new BaseFrameRow object
              const newBaseFrameRow = {
                uuid: this.uniqueKey(),  // Generate a unique UUID for each row as needed
                text: "Base Frame",
                color: "#bdae91",
                isGroup: true,
                size: `${width} ${selectedMaxTierHeight}`,
                type: "rectangle",
                category: "outerProfile",
                tool: "main",
                selectedOption: null,
                pos: `${currentPosX} ${posY}`,
                image: ".../../../../assets/media/icons/kikcad_2D_Icon_Base_Frame.svg",
                loc: `${currentPosX + 50} ${posY + 50}`, // Adjusted loc based on pos
                tire: "Outgoing",
                page: `${this.currentOutGoingPage}`,
                join: "nextOutgoing"
              };

              // Push the new object to the nodeDataArray
              this.nodeDataArray.push(newBaseFrameRow);

              // Update the currentPosX for the next BaseFrameRow
              currentPosX += width;
            }
          }
          this.selectedItems = this.nodeDataArray

        }
        this.currentPage++
        this.showMCCB = false;
        this.showProjectDetails = true;
      }
    }
    this.animateNext = true;
    this.animatePrevious = false;
    this.resetAnimationFlags();
    this.addBusbarMccb();
    this.addmccbampRow();
    this.addPorts();
    // this.removeDuplicateElements();
    if (this.showProjectDetails) {
      console.log('set values')
      this.setDefultValueOf();
    }
    this.addMissingVerticalBusbar();
    console.log('this.nodeDataArray in nextOutgoing>>>', this.nodeDataArray)
    this.selectedItems = this.nodeDataArray;

  }

  onSumbit(withBack: boolean = false) {
    this.hasFormErrors = false;
    const controls = this.projectForm.controls;
    /** check form */
    if (this.projectForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      this.hasFormErrors = true;
      return;
    }
    this.associateProfilesWithOuterProfile();
    const createdProject = this.prepareNewProject();
    this.addProject(createdProject, withBack);
    this.addmccbampRow();
    this.addBusbarMccb();
    this.removeDuplicateElements();
    this.setelmntGroupOuterProfile();
    this.configBusbar();
  }
  prepareNewProject(): Project {
    if (this.myControl.value) {
      this.getTypedCustomerData(this.myControl.value);
    }

    const controls = this.projectForm.controls;
    const _project = new Project();
    _project.clear();
    _project.uuid = this.typeUtil.generateUUID();
    _project.address = controls.address.value;
    _project.title = controls.title.value;
    _project.designer = this.userName;
    _project.approvedBy = controls.approvedBy.value;
    // Add a null check for this.customerData
    if (this.customerData && Object.keys(this.customerData).length > 0) {
      _project.customerName = this.customerData.customername;
      _project.customerId = this.customerData.uuid;
    } else {
      // Handle the case where customerData is not defined
      _project.customerName = '';
      _project.customerId = '';
    }
    _project.referenceId = this.referenceId;
    _project.drawingId = this.typeUtil.generateUUID();
    _project.telephone = controls.telephone.value;
    _project.mobile = controls.mobile.value;
    _project.earthingSystem = controls.earthingSystem.value;
    _project.iecStandard = controls.iecStandard.value;
    _project.ipRating = controls.ipRating.value;
    _project.orginDate = controls.orginDate.value;
    _project.formType = controls.formType.value;
    _project.voltage = controls.voltage.value;
    _project.busbarLocation = controls.busbarLocation.value;
    _project.cabledirection = controls.cabledirection.value;
    _project.shortCircuitTime = controls.shortCircuitTime.value;
    _project.version = controls.version.value;
    _project.colour = controls.colour.value;
    _project.discount = 0
    _project.frightCharges = 0;
    _project.shipmentMode = '-'
    _project.portName = 'CIF';
    _project.specialNote = '-';
    _project.panelname = controls.panelname.value;
    _project.depthoption = controls.depthoption.value;
    _project.salePersonCode = this.salePersonCode;
    _project.userId = this.userid;
    const draw = new Drawing();
    draw.uuid = _project.drawingId;
    draw.projectId = _project.uuid;
    draw.depthoption = _project.depthoption;
    draw.nodeDataArrayJSON = `{ "class": "GraphLinksModel",
		"nodeKeyProperty": "uuid",
		"linkKeyProperty": "uuid",
		"linkFromPortIdProperty": "fromPort",
		"linkToPortIdProperty": "toPort",
		"nodeDataArray": [],
		"linkDataArray": []}`;
    this.drawingService.createDiagram(draw).subscribe(res => {
      console.log('draw', draw)
    });
    return _project;
  }
  addProject(_project: Project, withBack: boolean = false) {

    // Ensure the first items in selectedItems are 'outerProfile' and reorder
    if (this.selectedItems && this.selectedItems.length > 0) {
      // Find all items with the 'outerProfile' category
      const outerProfileItems = this.selectedItems.filter(item => item.category === 'outerProfile');

      // Remove all 'outerProfile' items from selectedItems
      this.selectedItems = this.selectedItems.filter(item => item.category !== 'outerProfile');

      // Add the 'outerProfile' items back at the start of the array without modifying the category
      this.selectedItems.unshift(...outerProfileItems);

      // Now, all 'outerProfile' items are at the beginning of the array, in the same order they were before
    }

    // Proceed with your logic (project creation, etc.)...


    if (this.customerNameInputData && this.customerNameInputData.length > 0) {
      if (this.selectedCustomerId && this.selectedCustomerId.length > 0) {
        const updatedProject = {
          ..._project,
          customerId: this.selectedCustomerId
        } as Project;
        this.projectService.createProject(updatedProject).subscribe(res => {
          this.dialogRef.close();
          const url = `/drawing`;
          this.router.navigate([url], { state: { diagramId: _project.drawingId, projectId: _project.uuid, selectedItems: this.selectedItems, Wizard: this.Wizard } });
        });
      } else {
        const updatedProject = {
          ..._project,
          customerName: this.customerNameInputData
        } as Project;

        this.projectService.createProject(updatedProject).subscribe(res => {
          this.dialogRef.close();
          const url = `/drawing`;
          this.router.navigate([url], { state: { diagramId: _project.drawingId, projectId: _project.uuid, selectedItems: this.selectedItems, Wizard: this.Wizard } });
        });
      }
    } else {
      this.projectService.createProject(_project).subscribe(res => {
        this.dialogRef.close();
        const url = `/drawing`;
        this.router.navigate([url], { state: { diagramId: _project.drawingId, projectId: _project.uuid, selectedItems: this.selectedItems, Wizard: this.Wizard } });
      });
    }
  }

  getTypedCustomerData(inputData: string) {
    this.customerNameInputData = inputData;

    this.customerData = this.loadedCustomers.find(customer => customer.customername === this.customerNameInputData);

    if (!this.customerData) {
      this.customerData = this.loadedCustomers.find(customer => customer.uuid === this.customerNameInputData);
    }

    if (!this.customerData) {
      this.customerData = {}; // Set to an empty object
    } else {
      console.log("inputCustomerData", this.customerData);
    }

    return this.customerData;
  }
  validateTelephoneOrMobile(control: FormControl) {
    const inputValue = control.value;
    if (inputValue && !/^[0-9+()&\[\]*#\-/. ]*$/.test(inputValue)) {
      return { invalidNumber: true };
    }
    return null;
  }
  ProjectRefNo(Sym: string, text: string, padChar: string, size: number): string {
    return Sym + (String(padChar).repeat(size) + text).substr((size * -1), size);
  }
  previousOutgoings() {
    this.currentOutGoingPage--;
    this.animatePrevious = true; // Trigger left slide animation
    this.animateNext = false;
    this.resetAnimationFlags();


    if (this.initialNodeDataArray.length > 0) {
      this.nodeDataArray = this.initialNodeDataArray[this.initialNodeDataArray.length - 1];
    }
    else {
      console.error('Previous incomer is undefined');
    }
    if (this.initialAdditionalDoorDataArray.length > 0) {
      this.AdditionalDoorDataArray = this.initialAdditionalDoorDataArray[this.initialAdditionalDoorDataArray.length - 1];
    }

    this.initialNodeDataArray.pop();
    this.initialAdditionalDoorDataArray.pop();



    if (this.outgoingHistory.length > 0) {
      this.matchingRowMCCB = this.outgoingHistory[this.outgoingHistory.length - 1];
      if (this.matchingRowMCCB) {
        // Assign values from the matching row to the selected variables
        this.selectedManufacturerMCCB = this.matchingRowMCCB.MANUFACTUR;
        this.selectedRatedAmpMCCB = this.matchingRowMCCB.RATED_AMP;
        this.selectedTypeMCCB = this.matchingRowMCCB.TYPE;
        this.selectedFrameSizeMCCB = this.matchingRowMCCB.FRAME_SIZE;
        this.selectedPRFLevelMCCB = this.matchingRowMCCB.PRF_LEVEL;
        this.selectedShortCircuitIcuMCCB = this.matchingRowMCCB.SHORTCU_CU;
        this.selectedTripUnitMCCB = this.matchingRowMCCB.TRIP_UNIT;
        this.selectedOrderNumberMCCB = this.matchingRowMCCB.Order_number;
        this.selectedRotation = this.matchingRowMCCB.ROTATION;
      }
      else {
        console.error('Previous incomer is undefined');
      }
    } else {
      console.warn('No previous incomer to navigate to');
    }


    if (this.tempnumberOfOutgoing.length > 0) {
      this.numberOfOutgoing = this.tempnumberOfOutgoing[this.tempnumberOfOutgoing.length - 1];
    } else {
      console.warn('No previous incomer to navigate to');
    }
    this.tempnumberOfOutgoing.pop();
    this.outgoingHistory.pop();
  }

  isEqual(obj1: any, obj2: any): boolean {
    // Convert objects to JSON strings and compare
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  previousIncomer() {
    if (this.currentIncomerPage === 2) {
      let baseFrameWidth = 0;
      let shapeWidth = 0;

      // Get the Final text: "ACB" size[0] as shapeWidth
      const acbElements = this.nodeDataArray.filter(element => element.text === "ACB" || element.text === "MCCB");
      if (acbElements.length > 0) {
        const lastAcbElement = acbElements[acbElements.length - 1];
        const sizeParts = lastAcbElement.size.split(' ');
        shapeWidth = parseFloat(sizeParts[0]); // Get the width part
      }

      if (this.nodeDataArray && this.nodeDataArray.length > 0) {
        // Check if an element with the text "Base Frame" exists
        const baseFrameElement = this.nodeDataArray.find(element => element.category === "outerProfile");
        if (baseFrameElement) {
          const sizeParts = baseFrameElement.size.split(' '); // Split size string by whitespace
          baseFrameWidth = parseFloat(sizeParts[0]); // Parse the width part to a float

          if (!isNaN(baseFrameWidth)) {
            // Check if parsing was successful
            let baseWidth = baseFrameWidth - shapeWidth;
            sizeParts[0] = baseWidth.toString(); // Update the first part of sizeParts array
            baseFrameElement.size = sizeParts.join(' ');
            // Update the value in the array
          } else {
            // Handle the case where width is not a valid number
            // For example:
            // shapeWidth += defaultValue; // Add a default value
          }
        }
      }

      // Splice the array
      const lastIndex = this.nodeDataArray.length - 1;
      this.nodeDataArray.splice(lastIndex - 5, 6);
    }
    if (this.incomerHistory.length > 0) {
      this.isMovingToPreviousIncomer = true;
      const previousIncomer = this.incomerHistory[this.incomerHistory.length - 1];
      if (previousIncomer) {
        // Restore previous incomer details
        this.selectedManufacturer = previousIncomer.selectedManufacturer;
        this.selectedRatedAmp = previousIncomer.selectedRatedAmp;
        this.selectedType = previousIncomer.selectedType;
        this.selectedFrameSize = previousIncomer.selectedFrameSize;
        this.selectedPRFLevel = previousIncomer.selectedPRFLevel;
        this.selectedShortCircuitIcu = previousIncomer.selectedShortCircuitIcu;
        this.selectedMaxTierHeight = previousIncomer.selectedMaxTierHeight;
        this.matchingRow = previousIncomer.matchingRow;
        this.imagePath = previousIncomer.imagePath;

        // Decrement current page
        this.currentIncomerPage--;
        this.animatePrevious = true; // Trigger left slide animation
        this.animateNext = false;
        // Optionally, update the dropdown options or other UI elements
        this.updateDropdownOptions();
      } else {
        console.error('Previous incomer is undefined');
      }
    } else {
      console.warn('No previous incomer to navigate to');
    }
    this.incomerHistory.pop();
    console.log("this.nodeDataArray", this.nodeDataArray);

    // Reset animation flags after the animation completes
    this.resetAnimationFlags();
    this.addPorts();
  }
  addOutging() {
    this.initialNodeDataArray.push(JSON.parse(JSON.stringify(this.nodeDataArray)));
    this.initialAdditionalDoorDataArray.push(JSON.parse(JSON.stringify(this.AdditionalDoorDataArray)));
    this.outgoingHistory.push(this.matchingRowMCCB);
    this.tempnumberOfOutgoing.push(this.numberOfOutgoing);
    let pictureWidth = Math.round(this.matchingRowMCCB.WIDTH / 50) * 50;
    let pictureHeight = Math.round(this.matchingRowMCCB.HEIGHT / 50) * 50;
    const ratedAmp = parseInt(this.matchingRowMCCB.RATED_AMP || "0"); // Provide a default value if null
    let higherAmpRow;
    // Find the row with the nearest higher ampere value
    if (this.matchingRowMCCB.ROTATION === 'Vertical') {
      for (let i = 0; i < this.CubiclesSizesVerticle.length; i++) {
        const row = this.CubiclesSizesVerticle[i];
        if (row.ampere >= ratedAmp) {
          higherAmpRow = row;
          break;
        }
      }
    } else if (this.matchingRowMCCB.ROTATION === 'Horizontal') {
      for (let i = 0; i < this.CubiclesSizesHorizontal.length; i++) {
        const row = this.CubiclesSizesHorizontal[i];
        // Check if ratedAmp is more than 800
        if (ratedAmp > 800) {
          higherAmpRow = this.CubiclesSizesHorizontal.find(r => r.ampere === 800) || null;
          break;
        }

        if (row.ampere >= ratedAmp) {
          higherAmpRow = row;
          break;
        }
      }
    }



    if (higherAmpRow) {
      // Set shapeWidth and shapeHeight to the values from the higherAmpRow
      const shapeWidth = higherAmpRow.width;
      const shapeHeight = higherAmpRow.height;


      // Set these values to the properties in your component if needed
      this.matchingRowMCCB['cubicleWidth'] = shapeWidth;
      this.matchingRowMCCB['cubicleHeight'] = shapeHeight;

      let selectedMaxTierHeight = this.selectedMaxTierHeight ?? 0;
      let baseFrameWidth = 0;
      let totalWidth = 0;
      let baseFrameHeight = 0;
      let BusBarChamberHeight = 0;
      let totalBaseFrameWidth = 0;
      let LastBaseFrameWidth = 0;
      if (this.currentOutGoingPage === 1) {
        if (this.nodeDataArray && this.nodeDataArray.length > 0) {
          // Check if an element with the text "Base Frame" exists
          const baseFrameElement = this.nodeDataArray.slice().reverse().find(element => element.category === "outerProfile");
          this.nodeDataArray.forEach(element => {
            if (element.category === "outerProfile") {
              const sizeParts = element.size.split(' '); // Split size string by whitespace
              const width = parseFloat(sizeParts[0]); // Parse the width part to a float
              baseFrameHeight = parseFloat(sizeParts[1]);
              LastBaseFrameWidth = parseFloat(sizeParts[0]);
              if (!isNaN(width)) {
                totalBaseFrameWidth += width; // Sum up the widths
              }
            }
          });
          baseFrameWidth = totalBaseFrameWidth;
          if (baseFrameElement) {
            console.log("baseFrameElement", baseFrameElement);
            const sizeParts = baseFrameElement.size.split(' ');
            console.log("sizeParts", sizeParts);

            if (!isNaN(LastBaseFrameWidth)) {
              console.log("LastBaseFrameWidth", LastBaseFrameWidth);

              // Check if parsing was successful
              let baseWidth = shapeWidth + LastBaseFrameWidth;

              this.oneBaseFrameWidth = baseWidth;
              console.log("this.oneBaseFrameWidth", this.oneBaseFrameWidth);

              if (this.oneBaseFrameWidth < 2400) {
                this.oneBaseFrameWidth = baseWidth
              } else {
                console.log("this.widthArray", this.widthArray);
                if (this.widthArray.length === 0) {
                  this.oneBaseFrameWidth = LastBaseFrameWidth;
                  if (this.oneBaseFrameWidth <= 2400) {
                    this.widthArray.push(this.oneBaseFrameWidth);
                  }
                  this.oneBaseFrameWidth = 0;
                } else {
                  // If widthArray is not empty
                  let lastBaseFrameWidth = this.widthArray.reduce((acc, val) => acc + val, 0);
                  let difference = baseWidth - lastBaseFrameWidth - shapeWidth;
                  if (baseWidth - lastBaseFrameWidth > 2400) {
                    if (difference <= 2400) {
                      this.widthArray.push(difference);
                    }
                  }
                }
              }
              sizeParts[0] = baseWidth.toString(); // Update the first part of sizeParts array
              baseFrameElement.size = sizeParts.join(' ');
              // Update the value in the array
            } else {
              // Handle the case where width is not a valid number
              // For example:
              // shapeWidth += defaultValue; // Add a default value
            }
          }




          const BusBarChamberElement = this.nodeDataArray.find(element => element.category === "busbarChamber");
          if (BusBarChamberElement) {
            const sizeParts = BusBarChamberElement.size.split(' '); // Split size string by whitespace
            BusBarChamberHeight = parseFloat(sizeParts[1]); // Parse the width part to a float
          }

        }


        const BusBarChamber = {
          "uuid": "254134ba1dad",
          "text": "Busbar Chamber",
          "color": "#bdae91",
          "size": `${shapeWidth} ${BusBarChamberHeight}`,
          "type": "rectangle",
          "category": "busbarChamber",
          "top": false, "side": false,
          "innerProfile": false,
          "tool": "main",
          "ports": [{}],
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
          "pos": `${-1000 + baseFrameWidth} -1100`,
          'group': this.uniqueKey(),
          "page": `${this.currentOutGoingPage}`,
          "tire": "Outgoing",

        }
        this.nodeDataArray.push(BusBarChamber);


        // Calculate the remaining height for ControlSection

        const MccbRow = {
          'uuid': '9a4b5c6d7e8f',
          'text': 'MCCB',
          'color': '#bdae91',
          'size': `${shapeWidth} ${shapeHeight}`, // Update size
          'tool': 'main',
          'type': 'rectangle',
          'category': 'electricalMCCB',
          'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
          "pos": `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber.pos.split(' ')[1]) + BusBarChamberHeight}`,
          'group': this.uniqueKey(),
          'properties': { ...this.matchingRowMCCB },
          "ports": [{}],
          'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
          'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
          'innerProfile': false,
          "page": `${this.currentOutGoingPage}`,
          "tire": "Outgoing",
          "mccbcont": `${this.numberOfOutgoing}`
        };
        MccbRow.properties.imagePath = MccbRow.properties.ImagePath;

        const horizontalBusBar = {
          "uuid": "5432ceba1dad",
          "text": "Horizontal Busbar",
          "color": "#bdae91",
          "size": `${shapeWidth} 20`,
          "type": "square",
          "category": "busbary",
          "with": "mccb",
          "tool": "main",
          "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
          "pos": `${-1000 + baseFrameWidth} -1000`,
          "page": `${this.currentOutGoingPage}`,
          "tire": "Outgoing"
        }
        // Push the new rows into nodeDataArray
        let totalMccbRowHeight = 0;
        let totalMccbCountOFFirstTier = 0;
        let remainingMccbCount = 0;
        if (this.numberOfOutgoing > 1) {
          let previousMccbRowSize = 0;
          let CurrenttotalMccbRowHeight = 0;
          let addCableChamber = false;
          for (let i = 0; i < this.numberOfOutgoing; i++) {
            const currentMccbRow = { ...MccbRow }; // Create a copy of MccbRow

            // Adjust pos based on previousMccbRowSize
            currentMccbRow.pos = `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber.pos.split(' ')[1]) + BusBarChamberHeight + previousMccbRowSize}`;
            CurrenttotalMccbRowHeight += currentMccbRow.shapeSize.height;
            // Push the created MccbRow into the nodeDataArray
            if (CurrenttotalMccbRowHeight <= baseFrameHeight - parseInt(BusBarChamber.size.split(' ')[1])) {
              this.nodeDataArray.push(currentMccbRow);
              totalMccbRowHeight += currentMccbRow.shapeSize.height;
              totalMccbCountOFFirstTier++;
            } else {
              addCableChamber = true;
            }


            // Update previousMccbRowSize for the next iteration
            previousMccbRowSize += currentMccbRow.shapeSize.height;
          }
          remainingMccbCount = this.numberOfOutgoing - totalMccbCountOFFirstTier;
          console.log("remainingMccbCount", remainingMccbCount);
          const verticalBusBar = {
            "uuid": "9974ceba1dad",
            "text": "Vertical Busbar",
            "color": "#bdae91",
            "size": `20 ${totalMccbRowHeight}`,
            "type": "square",
            "category": "busbarx",
            "with": "mccb",
            "tool": "main",
            "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
            "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_VR.svg",
            "pos": `${-1000 + baseFrameWidth + (shapeWidth / 2)} -1100`,
            "page": `${this.currentOutGoingPage}`,
            "tire": "Outgoing"
          }
          console.log("baseFrameHeight - (totalMccbRowHeight + parseInt(BusBarChamber.size.split(' ')[1]))", baseFrameHeight - (totalMccbRowHeight + parseInt(BusBarChamber.size.split(' ')[1])));
          const remainingHeight = baseFrameHeight - (totalMccbRowHeight + parseInt(BusBarChamber.size.split(' ')[1]));
          if (remainingHeight > 0) {
            const Door = {
              "uuid": "4279ceba1dad",
              "text": "Door",
              "color": "#bdae91",
              "size": `${shapeWidth} ${remainingHeight}`,
              "type": "square",
              "category": "door",
              "tool": "main",
              "top": false,
              "side": false,
              "innerProfile": false,
              "ports": [{}],
              "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
              'pos': `${-1000 + baseFrameWidth} ${parseInt(MccbRow.pos.split(' ')[1]) + totalMccbRowHeight}`,
              'group': this.uniqueKey(),
              "page": `${this.currentOutGoingPage}`,
              "tire": "Outgoing"
            }
            const startPosition = -1000 + baseFrameWidth;
            this.nodeDataArray.push(Door);
            this.DoorShiftUndertheTier(startPosition, selectedMaxTierHeight);
            console.log("remainingHeight", remainingHeight);
            if (remainingHeight === 100) {
              this.adjustLastPushedDoor()
            } else {
              if (remainingMccbCount <= 0) {
                this.AdditionalDoorDataArray.push(Door);
              }
            }
          }



          if (remainingMccbCount > 0) {
            let remainingMccbTierCount = Math.ceil(Math.ceil(remainingMccbCount) / totalMccbCountOFFirstTier);
            let remainingMccbCountForOneTier = totalMccbCountOFFirstTier;
            let totalMccbRowHeightMCCB = 0;
            let totalSetPositionedMccbCountMCCB = 0;

            for (let i = 1; i <= remainingMccbTierCount; i++) {
              // if (i ===0){

              // }else{

              //   }
              // }
              // Check if parsing was successful
              const baseFrameElement = this.nodeDataArray.find(element => element.category === "outerProfile");
              if (baseFrameElement) {
                const sizeParts = baseFrameElement.size.split(' '); // Split size string by whitespace
                baseFrameWidth = parseFloat(sizeParts[0]); // Parse the width part to a float
                baseFrameHeight = parseFloat(sizeParts[1]);
                if (!isNaN(baseFrameWidth)) {
                  // Check if parsing was successful
                  let baseWidth = shapeWidth + baseFrameWidth;
                  totalWidth = baseWidth;
                  this.oneBaseFrameWidth = baseWidth;
                  if (this.oneBaseFrameWidth < 2400) {
                    this.oneBaseFrameWidth = totalWidth
                  } else {
                    if (this.widthArray.length === 0) {
                      this.oneBaseFrameWidth = totalWidth - shapeWidth;
                      if (this.oneBaseFrameWidth <= 2400) {
                        this.widthArray.push(this.oneBaseFrameWidth);
                      }
                      this.oneBaseFrameWidth = 0;
                    } else {
                      // If widthArray is not empty
                      let lastBaseFrameWidth = this.widthArray.reduce((acc, val) => acc + val, 0);
                      let difference = totalWidth - lastBaseFrameWidth - shapeWidth;
                      if (totalWidth - lastBaseFrameWidth > 2400) {
                        if (difference <= 2400) {
                          this.widthArray.push(difference);
                        }
                      }
                    }
                  }
                  sizeParts[0] = baseWidth.toString(); // Update the first part of sizeParts array
                  baseFrameElement.size = sizeParts.join(' ');


                  // Update the value in the array
                } else {
                  // Handle the case where width is not a valid number
                  // For example:
                  // shapeWidth += defaultValue; // Add a default value
                }
              }
              const BusBarChamberInChemberTier = {
                "uuid": "254134ba1dad",
                "text": "Busbar Chamber",
                "color": "#bdae91",
                "size": `${shapeWidth} ${BusBarChamberHeight}`,
                "type": "rectangle",
                "category": "busbarChamber",
                "top": false, "side": false,
                "innerProfile": false,
                "tool": "main",
                "ports": [{}],
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
                "pos": `${-1000 + baseFrameWidth} -1100`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }
              const horizontalBusBarChamberInChemberTier = {
                "uuid": "5432ceba1dad",
                "text": "Horizontal Busbar",
                "color": "#bdae91",
                "size": `${shapeWidth} 20`,
                "type": "square",
                "category": "busbary",
                "with": "mccb",
                "tool": "main",
                "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
                "pos": `${-1000 + baseFrameWidth} -1000`,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }
              const remainingHeightCableChamber = baseFrameHeight - parseInt(BusBarChamberInChemberTier.size.split(' ')[1]);

              const CableChamber = {
                "uuid": "6549ceba1dad",
                "text": "Cable Chamber",
                "color": "#bdae91",
                "size": `${shapeWidth} ${remainingHeightCableChamber}`,
                "type": "rectangle",
                "category": "cableChamber",
                "chamberType": "Cover",
                "top": false,
                "tool": "main",
                "side": false,
                "innerProfile": true,
                "ports": [{}],
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cable_CH.svg",
                "pos": `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber.pos.split(' ')[1]) + BusBarChamberHeight}`,
                'group': this.uniqueKey(),
                "glandData": { "properties": { "GlandPlateAThickness": "3.0mm", "view": "top" } },
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              };

              this.nodeDataArray.push(horizontalBusBarChamberInChemberTier);
              this.nodeDataArray.push(BusBarChamberInChemberTier);
              this.nodeDataArray.push(CableChamber);

              if (baseFrameElement) {
                const sizeParts = baseFrameElement.size.split(' '); // Split size string by whitespace
                baseFrameWidth = parseFloat(sizeParts[0]); // Parse the width part to a float
                baseFrameHeight = parseFloat(sizeParts[1]);
                if (!isNaN(baseFrameWidth)) {
                  // Check if parsing was successful
                  let baseWidth = shapeWidth + baseFrameWidth;
                  totalWidth = baseWidth;
                  this.oneBaseFrameWidth = baseWidth;
                  if (this.oneBaseFrameWidth < 2400) {
                    this.oneBaseFrameWidth = totalWidth
                  } else {
                    if (this.widthArray.length === 0) {
                      this.oneBaseFrameWidth = totalWidth - shapeWidth;
                      if (this.oneBaseFrameWidth <= 2400) {
                        this.widthArray.push(this.oneBaseFrameWidth);
                      }
                      this.oneBaseFrameWidth = 0;
                    } else {
                      // If widthArray is not empty
                      let lastBaseFrameWidth = this.widthArray.reduce((acc, val) => acc + val, 0);
                      let difference = totalWidth - lastBaseFrameWidth - shapeWidth;
                      if (totalWidth - lastBaseFrameWidth > 2400) {
                        if (difference <= 2400) {
                          this.widthArray.push(difference);
                        }
                      }
                    }
                  }
                  sizeParts[0] = baseWidth.toString(); // Update the first part of sizeParts array
                  baseFrameElement.size = sizeParts.join(' ');


                  // Update the value in the array
                } else {
                  // Handle the case where width is not a valid number
                  // For example:
                  // shapeWidth += defaultValue; // Add a default value
                }
              }

              const BusBarChamber1 = {
                "uuid": "254134ba1dad",
                "text": "Busbar Chamber",
                "color": "#bdae91",
                "size": `${shapeWidth} ${BusBarChamberHeight}`,
                "type": "rectangle",
                "category": "busbarChamber",
                "top": false, "side": false,
                "innerProfile": false,
                "tool": "main",
                "ports": [{}],
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
                "pos": `${-1000 + baseFrameWidth} -1100`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }
              const horizontalBusBar1 = {
                "uuid": "5432ceba1dad",
                "text": "Horizontal Busbar",
                "color": "#bdae91",
                "size": `${shapeWidth} 20`,
                "type": "square",
                "category": "busbary",
                "with": "mccb",
                "tool": "main",
                "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
                "pos": `${-1000 + baseFrameWidth} -1000`,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }
              const MccbRow1 = {
                'uuid': '9a4b5c6d7e8f',
                'text': 'MCCB',
                'color': '#bdae91',
                'size': `${shapeWidth} ${shapeHeight}`, // Update size
                'tool': 'main',
                'type': 'rectangle',
                'category': 'electricalMCCB',
                'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
                "pos": `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight}`,
                'group': this.uniqueKey(),
                'properties': { ...this.matchingRowMCCB },
                "ports": [{}],
                'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
                'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
                'innerProfile': false,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "mccbcont": `${this.numberOfOutgoing}`
              };
              MccbRow1.properties.imagePath = MccbRow1.properties.ImagePath;
              let previousMccbRowSize = 0;
              let CurrenttotalMccbRowHeight = 0;
              totalMccbRowHeightMCCB = 0;
              let remainingHeighttoDoor1 = 0;
              for (let j = 0; j < remainingMccbCountForOneTier; j++) {
                const currentMccbRow = { ...MccbRow1 };

                // Adjust pos based on previousMccbRowSize
                currentMccbRow.pos = `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight + previousMccbRowSize}`;
                CurrenttotalMccbRowHeight += currentMccbRow.shapeSize.height;
                // Push the created MccbRow into the nodeDataArray
                if ((CurrenttotalMccbRowHeight <= baseFrameHeight - parseInt(BusBarChamber1.size.split(' ')[1])) && (totalSetPositionedMccbCountMCCB < remainingMccbCount)) {
                  this.nodeDataArray.push(currentMccbRow);
                  totalMccbRowHeightMCCB += currentMccbRow.shapeSize.height;
                  totalSetPositionedMccbCountMCCB++;
                } else {
                  addCableChamber = true;
                }


                // Update previousMccbRowSize for the next iteration
                previousMccbRowSize += currentMccbRow.shapeSize.height;
              }
              remainingHeighttoDoor1 = baseFrameHeight - (totalMccbRowHeightMCCB + BusBarChamberHeight)

              const Door1 = {
                "uuid": "4279ceba1dad",
                "text": "Door",
                "color": "#bdae91",
                "size": `${shapeWidth} ${remainingHeighttoDoor1}`,
                "type": "square",
                "category": "door",
                "tool": "main",
                "top": false,
                "side": false,
                "innerProfile": false,
                "ports": [{}],
                "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
                'pos': `${-1000 + baseFrameWidth} ${parseInt(MccbRow1.pos.split(' ')[1]) + totalMccbRowHeightMCCB}`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }
              const verticalBusBar1 = {
                "uuid": "9974ceba1dad",
                "text": "Vertical Busbar",
                "color": "#bdae91",
                "size": `20 ${totalMccbRowHeightMCCB}`,
                "type": "square",
                "category": "busbarx",
                "with": "mccb",
                "tool": "main",
                "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_VR.svg",
                "pos": `${-1000 + baseFrameWidth + (shapeWidth / 2)} -1100`,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }
              console.log("remainingHeighttoDoor1", remainingHeighttoDoor1);
              console.log("remainingMccbTierCount", remainingMccbTierCount);
              console.log("i", i);
              if (remainingHeighttoDoor1 > 0) {
                console.log("Work>>>>");
                if (i = remainingMccbTierCount) {
                  console.log("Worccck>>>>");

                  // Last iteration: add to AdditionalDoorDataArray
                  this.nodeDataArray.push(Door1);
                  const startPositionNew = -1000 + baseFrameWidth;
                  this.DoorShiftUndertheTier(startPositionNew, selectedMaxTierHeight);
                  console.log("remainingHeight", remainingHeight);

                  if (remainingHeighttoDoor1 === 100) {
                    this.adjustLastPushedDoor()
                  } else {
                    this.AdditionalDoorDataArray.push(Door1);
                    console.log("this.AdditionalDoorDataArray", this.AdditionalDoorDataArray);
                  }
                } else {
                  console.log("Wosrk>>>>");

                  // Other iterations: add to nodeDataArray
                  const startPosition = -1000 + baseFrameWidth;
                  this.nodeDataArray.push(Door1);
                  this.DoorShiftUndertheTier(startPosition, selectedMaxTierHeight);
                  if (remainingHeight === 100) {
                    this.adjustLastPushedDoor()
                  }
                }
              }

              this.nodeDataArray.push(verticalBusBar1);
              this.nodeDataArray.push(BusBarChamber1);
              this.nodeDataArray.push(horizontalBusBar1);
            }
          }
          // else {
          //   const BusBarChamberInChemberTier = {
          //     "uuid": "254134ba1dad",
          //     "text": "Busbar Chamber",
          //     "color": "#bdae91",
          //     "size": `${shapeWidth} ${BusBarChamberHeight}`,
          //     "type": "rectangle",
          //     "category": "busbarChamber",
          //     "top": false, "side": false,
          //     "innerProfile": false,
          //     "tool": "main",
          //     "ports": [{}],
          //     "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
          //     "pos": `${-1000 + baseFrameWidth} -1100`,
          //     'group': this.uniqueKey(),
          //     "page": `${this.currentOutGoingPage}`,
          //     "tire": "Outgoing"
          //   }
          //   const remainingHeightCableChamber = baseFrameHeight - parseInt(BusBarChamberInChemberTier.size.split(' ')[1]);
          //   const CableChamber = {
          //     "uuid": "6549ceba1dad",
          //     "text": "Cable Chamber",
          //     "color": "#bdae91",
          //     "size": `${shapeWidth} ${remainingHeightCableChamber}`,
          //     "type": "rectangle",
          //     "category": "cableChamber",
          //     "chamberType": "Cover",
          //     "top": false,
          //     "tool": "main",
          //     "side": false,
          //     "innerProfile": true,
          //     "ports": [{}],
          //     "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cable_CH.svg",
          //     "pos": `${-1000 + baseFrameWidth} ${parseInt(BusBarChamber.pos.split(' ')[1]) + BusBarChamberHeight}`,
          //     'group': this.uniqueKey(),
          //     "glandData": { "properties": { "GlandPlateAThickness": "3.0mm", "view": "top" } },
          //     "page": `${this.currentOutGoingPage}`,
          //     "tire": "Outgoing"
          //   };
          //   this.nodeDataArray.push(BusBarChamberInChemberTier);
          //   this.nodeDataArray.push(CableChamber);
          // }

          this.nodeDataArray.push(verticalBusBar);

          const baseFrameElement = this.nodeDataArray.find(element => element.category === "outerProfile");
          if (baseFrameElement) {
            const sizeParts = baseFrameElement.size.split(' ');
            selectedMaxTierHeight = parseFloat(sizeParts[1]);
          }
        } else {
          totalMccbRowHeight = shapeHeight;
          // Your existing logic for creating a single MccbRow here
          // Push the created MccbRow into the nodeDataArray
          this.nodeDataArray.push(MccbRow);
          const remainingHeight = baseFrameHeight - (totalMccbRowHeight + parseInt(BusBarChamber.size.split(' ')[1]));
          const Door3 = {
            "uuid": "4279ceba1dad",
            "text": "Door",
            "color": "#bdae91",
            "size": `${shapeWidth} ${remainingHeight}`,
            "type": "square",
            "category": "door",
            "tool": "main",
            "top": false,
            "side": false,
            "innerProfile": false,
            "ports": [{}],
            "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
            'pos': `${-1000 + baseFrameWidth} ${parseInt(MccbRow.pos.split(' ')[1]) + totalMccbRowHeight}`,
            'group': this.uniqueKey(),
            "page": `${this.currentOutGoingPage}`,
            "tire": "Outgoing"
          }
          this.nodeDataArray.push(Door3);
          if (remainingHeight === 100) {
            this.adjustLastPushedDoor()
          } else {
            this.AdditionalDoorDataArray.push(Door3);
          }
          const baseFrameElement = this.nodeDataArray.find(element => element.category === "outerProfile");
          if (baseFrameElement) {
            const sizeParts = baseFrameElement.size.split(' '); // Split size string by whitespace
            baseFrameWidth = parseFloat(sizeParts[0]); // Parse the width part to a float
            baseFrameHeight = parseFloat(sizeParts[1]);
            if (!isNaN(baseFrameWidth)) {
              // Check if parsing was successful
              let baseWidth = shapeWidth + baseFrameWidth;
              totalWidth = baseWidth;
              this.oneBaseFrameWidth = baseWidth;
              if (this.oneBaseFrameWidth < 2400) {
                this.oneBaseFrameWidth = totalWidth
              } else {
                if (this.widthArray.length === 0) {  // Fixing the comparison operator to '==='
                  this.oneBaseFrameWidth = totalWidth - shapeWidth;
                  if (this.oneBaseFrameWidth <= 2400) {
                    this.widthArray.push(this.oneBaseFrameWidth);
                  } else {
                    // Calculate how many times 2400 fits into oneBaseFrameWidth
                    let fullTimes = Math.floor(this.oneBaseFrameWidth / 2400);
                    // Push 2400 fullTimes number of times
                    for (let i = 0; i < fullTimes; i++) {
                      this.widthArray.push(2400);
                    }
                    // Calculate the remaining part and push it if it's greater than 0
                    let remainder = this.oneBaseFrameWidth % 2400;
                    if (remainder > 0) {
                      this.widthArray.push(remainder);
                    }
                  }
                  this.oneBaseFrameWidth = 0;
                } else {
                  // If widthArray is not empty
                  let lastBaseFrameWidth = this.widthArray.reduce((acc, val) => acc + val, 0);
                  let difference = totalWidth - lastBaseFrameWidth - shapeWidth;
                  if (totalWidth - lastBaseFrameWidth > 2400) {
                    if (difference <= 2400) {
                      this.widthArray.push(difference);
                    }
                  }
                }
              }
              sizeParts[0] = baseWidth.toString(); // Update the first part of sizeParts array
              baseFrameElement.size = sizeParts.join(' ');


              // Update the value in the array
            } else {
              // Handle the case where width is not a valid number
              // For example:
              // shapeWidth += defaultValue; // Add a default value
            }
          }

          let arraySum = this.widthArray.reduce((acc, val) => acc + val, 0);

          // Check if the sum equals totalWidth
          if (arraySum !== totalWidth) {
            // Calculate the difference
            let difference = totalWidth - arraySum;

            // Add the difference to the array
            if (difference <= 2400) {
              this.widthArray.push(difference);
            }
          }
          if (baseFrameElement) {
            const sizeParts = baseFrameElement.size.split(' ');
            selectedMaxTierHeight = parseFloat(sizeParts[1]);
          }
          const baseFrameIndex = this.nodeDataArray.findIndex(element => element.category === "outerProfile");
          // If a Base Frame element was found, remove it from the array
          if (baseFrameIndex !== -1) {
            this.nodeDataArray.splice(baseFrameIndex, 1);
          }

          const initialPosX = -1000;  // Initial x position for the first BaseFrameRow
          const posY = -1100;         // Constant y position for all BaseFrameRows
          let currentPosX = initialPosX;  // Variable to track the current x position

          for (let i = 0; i < this.widthArray.length; i++) {
            const width = this.widthArray[i];
            console.log("this.widthArray[i]", this.widthArray[i]);

            // Create a new BaseFrameRow object
            const newBaseFrameRow = {
              uuid: this.uniqueKey(),  // Generate a unique UUID for each row as needed
              text: "Base Frame",
              color: "#bdae91",
              isGroup: true,
              size: `${width} ${selectedMaxTierHeight}`,
              type: "rectangle",
              category: "outerProfile",
              tool: "main",
              selectedOption: null,
              pos: `${currentPosX} ${posY}`,
              image: ".../../../../assets/media/icons/kikcad_2D_Icon_Base_Frame.svg",
              loc: `${currentPosX + 50} ${posY + 50}`,  // Adjusted loc based on pos
              tire: "Outgoing",
              page: `${this.currentOutGoingPage}`,
            };

            // Push the new object to the nodeDataArray
            this.nodeDataArray.push(newBaseFrameRow);

            // Update the currentPosX for the next BaseFrameRow
            currentPosX += width;
          }

        }
        const baseFrameElement = this.nodeDataArray.find(element => element.category === "outerProfile");
        if (baseFrameElement) {
          console.log("baseFrameElement", baseFrameElement);
          const sizeParts = baseFrameElement.size.split(' '); // Split size string by whitespace
          baseFrameWidth = parseFloat(sizeParts[0]); // Parse the width part to a float
          baseFrameHeight = parseFloat(sizeParts[1]);
          if (!isNaN(baseFrameWidth)) {
            // Check if parsing was successful
            let baseWidth = shapeWidth + baseFrameWidth;
            totalWidth = baseWidth;
            this.oneBaseFrameWidth = baseWidth;
            if (this.oneBaseFrameWidth < 2400) {
              this.oneBaseFrameWidth = totalWidth
            } else {
              if (this.widthArray.length === 0) {
                this.oneBaseFrameWidth = totalWidth - shapeWidth;
                if (this.oneBaseFrameWidth <= 2400) {
                  this.widthArray.push(this.oneBaseFrameWidth);
                } else {
                  // Calculate how many times 2400 fits into oneBaseFrameWidth
                  let fullTimes = Math.floor(this.oneBaseFrameWidth / 2400);
                  // Push 2400 fullTimes number of times
                  for (let i = 0; i < fullTimes; i++) {
                    this.widthArray.push(2400);
                  }
                  // Calculate the remaining part and push it if it's greater than 0
                  let remainder = this.oneBaseFrameWidth % 2400;
                  if (remainder > 0) {
                    this.widthArray.push(remainder);
                  }
                }
                this.oneBaseFrameWidth = 0;
              } else {
                // If widthArray is not empty
                let lastBaseFrameWidth = this.widthArray.reduce((acc, val) => acc + val, 0);
                let difference = totalWidth - lastBaseFrameWidth - shapeWidth;
                if (totalWidth - lastBaseFrameWidth > 2400) {
                  if (difference <= 2400) {
                    this.widthArray.push(difference);
                  } else {
                    console.error("difference", difference);
                  }
                }
              }
            }
            sizeParts[0] = baseWidth.toString(); // Update the first part of sizeParts array
            baseFrameElement.size = sizeParts.join(' ');


            // Update the value in the array
          } else {
            // Handle the case where width is not a valid number
            // For example:
            // shapeWidth += defaultValue; // Add a default value
          }
        }


        const busbarChamberData = this.nodeDataArray
          .filter((item) => item.category === "busbarChamber") // Filter elements with category "busbarChamber"
          .reduce(
            (maxData, currentItem) => {
              const currentPosX = Number(currentItem.pos.split(" ")[0]); // Extract pos[0] as a number
              const currentSizeX = Number(currentItem.size.split(" ")[0]); // Extract size[0] as a number

              if (currentPosX > maxData.maxPosX) {
                // Update maxPosX and its corresponding sizeX
                return { maxPosX: currentPosX, maxSizeX: currentSizeX };
              }

              return maxData; // Keep the existing maximum if currentPosX is smaller
            },
            { maxPosX: Number.NEGATIVE_INFINITY, maxSizeX: 0 } // Initialize with default values
          );

        const StartPositionNextTier = busbarChamberData.maxPosX + busbarChamberData.maxSizeX;

        console.log("Maximum pos[0] for busbarChamber:", busbarChamberData.maxPosX);
        console.log("Maximum size[0] for corresponding busbarChamber:", busbarChamberData.maxSizeX);
        console.log("StartPositionNextTier:", StartPositionNextTier);


        const BusBarChamberInChemberTier = {
          "uuid": "254134ba1dad",
          "text": "Busbar Chamber",
          "color": "#bdae91",
          "size": `${shapeWidth} ${BusBarChamberHeight}`,
          "type": "rectangle",
          "category": "busbarChamber",
          "top": false, "side": false,
          "innerProfile": false,
          "tool": "main",
          "ports": [{}],
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
          "pos": `${StartPositionNextTier} -1100`,
          'group': this.uniqueKey(),
          "page": `${this.currentOutGoingPage}`,
          "tire": "Outgoing"
        }
        const horizontalBusBarChamberInChemberTier = {
          "uuid": "5432ceba1dad",
          "text": "Horizontal Busbar",
          "color": "#bdae91",
          "size": `${shapeWidth} 20`,
          "type": "square",
          "category": "busbary",
          "with": "mccb",
          "tool": "main",
          "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
          "pos": `${StartPositionNextTier} -1000`,
          "page": `${this.currentOutGoingPage}`,
          "tire": "Outgoing"
        }
        console.log("StartPositionNextTier>>>>>>:", StartPositionNextTier);

        const remainingHeightCableChamber = baseFrameHeight - parseInt(BusBarChamberInChemberTier.size.split(' ')[1]);

        const CableChamber = {
          "uuid": "6549ceba1dad",
          "text": "Cable Chamber",
          "color": "#bdae91",
          "size": `${shapeWidth} ${remainingHeightCableChamber}`,
          "type": "rectangle",
          "category": "cableChamber",
          "chamberType": "Cover",
          "top": false,
          "tool": "main",
          "side": false,
          "innerProfile": true,
          "ports": [{}],
          "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cable_CH.svg",
          "pos": `${StartPositionNextTier} ${parseInt(BusBarChamber.pos.split(' ')[1]) + BusBarChamberHeight}`,
          'group': this.uniqueKey(),
          "glandData": { "properties": { "GlandPlateAThickness": "3.0mm", "view": "top" } },
          "page": `${this.currentOutGoingPage}`,
          "tire": "Outgoing"
        };
        let arraySum = this.widthArray.reduce((acc, val) => acc + val, 0);

        // Check if the sum equals totalWidth
        if (arraySum !== totalWidth) {
          // Calculate the difference
          let difference = totalWidth - arraySum;

          // Add the difference to the array
          if (difference <= 2400) {
            this.widthArray.push(difference);
          } else {
            console.error("difference", difference);
          }
        }
        console.log("horizontalBusBarChamberInChemberTier", horizontalBusBarChamberInChemberTier);
        this.nodeDataArray.push(horizontalBusBarChamberInChemberTier);
        console.log("this.nodeDataArray", this.nodeDataArray);

        this.nodeDataArray.push(BusBarChamberInChemberTier);
        this.nodeDataArray.push(CableChamber);

        // this.nodeDataArray.push(BusBarChamber);
        this.nodeDataArray.push(horizontalBusBar);

        const baseFrameIndex = this.nodeDataArray.findIndex(element => element.category === "outerProfile");

        // If a Base Frame element was found, remove it from the array
        if (baseFrameIndex !== -1) {
          this.nodeDataArray.splice(baseFrameIndex, 1);
        }
        const initialPosX = -1000;  // Initial x position for the first BaseFrameRow
        const posY = -1100;         // Constant y position for all BaseFrameRows
        let currentPosX = initialPosX;  // Variable to track the current x position

        for (let i = 0; i < this.widthArray.length; i++) {
          const width = this.widthArray[i];
          console.log("this.widthArray[i]", this.widthArray[i]);

          // Create a new BaseFrameRow object
          const newBaseFrameRow = {
            uuid: this.uniqueKey(),  // Generate a unique UUID for each row as needed
            text: "Base Frame",
            color: "#bdae91",
            isGroup: true,
            size: `${width} ${selectedMaxTierHeight}`,
            type: "rectangle",
            category: "outerProfile",
            tool: "main",
            selectedOption: null,
            pos: `${currentPosX} ${posY}`,
            image: ".../../../../assets/media/icons/kikcad_2D_Icon_Base_Frame.svg",
            loc: `${currentPosX + 50} ${posY + 50}`,  // Adjusted loc based on pos
            tire: "Outgoing",
            page: `${this.currentOutGoingPage}`,
          };

          // Push the new object to the nodeDataArray
          this.nodeDataArray.push(newBaseFrameRow);

          // Update the currentPosX for the next BaseFrameRow
          currentPosX += width;
        }
        console.log(" this.AdditionalDoorDataArray", this.AdditionalDoorDataArray);
      } else {
        console.log(" this.AdditionalDoorDataArray>>>>", this.AdditionalDoorDataArray);
        console.log("this.matchingRowMCCB", this.matchingRowMCCB);
        console.log("this.numberOfOutgoing", this.numberOfOutgoing);
        let maximumMCCBInTier = 0;
        let TotalMCCBTiers = 0;
        const BusBarChamberElement = this.nodeDataArray.find(element => element.category === "busbarChamber");
        console.log("BusBarChamberElement>>>>>>", BusBarChamberElement);
        if (BusBarChamberElement) {
          const sizeParts = BusBarChamberElement.size.split(' '); // Split size string by whitespace
          BusBarChamberHeight = parseFloat(sizeParts[1]); // Parse the width part to a float
        }
        let NewMCCBCountAddBottom = 0
        let baseStartPoint = 0
        console.log('  this.nodeDataArray', this.nodeDataArray)
        this.nodeDataArray.forEach(element => {
          if (element.category === "outerProfile") {
            console.log('element', element)
            const sizeParts = element.size.split(' '); // Split size string by whitespace 
            baseFrameHeight = parseFloat(sizeParts[1]);
            const BasePosParts = element.size.split(' ');
            baseStartPoint = parseFloat(BasePosParts[1]);
          }
        });
        console.log("this.AdditionalDoorDataArray", this.AdditionalDoorDataArray);
        if (this.AdditionalDoorDataArray.length > 0) {
          // Extract the height from the size attribute (assuming size is "width height")
          const sizeParts = this.AdditionalDoorDataArray[0].size.split(" ");
          const doorHeight = parseInt(sizeParts[1], 10);
          const doorWidth = parseInt(sizeParts[0], 10);
          const posParts = this.AdditionalDoorDataArray[0].pos.split(" ");

          const pos0 = parseInt(posParts[0], 10);
          const pos1 = parseInt(posParts[1], 10);
          let widthOflastTier = 0;
          if (doorWidth > shapeWidth) {
            widthOflastTier = doorWidth;
          } else {
            widthOflastTier = shapeWidth
          }
          console.log("doorHeight", doorHeight);
          console.log("shapeHeight", shapeHeight);
          // Check if the door height is greater than shapeHeight
          if (doorHeight >= shapeHeight) {
            this.AdditionalDoorDataArray = [];
            // Calculate how many times shapeHeight fits into doorHeight
            NewMCCBCountAddBottom = Math.floor(doorHeight / shapeHeight);
            console.log("NewMCCBCountAddBottom", NewMCCBCountAddBottom);
            const MccbRow = {
              'uuid': '9a4b5c6d7e8f',
              'text': 'MCCB',
              'color': '#bdae91',
              'size': `${shapeWidth} ${shapeHeight}`, // Update size
              'tool': 'main',
              'type': 'rectangle',
              'category': 'electricalMCCB',
              'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
              "pos": `${pos0} ${pos1}`,
              'group': this.uniqueKey(),
              'properties': { ...this.matchingRowMCCB },
              "ports": [{}],
              'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
              'shapeSize': { width: doorWidth, height: shapeHeight }, // Update shapeSize
              'innerProfile': false,
              "page": `${this.currentOutGoingPage}`,
              "tire": "Outgoing",
              "mccbcont": `${this.numberOfOutgoing}`
            };
            MccbRow.properties.imagePath = MccbRow.properties.ImagePath;
            // Loop the calculated number of times
            let CurrenttotalMccbRowHeight = 0;
            let previousMccbRowSize = 0;
            let lastMCCBPos = 0;
            console.log("this.numberOfOutgoing", this.numberOfOutgoing);
            if (NewMCCBCountAddBottom > this.numberOfOutgoing) {
              for (let i = 0; i < this.numberOfOutgoing; i++) {
                const currentMccbRow = { ...MccbRow }; // Create a copy of MccbRow
                currentMccbRow.pos = `${pos0} ${pos1 + previousMccbRowSize}`;

                // Push the created MccbRow into the nodeDataArray
                this.nodeDataArray.push(currentMccbRow);

                // Update previousMccbRowSize for the next iteration
                previousMccbRowSize += currentMccbRow.shapeSize.height;
                lastMCCBPos = pos1 + previousMccbRowSize;
                console.log("lastMCCBPos", lastMCCBPos);

              }
              this.numberOfOutgoing = 0;
            } else {
              for (let i = 0; i < NewMCCBCountAddBottom; i++) {
                const currentMccbRow = { ...MccbRow }; // Create a copy of MccbRow
                currentMccbRow.pos = `${pos0} ${pos1 + previousMccbRowSize}`;

                // Push the created MccbRow into the nodeDataArray
                this.nodeDataArray.push(currentMccbRow);

                // Update previousMccbRowSize for the next iteration
                previousMccbRowSize += currentMccbRow.shapeSize.height;
                lastMCCBPos = pos1 + previousMccbRowSize;
              }
              this.numberOfOutgoing = this.numberOfOutgoing - NewMCCBCountAddBottom;

            }

            // After the loop, calculate the remaining height
            const filteredNodes = this.nodeDataArray.filter(node => {
              const nodePosParts = node.pos.split(" ");
              if (node.category !== "outerProfile" && node.category !== "busbary" && node.category !== "busbarx" && node.category !== "door") {
                return parseInt(nodePosParts[0], 10) === pos0;
              } else {
                return false;
              }
            });
            console.log("filteredNodes", filteredNodes);
            const totalHeight = filteredNodes.reduce((sum, node) => {
              const nodeSizeParts = node.size.split(" ");
              return sum + parseInt(nodeSizeParts[1], 10);
            }, 0);
            console.log("totalHeight", totalHeight);
            console.log("baseFrameHeight", baseFrameHeight);
            const remainingHeight = baseFrameHeight - totalHeight;
            console.log("remainingHeight", remainingHeight);
            this.nodeDataArray = this.nodeDataArray.filter(item => {
              const itemPos = item.pos.split(' ')[0]; // Extract pos[0]
              return !(item.category === "door" && itemPos === `${pos0}`);
            });





            const mccbChangeTierallElemnts = this.nodeDataArray.filter(node => {
              const nodePosParts = node.pos.split(" ");
              if (node.category !== "outerProfile" && node.category !== "busbarx") {
                return parseInt(nodePosParts[0], 10) === pos0;
              } else {
                return false;
              }
            });
            console.log("mccbChangeTierallElemnts", mccbChangeTierallElemnts);
            // Step 1: Filter the elements that have category "electricalMCCB"
            const mccbElements = mccbChangeTierallElemnts.filter(node => node.category === "electricalMCCB");

            // Step 2: Find the maximum size[0] value from the "electricalMCCB" elements
            const maxSize0 = Math.max(...mccbElements.map(node => parseInt(node.size.split(" ")[0], 10)));

            // Step 3: Set the maximum size[0] value to all elements in filteredNodes
            mccbChangeTierallElemnts.forEach(mccbChangeTierallElemntsnode => {
              const sizeParts = mccbChangeTierallElemntsnode.size.split(" "); // Split the size string
              sizeParts[0] = maxSize0.toString(); // Set the size[0] to the maximum value
              mccbChangeTierallElemntsnode.size = sizeParts.join(" "); // Join the parts back into a string

              // Update cubicleWidth if the category is "electricalMCCB"
              if (mccbChangeTierallElemntsnode.category === "electricalMCCB") {
                mccbChangeTierallElemntsnode.properties.cubicleWidth = maxSize0; // Set cubicleWidth to size[0]
              }
            });

            // Now all elements in filteredNodes will have the maximum size[0] value
            console.log("Updated mccbChangeTierallElemnts:", mccbChangeTierallElemnts);


            // Step 4: Update the original this.nodeDataArray based on matching category and pos
            this.nodeDataArray = this.nodeDataArray.map(node => {
              // Check if the node matches in category and pos with the filteredNodes
              const matchingNode = mccbChangeTierallElemnts.find(filteredNode =>
                filteredNode.category === node.category && filteredNode.pos === node.pos
              );
              if (matchingNode) {
                console.log("matchingNode", matchingNode);
                return matchingNode; // Return the updated node from filteredNodes
              }
              return node; // Return the original node if it doesn't need updating
            });

            // Now all elements in filteredNodes will have the maximum size[0] value
            console.log("Updated this.nodeDataArray:", this.nodeDataArray);

            const BusBarChamberMCCBChangingPlace = mccbChangeTierallElemnts.filter(node => node.category === "busbarChamber");
            console.log("BusBarChamberMCCBChangingPlace", BusBarChamberMCCBChangingPlace);
            let busbarChamberWidthmccbChangepos;
            let nextbusbarChamberWidth;
            // Loop through the filtered "busbarChamber" nodes to calculate StartPositionX and EndPositionX
            BusBarChamberMCCBChangingPlace.forEach(busBarNode => {
              const busBarPosParts = busBarNode.pos.split(" ");
              const busBarSizeParts = busBarNode.size.split(" ");

              const StartPositionX = parseInt(busBarPosParts[0], 10); // Extract pos[0]
              console.log("StartPositionX", StartPositionX);
              busbarChamberWidthmccbChangepos = parseInt(busBarSizeParts[0], 10);
              console.log("busbarChamberWidthmccbChangepos", busbarChamberWidthmccbChangepos);

              const EndPositionX = StartPositionX + busbarChamberWidthmccbChangepos; // Calculate EndPositionX
              console.log("EndPositionX", EndPositionX);

              // Find nodes in this.nodeDataArray with pos[0] between StartPositionX and EndPositionX
              this.nodeDataArray.forEach(node => {
                const nodePosParts = node.pos.split(" ");
                const nodePosX = parseInt(nodePosParts[0], 10);
                const nodeSize = busBarNode.size.split(" ");
                let nodeWidth = parseInt(nodeSize[0], 10);
                // Check if the node category is "busbarChamber" or "cableChamber"
                if (
                  (node.category === "busbarChamber" || node.category === "cableChamber" || node.category === 'busbary') &&
                  nodePosX > StartPositionX && nodePosX < EndPositionX
                ) {

                  if
                    (node.category === "busbarChamber") {
                    const nodeSizeParts = node.size.split(" ");
                    nextbusbarChamberWidth = parseInt(nodeSizeParts[0], 10);

                    console.log('node', node);
                    console.log('nodeWidth', nodeWidth);
                  }
                  // Update pos[0] to EndPositionX
                  nodePosParts[0] = EndPositionX.toString();
                  node.pos = nodePosParts.join(" "); // Rejoin the position parts back into the pos string
                }
              });
            });
            console.log("busbarChamberWidthmccbChangepos", busbarChamberWidthmccbChangepos);
            console.log("nextbusbarChamberWidth", nextbusbarChamberWidth);
            console.log("busbarChamberWidthmccbChangepos+nextbusbarChamberWidth", busbarChamberWidthmccbChangepos + nextbusbarChamberWidth);
            // Filter mccbChangeTierBaseFrame based on "outerProfile" and position match
            const mccbChangeTierBaseFrame = this.nodeDataArray.filter(node => {
              const nodePosParts = node.pos.split(" ");
              if (node.category === "outerProfile") {
                return parseInt(nodePosParts[0], 10) === pos0;
              } else {
                return false;
              }
            });

            // Calculate the new width
            const newWidth = busbarChamberWidthmccbChangepos + nextbusbarChamberWidth;
            console.log('newWidth', newWidth);

            // Update the size[0] for each node in mccbChangeTierBaseFrame
            mccbChangeTierBaseFrame.forEach(baseFrameNode => {
              const sizeParts = baseFrameNode.size.split(" "); // Split size into parts
              sizeParts[0] = newWidth.toString(); // Update size[0] with the new width
              baseFrameNode.size = sizeParts.join(" "); // Join the size parts back into a string
            });

            // Update the original this.nodeDataArray with the modified mccbChangeTierBaseFrame nodes
            this.nodeDataArray = this.nodeDataArray.map(node => {
              // Check if the node matches any of the updated mccbChangeTierBaseFrame nodes
              const matchingNode = mccbChangeTierBaseFrame.find(baseFrameNode =>
                baseFrameNode.category === node.category && baseFrameNode.pos === node.pos
              );

              if (matchingNode) {
                return matchingNode; // Return the updated node
              }
              return node; // Return the original node if it doesn't match
            });

            this.processBusbarChamber(pos0);
            console.log("pos0", pos0);

            const DoorPosX = this.nodeDataArray
              .filter((item) => item.category === "electricalMCCB") // Filter elements with category "electricalMCCB"
              .reduce((maxPosX, currentItem) => {
                const currentPosX = Number(currentItem.pos.split(" ")[0]); // Extract pos[0] as a number
                return currentPosX > maxPosX ? currentPosX : maxPosX; // Find the maximum pos[0]
              }, Number.NEGATIVE_INFINITY); // Initialize with the smallest possible number

            console.log("Maximum pos[0] for electricalMCCB:", DoorPosX);

            if (remainingHeight > 0) {
              // Remove the 'door' from nodeDataArray if its pos[0] matches pos0

              console.log('Remaining Height:', remainingHeight);
              const Door1 = {
                "uuid": "4279ceba1dad",
                "text": "Door",
                "color": "#bdae91",
                "size": `${shapeWidth} ${remainingHeight}`,
                "type": "square",
                "category": "door",
                "tool": "main",
                "top": false,
                "side": false,
                "innerProfile": false,
                "ports": [{}],
                "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
                'pos': `${DoorPosX} ${pos1 + previousMccbRowSize}`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }
              this.nodeDataArray.push(Door1);
              this.DoorShiftUndertheTier(pos0, selectedMaxTierHeight);
              if (remainingHeight === 100) {
                this.adjustLastPushedDoor()
              } else {
                this.AdditionalDoorDataArray.push(Door1);
              }
            }
          } else {
            console.log("this.AdditionalDoorDataArray[0]", this.AdditionalDoorDataArray[0]);
            // If the door height is not greater than shapeHeight, push the data to nodeDataArray
            this.nodeDataArray.push(this.AdditionalDoorDataArray[0]);
            this.AdditionalDoorDataArray = [];
          }
        }

        console.log(' this.nodeDataArray', this.nodeDataArray)
        const LastbaseFrameElement = this.nodeDataArray.slice().reverse().find(element => element.category === "outerProfile");

        this.nodeDataArray.forEach(element => {
          if (element.category === "outerProfile") {
            console.log('element', element)
            const sizeParts = element.size.split(' '); // Split size string by whitespace
            const width = parseFloat(sizeParts[0]); // Parse the width part to a float
            baseFrameHeight = parseFloat(sizeParts[1]);
            selectedMaxTierHeight = baseFrameHeight;
            if (!isNaN(width)) {
              totalBaseFrameWidth += width; // Sum up the widths
            }
          }
        });
        console.log("LastbaseFrameElement", LastbaseFrameElement);
        if (LastbaseFrameElement) {
          const sizeParts = LastbaseFrameElement.size.split(' ');
          const width = parseFloat(sizeParts[0]);
          if (width + shapeWidth <= 2400) {
            maximumMCCBInTier = Math.floor((selectedMaxTierHeight - BusBarChamberHeight - 200) / shapeHeight);
            console.log("maximumMCCBInTier", maximumMCCBInTier);
            TotalMCCBTiers = Math.ceil(this.numberOfOutgoing / maximumMCCBInTier);
            console.log("TotalMCCBTiers>>>>", TotalMCCBTiers);
            let RemainsMCCBcount = 0;
            for (let i = 0; i < TotalMCCBTiers; i++) {

              let busbarChamberData = this.nodeDataArray
                .filter((item) => item.category === "busbarChamber") // Filter elements with category "busbarChamber"
                .reduce(
                  (maxData, currentItem) => {
                    const currentPosX = Number(currentItem.pos.split(" ")[0]); // Extract pos[0] as a number
                    const currentSizeX = Number(currentItem.size.split(" ")[0]); // Extract size[0] as a number

                    if (currentPosX > maxData.maxPosX) {
                      // Update maxPosX and its corresponding sizeX
                      return { maxPosX: currentPosX, maxSizeX: currentSizeX };
                    }

                    return maxData; // Keep the existing maximum if currentPosX is smaller
                  },
                  { maxPosX: Number.NEGATIVE_INFINITY, maxSizeX: 0 } // Initialize with default values
                );

              let StartPositionNextTier = busbarChamberData.maxPosX + busbarChamberData.maxSizeX;

              console.log("Maximum pos[0] for busbarChamber:", busbarChamberData.maxPosX);
              console.log("Maximum size[0] for corresponding busbarChamber:", busbarChamberData.maxSizeX);
              console.log("StartPositionNextTier:", StartPositionNextTier);

              const BusBarChamber1 = {
                "uuid": "254134ba1dad",
                "text": "Busbar Chamber",
                "color": "#bdae91",
                "size": `${shapeWidth} ${BusBarChamberHeight}`,
                "type": "rectangle",
                "category": "busbarChamber",
                "top": false, "side": false,
                "innerProfile": false,
                "tool": "main",
                "ports": [{}],
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
                "pos": `${StartPositionNextTier} -1100`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }

              const MccbRow = {
                'uuid': '9a4b5c6d7e8f',
                'text': 'MCCB',
                'color': '#bdae91',
                'size': `${shapeWidth} ${shapeHeight}`, // Update size
                'tool': 'main',
                'type': 'rectangle',
                'category': 'electricalMCCB',
                'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
                "pos": `${StartPositionNextTier} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight}`,
                'group': this.uniqueKey(),
                'properties': { ...this.matchingRowMCCB },
                "ports": [{}],
                'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
                'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
                'innerProfile': false,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "mccbcont": `${this.numberOfOutgoing}`
              };
              MccbRow.properties.imagePath = MccbRow.properties.ImagePath;
              let previousMccbRowSize = 0;
              let CurrenttotalMccbRowHeight = 0;
              let addCableChamber = false;
              let totalMccbRowHeight = 0;
              let totalMccbCountOFFirstTier = 0;
              for (let j = 0; j < this.numberOfOutgoing; j++) {
                const currentMccbRow = { ...MccbRow }; // Create a copy of MccbRow

                // Adjust pos based on previousMccbRowSize
                currentMccbRow.pos = `${StartPositionNextTier} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight + previousMccbRowSize}`;
                CurrenttotalMccbRowHeight += currentMccbRow.shapeSize.height;
                // Push the created MccbRow into the nodeDataArray
                if (CurrenttotalMccbRowHeight <= baseFrameHeight - parseInt(BusBarChamber1.size.split(' ')[1])) {
                  this.nodeDataArray.push(currentMccbRow);
                  totalMccbRowHeight += currentMccbRow.shapeSize.height;
                  totalMccbCountOFFirstTier++;
                } else {
                  addCableChamber = true;
                }


                // Update previousMccbRowSize for the next iteration
                previousMccbRowSize += currentMccbRow.shapeSize.height;
              }
              this.numberOfOutgoing = this.numberOfOutgoing - totalMccbCountOFFirstTier;
              const horizontalBusBar1 = {
                "uuid": "5432ceba1dad",
                "text": "Horizontal Busbar",
                "color": "#bdae91",
                "size": `${shapeWidth} 20`,
                "type": "square",
                "category": "busbary",
                "with": "mccb",
                "tool": "main",
                "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
                "pos": `${StartPositionNextTier} -1000`,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }

              const verticalBusBar1 = {
                "uuid": "9974ceba1dad",
                "text": "Vertical Busbar",
                "color": "#bdae91",
                "size": `20 ${totalMccbRowHeight}`,
                "type": "square",
                "category": "busbarx",
                "with": "mccb",
                "tool": "main",
                "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_VR.svg",
                "pos": `${StartPositionNextTier + shapeWidth / 2} -1100`,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }

              let remainingHeightToDoor = baseFrameHeight - (parseInt(BusBarChamber1.size.split(' ')[1]) + totalMccbRowHeight);
              console.log("remainingHeightToDoor", remainingHeightToDoor);
              const Door1 = {
                "uuid": "4279ceba1dad",
                "text": "Door",
                "color": "#bdae91",
                "size": `${shapeWidth} ${remainingHeightToDoor}`,
                "type": "square",
                "category": "door",
                "tool": "main",
                "top": false,
                "side": false,
                "innerProfile": false,
                "ports": [{}],
                "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
                'pos': `${StartPositionNextTier} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight + totalMccbRowHeight}`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }
              const BusBarChamberInChemberTier = {
                "uuid": "254134ba1dad",
                "text": "Busbar Chamber",
                "color": "#bdae91",
                "size": `${shapeWidth} ${BusBarChamberHeight}`,
                "type": "rectangle",
                "category": "busbarChamber",
                "top": false, "side": false,
                "innerProfile": false,
                "tool": "main",
                "ports": [{}],
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
                "pos": `${StartPositionNextTier + shapeWidth} -1100`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }
              const remainingHeightCableChamber = baseFrameHeight - parseInt(BusBarChamberInChemberTier.size.split(' ')[1]);
              const CableChamber = {
                "uuid": "6549ceba1dad",
                "text": "Cable Chamber",
                "color": "#bdae91",
                "size": `${shapeWidth} ${remainingHeightCableChamber}`,
                "type": "rectangle",
                "category": "cableChamber",
                "chamberType": "Cover",
                "top": false,
                "tool": "main",
                "side": false,
                "innerProfile": true,
                "ports": [{}],
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cable_CH.svg",
                "pos": `${StartPositionNextTier + shapeWidth} ${parseInt(BusBarChamberInChemberTier.pos.split(' ')[1]) + BusBarChamberHeight}`,
                'group': this.uniqueKey(),
                "glandData": { "properties": { "GlandPlateAThickness": "3.0mm", "view": "top" } },
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              };
              const horizontalBusBarInChemberTier = {
                "uuid": "5432ceba1dad",
                "text": "Horizontal Busbar",
                "color": "#bdae91",
                "size": `${shapeWidth} 20`,
                "type": "square",
                "category": "busbary",
                "with": "mccb",
                "tool": "main",
                "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
                "pos": `${StartPositionNextTier + shapeWidth} -1000`,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }
              this.nodeDataArray.push(BusBarChamber1);
              this.nodeDataArray.push(verticalBusBar1);
              this.nodeDataArray.push(horizontalBusBar1);
              if (remainingHeightToDoor > 0) {
                this.nodeDataArray.push(Door1);
                if (remainingHeightToDoor === 100) {
                  this.adjustLastPushedDoor()
                } else {
                  this.AdditionalDoorDataArray = [];
                  this.AdditionalDoorDataArray.push(Door1);
                  console.log("this.AdditionalDoorDataArray", this.AdditionalDoorDataArray);
                }
              }
              this.nodeDataArray.push(BusBarChamberInChemberTier);
              this.nodeDataArray.push(CableChamber);
              this.nodeDataArray.push(horizontalBusBarInChemberTier);
            }
            RemainsMCCBcount = this.numberOfOutgoing;

            console.log("RemainsMCCBcount", RemainsMCCBcount);
            if (RemainsMCCBcount > 0) {

              let lastBusbarChamberPositionx = 0;
              const BusbarChamberElement = this.nodeDataArray.slice().reverse().find(element => element.category === "busbarChamber");
              if (BusbarChamberElement) {
                const MccbRow = {
                  'uuid': '9a4b5c6d7e8f',
                  'text': 'MCCB',
                  'color': '#bdae91',
                  'size': `${shapeWidth} ${shapeHeight}`, // Update size
                  'tool': 'main',
                  'type': 'rectangle',
                  'category': 'electricalMCCB',
                  'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
                  "pos": `${-1000} ${1000}`,
                  'group': this.uniqueKey(),
                  'properties': { ...this.matchingRowMCCB },
                  "ports": [{}],
                  'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
                  'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
                  'innerProfile': false,
                  "page": `${this.currentOutGoingPage}`,
                  "tire": "Outgoing",
                  "mccbcont": `${this.numberOfOutgoing}`
                };
                MccbRow.properties.imagePath = MccbRow.properties.ImagePath;
                const positionParts = BusbarChamberElement.pos.split(' ');
                lastBusbarChamberPositionx = parseFloat(positionParts[0]);
                const BusBarChamber1 = {
                  "uuid": "254134ba1dad",
                  "text": "Busbar Chamber",
                  "color": "#bdae91",
                  "size": `${shapeWidth} ${BusBarChamberHeight}`,
                  "type": "rectangle",
                  "category": "busbarChamber",
                  "top": false, "side": false,
                  "innerProfile": false,
                  "tool": "main",
                  "ports": [{}],
                  "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
                  "pos": `${lastBusbarChamberPositionx + shapeWidth} -1100`,
                  'group': this.uniqueKey(),
                  "page": `${this.currentOutGoingPage}`,
                  "tire": "Outgoing"
                }
                this.nodeDataArray.push(BusBarChamber1);
                let previousMccbRowSize = 0;
                let CurrenttotalMccbRowHeight = 0;
                let addCableChamber = false;
                let totalMccbRowHeight = 0;
                let totalMccbCountOFFirstTier = 0;
                for (let j = 0; j < RemainsMCCBcount; j++) {
                  const currentMccbRow = { ...MccbRow }; // Create a copy of MccbRow

                  // Adjust pos based on previousMccbRowSize
                  currentMccbRow.pos = `${lastBusbarChamberPositionx + shapeWidth} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight + previousMccbRowSize}`;
                  CurrenttotalMccbRowHeight += currentMccbRow.shapeSize.height;
                  // Push the created MccbRow into the nodeDataArray
                  if (CurrenttotalMccbRowHeight <= baseFrameHeight - parseInt(BusBarChamber1.size.split(' ')[1])) {
                    this.nodeDataArray.push(currentMccbRow);
                    totalMccbRowHeight += currentMccbRow.shapeSize.height;
                    totalMccbCountOFFirstTier++;
                  } else {
                    addCableChamber = true;
                  }


                  // Update previousMccbRowSize for the next iteration
                  previousMccbRowSize += currentMccbRow.shapeSize.height;
                }
                const horizontalBusBar1 = {
                  "uuid": "5432ceba1dad",
                  "text": "Horizontal Busbar",
                  "color": "#bdae91",
                  "size": `${shapeWidth} 20`,
                  "type": "square",
                  "category": "busbary",
                  "with": "mccb",
                  "tool": "main",
                  "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                  "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
                  "pos": `${lastBusbarChamberPositionx + shapeWidth} -1000`,
                  "page": `${this.currentOutGoingPage}`,
                  "tire": "Outgoing",
                }

                const verticalBusBar1 = {
                  "uuid": "9974ceba1dad",
                  "text": "Vertical Busbar",
                  "color": "#bdae91",
                  "size": `20 ${totalMccbRowHeight}`,
                  "type": "square",
                  "category": "busbarx",
                  "with": "mccb",
                  "tool": "main",
                  "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                  "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_VR.svg",
                  "pos": `${lastBusbarChamberPositionx + shapeWidth + shapeWidth / 2} -1100`,
                  "page": `${this.currentOutGoingPage}`,
                  "tire": "Outgoing"
                }
                let remainingHeightForRemainingDoor = baseFrameHeight - (BusBarChamberHeight + totalMccbRowHeight);
                const Door1 = {
                  "uuid": "4279ceba1dad",
                  "text": "Door",
                  "color": "#bdae91",
                  "size": `${shapeWidth} ${remainingHeightForRemainingDoor}`,
                  "type": "square",
                  "category": "door",
                  "tool": "main",
                  "top": false,
                  "side": false,
                  "innerProfile": false,
                  "ports": [{}],
                  "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
                  'pos': `${lastBusbarChamberPositionx + shapeWidth} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight + previousMccbRowSize}`,
                  'group': this.uniqueKey(),
                  "page": `${this.currentOutGoingPage}`,
                  "tire": "Outgoing"
                }
                if (remainingHeightForRemainingDoor > 0) {
                  if (remainingHeightForRemainingDoor === 100) {
                    this.adjustLastPushedDoor()
                  } else {
                    this.AdditionalDoorDataArray.push(Door1);
                  }
                  console.log('Added to AdditionalDoorDataArray:', Door1);
                }
                this.nodeDataArray.push(horizontalBusBar1);
                this.nodeDataArray.push(verticalBusBar1);
                const BusBarChamberInChemberTier = {
                  "uuid": "254134ba1dad",
                  "text": "Busbar Chamber",
                  "color": "#bdae91",
                  "size": `${shapeWidth} ${BusBarChamberHeight}`,
                  "type": "rectangle",
                  "category": "busbarChamber",
                  "top": false, "side": false,
                  "innerProfile": false,
                  "tool": "main",
                  "ports": [{}],
                  "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
                  "pos": `${lastBusbarChamberPositionx + shapeWidth * 2} -1100`,
                  'group': this.uniqueKey(),
                  "page": `${this.currentOutGoingPage}`,
                  "tire": "Outgoing"
                }
                const remainingHeightCableChamber = baseFrameHeight - parseInt(BusBarChamberInChemberTier.size.split(' ')[1]);
                const CableChamber = {
                  "uuid": "6549ceba1dad",
                  "text": "Cable Chamber",
                  "color": "#bdae91",
                  "size": `${shapeWidth} ${remainingHeightCableChamber}`,
                  "type": "rectangle",
                  "category": "cableChamber",
                  "chamberType": "Cover",
                  "top": false,
                  "tool": "main",
                  "side": false,
                  "innerProfile": true,
                  "ports": [{}],
                  "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cable_CH.svg",
                  "pos": `${lastBusbarChamberPositionx + shapeWidth * 2} ${parseInt(BusBarChamberInChemberTier.pos.split(' ')[1]) + BusBarChamberHeight}`,
                  'group': this.uniqueKey(),
                  "glandData": { "properties": { "GlandPlateAThickness": "3.0mm", "view": "top" } },
                  "page": `${this.currentOutGoingPage}`,
                  "tire": "Outgoing"
                };
                const horizontalBusBarInChemberTier = {
                  "uuid": "5432ceba1dad",
                  "text": "Horizontal Busbar",
                  "color": "#bdae91",
                  "size": `${shapeWidth} 20`,
                  "type": "square",
                  "category": "busbary",
                  "with": "mccb",
                  "tool": "main",
                  "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                  "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
                  "pos": `${lastBusbarChamberPositionx + shapeWidth * 2} -1000`,
                  "page": `${this.currentOutGoingPage}`,
                  "tire": "Outgoing"
                }
                this.nodeDataArray.push(BusBarChamberInChemberTier);
                this.nodeDataArray.push(CableChamber);
                this.nodeDataArray.push(horizontalBusBarInChemberTier);

              }
            }
            let LastbaseFrameElementPosX = parseInt(LastbaseFrameElement.pos.split(' ')[0]) + parseInt(LastbaseFrameElement.size.split(' ')[0])
            const LastBusbarChamberElement = this.nodeDataArray.slice().reverse().find(element => element.category === "busbarChamber");
            if (LastBusbarChamberElement) {
              let LastBusbarChamberElementPosX = parseInt(LastBusbarChamberElement.pos.split(' ')[0]) + parseInt(LastBusbarChamberElement.size.split(' ')[0]);;
              let fullWidthOfNewOutCommers = LastBusbarChamberElementPosX - LastbaseFrameElementPosX;
              this.widthArrayNextOutgoing = [];
              if (fullWidthOfNewOutCommers <= 2400) {
                this.widthArrayNextOutgoing.push(fullWidthOfNewOutCommers);
              } else {
                // Calculate how many 2400 values are needed
                while (fullWidthOfNewOutCommers > 2400) {
                  this.widthArrayNextOutgoing.push(2400);
                  fullWidthOfNewOutCommers -= 2400;
                }
                // Push the remaining value if it's greater than 0
                if (fullWidthOfNewOutCommers > 0) {
                  this.widthArrayNextOutgoing.push(fullWidthOfNewOutCommers);
                }
              }
              const initialPosX = LastbaseFrameElementPosX;  // Initial x position for the first BaseFrameRow
              const posY = -1100;         // Constant y position for all BaseFrameRows
              let currentPosX = initialPosX;  // Variable to track the current x position

              for (let i = 0; i < this.widthArrayNextOutgoing.length; i++) {
                const width = this.widthArrayNextOutgoing[i];

                // Create a new BaseFrameRow object
                const newBaseFrameRow = {
                  uuid: this.uniqueKey(),  // Generate a unique UUID for each row as needed
                  text: "Base Frame",
                  color: "#bdae91",
                  isGroup: true,
                  size: `${width} ${selectedMaxTierHeight}`,
                  type: "rectangle",
                  category: "outerProfile",
                  tool: "main",
                  selectedOption: null,
                  pos: `${currentPosX} ${posY}`,
                  image: ".../../../../assets/media/icons/kikcad_2D_Icon_Base_Frame.svg",
                  loc: `${currentPosX + 50} ${posY + 50}`,  // Adjusted loc based on pos
                  tire: "Outgoing",
                  page: `${this.currentOutGoingPage}`,
                };

                // Push the new object to the nodeDataArray
                this.nodeDataArray.push(newBaseFrameRow);

                // Update the currentPosX for the next BaseFrameRow
                currentPosX += width;
              }
            }
          } else {
            maximumMCCBInTier = Math.floor((selectedMaxTierHeight - BusBarChamberHeight - 200) / shapeHeight);
            console.log('maximumMCCBInTier', maximumMCCBInTier);
            TotalMCCBTiers = Math.ceil(this.numberOfOutgoing / maximumMCCBInTier);
            console.log("TotalMCCBTiers", TotalMCCBTiers);
            let RemainsMCCBcount = 0;
            for (let i = 0; i < TotalMCCBTiers; i++) {


              let busbarChamberData = this.nodeDataArray
                .filter((item) => item.category === "busbarChamber") // Filter elements with category "busbarChamber"
                .reduce(
                  (maxData, currentItem) => {
                    const currentPosX = Number(currentItem.pos.split(" ")[0]); // Extract pos[0] as a number
                    const currentSizeX = Number(currentItem.size.split(" ")[0]); // Extract size[0] as a number

                    if (currentPosX > maxData.maxPosX) {
                      // Update maxPosX and its corresponding sizeX
                      return { maxPosX: currentPosX, maxSizeX: currentSizeX };
                    }

                    return maxData; // Keep the existing maximum if currentPosX is smaller
                  },
                  { maxPosX: Number.NEGATIVE_INFINITY, maxSizeX: 0 } // Initialize with default values
                );

              let StartPositionNextTier = busbarChamberData.maxPosX + busbarChamberData.maxSizeX;

              console.log("Maximum pos[0] for busbarChamber:", busbarChamberData.maxPosX);
              console.log("Maximum size[0] for corresponding busbarChamber:", busbarChamberData.maxSizeX);
              console.log("StartPositionNextTier:", StartPositionNextTier);



              const BusBarChamber1 = {
                "uuid": "254134ba1dad",
                "text": "Busbar Chamber",
                "color": "#bdae91",
                "size": `${shapeWidth} ${BusBarChamberHeight}`,
                "type": "rectangle",
                "category": "busbarChamber",
                "top": false, "side": false,
                "innerProfile": false,
                "tool": "main",
                "ports": [{}],
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
                "pos": `${StartPositionNextTier} -1100`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }

              const MccbRow = {
                'uuid': '9a4b5c6d7e8f',
                'text': 'MCCB',
                'color': '#bdae91',
                'size': `${shapeWidth} ${shapeHeight}`, // Update size
                'tool': 'main',
                'type': 'rectangle',
                'category': 'electricalMCCB',
                'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
                "pos": `${StartPositionNextTier} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight}`,
                'group': this.uniqueKey(),
                'properties': { ...this.matchingRowMCCB },
                "ports": [{}],
                'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
                'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
                'innerProfile': false,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing",
                "mccbcont": `${this.numberOfOutgoing}`
              };
              MccbRow.properties.imagePath = MccbRow.properties.ImagePath;
              let previousMccbRowSize = 0;
              let CurrenttotalMccbRowHeight = 0;
              let addCableChamber = false;
              let totalMccbRowHeight = 0;
              let totalMccbCountOFFirstTier = 0;
              console.log('this.numberOfOutgoing', this.numberOfOutgoing)

              for (let j = 0; j < this.numberOfOutgoing; j++) {
                const currentMccbRow = { ...MccbRow }; // Create a copy of MccbRow

                // Adjust pos based on previousMccbRowSize
                currentMccbRow.pos = `${StartPositionNextTier} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight + previousMccbRowSize}`;
                CurrenttotalMccbRowHeight += currentMccbRow.shapeSize.height;
                // Push the created MccbRow into the nodeDataArray
                if (CurrenttotalMccbRowHeight <= baseFrameHeight - parseInt(BusBarChamber1.size.split(' ')[1])) {
                  this.nodeDataArray.push(currentMccbRow);
                  totalMccbRowHeight += currentMccbRow.shapeSize.height;
                  totalMccbCountOFFirstTier++;
                } else {
                  addCableChamber = true;
                }


                // Update previousMccbRowSize for the next iteration
                previousMccbRowSize += currentMccbRow.shapeSize.height;
              }
              this.numberOfOutgoing = this.numberOfOutgoing - totalMccbCountOFFirstTier;
              const horizontalBusBar1 = {
                "uuid": "5432ceba1dad",
                "text": "Horizontal Busbar",
                "color": "#bdae91",
                "size": `${shapeWidth} 20`,
                "type": "square",
                "category": "busbary",
                "with": "mccb",
                "tool": "main",
                "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
                "pos": `${StartPositionNextTier} -1000`,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }

              const verticalBusBar1 = {
                "uuid": "9974ceba1dad",
                "text": "Vertical Busbar",
                "color": "#bdae91",
                "size": `20 ${totalMccbRowHeight}`,
                "type": "square",
                "category": "busbarx",
                "with": "mccb",
                "tool": "main",
                "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_VR.svg",
                "pos": `${StartPositionNextTier + shapeWidth / 2} -1100`,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }
              let remainingHeightToDoor = baseFrameHeight - (parseInt(BusBarChamber1.size.split(' ')[1]) + totalMccbRowHeight);
              const Door1 = {
                "uuid": "4279ceba1dad",
                "text": "Door",
                "color": "#bdae91",
                "size": `${shapeWidth} ${remainingHeightToDoor}`,
                "type": "square",
                "category": "door",
                "tool": "main",
                "top": false,
                "side": false,
                "innerProfile": false,
                "ports": [{}],
                "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
                'pos': `${StartPositionNextTier} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight + totalMccbRowHeight}`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }
              console.log("totalMccbRowHeight", totalMccbRowHeight);

              console.log("RemainsMCCBcount", RemainsMCCBcount);
              const BusBarChamberInChemberTier = {
                "uuid": "254134ba1dad",
                "text": "Busbar Chamber",
                "color": "#bdae91",
                "size": `${shapeWidth} ${BusBarChamberHeight}`,
                "type": "rectangle",
                "category": "busbarChamber",
                "top": false, "side": false,
                "innerProfile": false,
                "tool": "main",
                "ports": [{}],
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
                "pos": `${StartPositionNextTier + shapeWidth} -1100`,
                'group': this.uniqueKey(),
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }
              const remainingHeightCableChamber = baseFrameHeight - parseInt(BusBarChamberInChemberTier.size.split(' ')[1]);
              const CableChamber = {
                "uuid": "6549ceba1dad",
                "text": "Cable Chamber",
                "color": "#bdae91",
                "size": `${shapeWidth} ${remainingHeightCableChamber}`,
                "type": "rectangle",
                "category": "cableChamber",
                "chamberType": "Cover",
                "top": false,
                "tool": "main",
                "side": false,
                "innerProfile": true,
                "ports": [{}],
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cable_CH.svg",
                "pos": `${StartPositionNextTier + shapeWidth} ${parseInt(BusBarChamberInChemberTier.pos.split(' ')[1]) + BusBarChamberHeight}`,
                'group': this.uniqueKey(),
                "glandData": { "properties": { "GlandPlateAThickness": "3.0mm", "view": "top" } },
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              };
              const horizontalBusBarInRemainingCableChamberTier = {
                "uuid": "5432ceba1dad",
                "text": "Horizontal Busbar",
                "color": "#bdae91",
                "size": `${shapeWidth} 20`,
                "type": "square",
                "category": "busbary",
                "with": "mccb",
                "tool": "main",
                "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
                "pos": `${StartPositionNextTier + shapeWidth} -1000`,
                "page": `${this.currentOutGoingPage}`,
                "tire": "Outgoing"
              }


              this.nodeDataArray.push(BusBarChamber1);
              if (remainingHeightToDoor > 0) {
                this.nodeDataArray.push(Door1);
                const startPosition = -1000 + totalBaseFrameWidth + shapeWidth * i * 2;
                this.DoorShiftUndertheTier(startPosition, selectedMaxTierHeight);
                if (remainingHeightToDoor === 100) {
                  this.adjustLastPushedDoor()
                } else {
                  this.AdditionalDoorDataArray = [];
                  this.AdditionalDoorDataArray.push(Door1);
                }
              }
              this.nodeDataArray.push(BusBarChamberInChemberTier);
              this.nodeDataArray.push(CableChamber);
              this.nodeDataArray.push(horizontalBusBar1);
              this.nodeDataArray.push(verticalBusBar1);
              this.nodeDataArray.push(horizontalBusBarInRemainingCableChamberTier);
            }
            RemainsMCCBcount = this.numberOfOutgoing;
            if (RemainsMCCBcount > 0) {

              let lastBusbarChamberPositionx = 0;
              const BusbarChamberElement = this.nodeDataArray.slice().reverse().find(element => element.category === "busbarChamber");
              if (BusbarChamberElement) {
                const MccbRow = {
                  'uuid': '9a4b5c6d7e8f',
                  'text': 'MCCB',
                  'color': '#bdae91',
                  'size': `${shapeWidth} ${shapeHeight}`, // Update size
                  'tool': 'main',
                  'type': 'rectangle',
                  'category': 'electricalMCCB',
                  'image': '.../../../../assets/media/icons/kikcad_2D_Icon_ACB.svg',
                  "pos": `${-1000} ${1000}`,
                  'group': this.uniqueKey(),
                  'properties': { ...this.matchingRowMCCB },
                  "ports": [{}],
                  'pictureSize': { width: pictureWidth, height: pictureHeight }, // Update pictureSize
                  'shapeSize': { width: shapeWidth, height: shapeHeight }, // Update shapeSize
                  'innerProfile': false,
                  "page": `${this.currentOutGoingPage}`,
                  "tire": "Outgoing",
                  "mccbcont": `${this.numberOfOutgoing}`
                };
                MccbRow.properties.imagePath = MccbRow.properties.ImagePath;
                const positionParts = BusbarChamberElement.pos.split(' ');
                lastBusbarChamberPositionx = parseFloat(positionParts[0]);
                console.log("lastBusbarChamberPositionx", lastBusbarChamberPositionx);
                const BusBarChamber1 = {
                  "uuid": "254134ba1dad",
                  "text": "Busbar Chamber",
                  "color": "#bdae91",
                  "size": `${shapeWidth} ${BusBarChamberHeight}`,
                  "type": "rectangle",
                  "category": "busbarChamber",
                  "top": false, "side": false,
                  "innerProfile": false,
                  "tool": "main",
                  "ports": [{}],
                  "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
                  "pos": `${lastBusbarChamberPositionx + shapeWidth} -1100`,
                  'group': this.uniqueKey(),
                  "page": `${this.currentOutGoingPage}`,
                  "tire": "Outgoing"
                }
                this.nodeDataArray.push(BusBarChamber1);
                let previousMccbRowSize = 0;
                let CurrenttotalMccbRowHeight = 0;
                let addCableChamber = false;
                let totalMccbRowHeight = 0;
                let totalMccbCountOFFirstTier = 0;
                for (let j = 0; j < RemainsMCCBcount; j++) {
                  const currentMccbRow = { ...MccbRow }; // Create a copy of MccbRow

                  // Adjust pos based on previousMccbRowSize
                  currentMccbRow.pos = `${lastBusbarChamberPositionx + shapeWidth} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight + previousMccbRowSize}`;
                  CurrenttotalMccbRowHeight += currentMccbRow.shapeSize.height;
                  // Push the created MccbRow into the nodeDataArray
                  if (CurrenttotalMccbRowHeight <= baseFrameHeight - parseInt(BusBarChamber1.size.split(' ')[1])) {
                    this.nodeDataArray.push(currentMccbRow);
                    totalMccbRowHeight += currentMccbRow.shapeSize.height;
                    totalMccbCountOFFirstTier++;
                  } else {
                    addCableChamber = true;
                    // currentMccbRow.pos = `${-1000 + baseFrameWidth + shapeWidth} ${parseInt(BusBarChamber.pos.split(' ')[1]) + busBarChamberSizeHeight + previousMccbRowSize}`;
                    // this.nodeDataArray.push(currentMccbRow);
                  }


                  // Update previousMccbRowSize for the next iteration
                  previousMccbRowSize += currentMccbRow.shapeSize.height;
                }



                let remainingHeightForRemainingDoor = baseFrameHeight - (BusBarChamberHeight + totalMccbRowHeight);
                const Door1 = {
                  "uuid": "4279ceba1dad",
                  "text": "Door",
                  "color": "#bdae91",
                  "size": `${shapeWidth} ${remainingHeightForRemainingDoor}`,
                  "type": "square",
                  "category": "door",
                  "tool": "main",
                  "top": false,
                  "side": false,
                  "innerProfile": false,
                  "ports": [{}],
                  "image": "../../../../assets/media/icons/kikcad_2D_Icon_Door.svg",
                  'pos': `${lastBusbarChamberPositionx + shapeWidth} ${parseInt(BusBarChamber1.pos.split(' ')[1]) + BusBarChamberHeight + previousMccbRowSize}`,
                  'group': this.uniqueKey(),
                  "page": `${this.currentOutGoingPage}`,
                  "tire": "Outgoing"
                }
                if (remainingHeightForRemainingDoor > 0) {
                  this.nodeDataArray.push(Door1);
                  if (remainingHeightForRemainingDoor === 100) {
                    this.adjustLastPushedDoor()
                  } else {
                    this.AdditionalDoorDataArray.push(Door1);
                  }
                }
                console.log("this.nodeDataArray", this.nodeDataArray);
                const BusBarChamberInChemberTier = {
                  "uuid": "254134ba1dad",
                  "text": "Busbar Chamber",
                  "color": "#bdae91",
                  "size": `${shapeWidth} ${BusBarChamberHeight}`,
                  "type": "rectangle",
                  "category": "busbarChamber",
                  "top": false, "side": false,
                  "innerProfile": false,
                  "tool": "main",
                  "ports": [{}],
                  "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_Ch.svg",
                  "pos": `${lastBusbarChamberPositionx + shapeWidth * 2} -1100`,
                  'group': this.uniqueKey(),
                  "page": `${this.currentOutGoingPage}`,
                  "tire": "Outgoing"
                }
                const remainingHeightCableChamber = baseFrameHeight - parseInt(BusBarChamberInChemberTier.size.split(' ')[1]);
                const CableChamber = {
                  "uuid": "6549ceba1dad",
                  "text": "Cable Chamber",
                  "color": "#bdae91",
                  "size": `${shapeWidth} ${remainingHeightCableChamber}`,
                  "type": "rectangle",
                  "category": "cableChamber",
                  "chamberType": "Cover",
                  "top": false,
                  "tool": "main",
                  "side": false,
                  "innerProfile": true,
                  "ports": [{}],
                  "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Cable_CH.svg",
                  "pos": `${lastBusbarChamberPositionx + shapeWidth * 2} ${parseInt(BusBarChamberInChemberTier.pos.split(' ')[1]) + BusBarChamberHeight}`,
                  'group': this.uniqueKey(),
                  "glandData": { "properties": { "GlandPlateAThickness": "3.0mm", "view": "top" } },
                  "page": `${this.currentOutGoingPage}`,
                  "tire": "Outgoing"
                };

                const horizontalBusBarInChemberTier = {
                  "uuid": "5432ceba1dad",
                  "text": "Horizontal Busbar",
                  "color": "#bdae91",
                  "size": `${shapeWidth} 20`,
                  "type": "square",
                  "category": "busbary",
                  "with": "mccb",
                  "tool": "main",
                  "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
                  "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_HR.svg",
                  "pos": `${lastBusbarChamberPositionx + shapeWidth * 2} -1000`,
                  "page": `${this.currentOutGoingPage}`,
                  "tire": "Outgoing"
                }

                this.nodeDataArray.push(BusBarChamberInChemberTier);
                this.nodeDataArray.push(CableChamber);
                this.nodeDataArray.push(horizontalBusBarInChemberTier);


              }
            }
            let LastbaseFrameElementPosX = parseInt(LastbaseFrameElement.pos.split(' ')[0]) + parseInt(LastbaseFrameElement.size.split(' ')[0])
            const LastBusbarChamberElement = this.nodeDataArray.slice().reverse().find(element => element.category === "busbarChamber");
            if (LastBusbarChamberElement) {
              let LastBusbarChamberElementPosX = parseInt(LastBusbarChamberElement.pos.split(' ')[0]) + parseInt(LastBusbarChamberElement.size.split(' ')[0]);;
              let fullWidthOfNewOutCommers = LastBusbarChamberElementPosX - LastbaseFrameElementPosX;
              this.widthArrayNextOutgoing = []
              if (fullWidthOfNewOutCommers <= 2400) {
                this.widthArrayNextOutgoing.push(fullWidthOfNewOutCommers);
              } else {
                // Calculate how many 2400 values are needed
                while (fullWidthOfNewOutCommers > 2400) {
                  this.widthArrayNextOutgoing.push(2400);
                  fullWidthOfNewOutCommers -= 2400;
                }
                // Push the remaining value if it's greater than 0
                if (fullWidthOfNewOutCommers > 0) {
                  this.widthArrayNextOutgoing.push(fullWidthOfNewOutCommers);
                }
              }
              const initialPosX = LastbaseFrameElementPosX;  // Initial x position for the first BaseFrameRow
              const posY = -1100;         // Constant y position for all BaseFrameRows
              let currentPosX = initialPosX;  // Variable to track the current x position

              for (let i = 0; i < this.widthArrayNextOutgoing.length; i++) {
                const width = this.widthArrayNextOutgoing[i];

                // Create a new BaseFrameRow object
                const newBaseFrameRow = {
                  uuid: this.uniqueKey(),  // Generate a unique UUID for each row as needed
                  text: "Base Frame",
                  color: "#bdae91",
                  isGroup: true,
                  size: `${width} ${selectedMaxTierHeight}`,
                  type: "rectangle",
                  category: "outerProfile",
                  tool: "main",
                  selectedOption: null,
                  pos: `${currentPosX} ${posY}`,
                  image: ".../../../../assets/media/icons/kikcad_2D_Icon_Base_Frame.svg",
                  loc: `${currentPosX + 50} ${posY + 50}`,  // Adjusted loc based on pos
                  tire: "Outgoing",
                  page: `${this.currentOutGoingPage}`,
                };

                // Push the new object to the nodeDataArray
                this.nodeDataArray.push(newBaseFrameRow);

                // Update the currentPosX for the next BaseFrameRow
                currentPosX += width;
              }
            }
          }

        } else {
          console.log("ANEEEEEE MKUTH NADDA????????");
        }

      }


      this.selectedManufacturerMCCB = null;
      this.selectedRatedAmpMCCB = null;
      this.selectedFrameSizeMCCB = null;
      this.selectedPRFLevelMCCB = null;
      this.selectedShortCircuitIcuMCCB = null;
      this.selectedTripUnitMCCB = null;
      this.selectedRotation = null;
      this.selectedOrderNumberMCCB = null;
      this.selectedTypeMCCB = null;
      this.matchingRowMCCB = null;
      this.numberOfOutgoing = 1;
      this.selectedRotation = 'Vertical';

      this.animateNext = true; // Trigger right slide animation
      this.animatePrevious = false;

      this.currentOutGoingPage++;

      // Reset animation flags after the animation completes
      this.resetAnimationFlags();
      this.addPorts();
    } else {
      console.error('No cubicle size found for the selected rated ampere.');
    }
    console.log("this.nodeDataArray", this.nodeDataArray);
  }
  previous() {
    if (this.currentIncomerPage === 2) {
      this.nodeDataArray = [];
    } else {
      let baseFrameWidth = 0;
      let shapeWidth = 0;

      // Get the Final text: "ACB" size[0] as shapeWidth
      const acbElements = this.nodeDataArray.filter(element => element.text === "ACB" || element.text === "MCCB");
      if (acbElements.length > 0) {
        const lastAcbElement = acbElements[acbElements.length - 1];
        const sizeParts = lastAcbElement.size.split(' ');
        shapeWidth = parseFloat(sizeParts[0]); // Get the width part
      }

      if (this.nodeDataArray && this.nodeDataArray.length > 0) {
        // Check if an element with the text "Base Frame" exists
        const baseFrameElement = this.nodeDataArray.find(element => element.category === "outerProfile");
        if (baseFrameElement) {
          const sizeParts = baseFrameElement.size.split(' '); // Split size string by whitespace
          baseFrameWidth = parseFloat(sizeParts[0]); // Parse the width part to a float

          if (!isNaN(baseFrameWidth)) {
            // Check if parsing was successful
            let baseWidth = baseFrameWidth - shapeWidth;
            sizeParts[0] = baseWidth.toString(); // Update the first part of sizeParts array
            baseFrameElement.size = sizeParts.join(' ');
            // Update the value in the array
          } else {
            // Handle the case where width is not a valid number
            // For example:
            // shapeWidth += defaultValue; // Add a default value
          }
        }
      }

      // Splice the array
      const lastIndex = this.nodeDataArray.length - 1;
      this.nodeDataArray.splice(lastIndex - 5, 6);
    }
    if (this.incomerHistory.length > 0) {
      this.isMovingToPreviousIncomer = true;
      const previousIncomer = this.incomerHistory[this.incomerHistory.length - 1];
      if (previousIncomer) {
        // Restore previous incomer details
        this.selectedManufacturer = previousIncomer.selectedManufacturer;
        this.selectedRatedAmp = previousIncomer.selectedRatedAmp;
        this.selectedType = previousIncomer.selectedType;
        this.selectedFrameSize = previousIncomer.selectedFrameSize;
        this.selectedPRFLevel = previousIncomer.selectedPRFLevel;
        this.selectedShortCircuitIcu = previousIncomer.selectedShortCircuitIcu;
        this.selectedMaxTierHeight = previousIncomer.selectedMaxTierHeight;
        this.matchingRow = previousIncomer.matchingRow;
        this.imagePath = previousIncomer.imagePath;

        this.updateDropdownOptions();
      } else {
        console.error('Previous incomer is undefined');
      }
    } else {
      console.warn('No previous incomer to navigate to');
    }
    this.incomerHistory.pop();


    this.showMCCB = false;
    this.currentPage--;
    this.animateNext = false;
    this.animatePrevious = true;
    this.resetAnimationFlags();
  }
  previousOutgoing() {
    this.showMCCB = true;
    this.showProjectDetails = false;
    this.currentPage--;
    this.animateNext = false;
    this.animatePrevious = true;
    this.resetAnimationFlags();
    this.addmccbampRow();
    this.addBusbarMccb();
    this.addPorts()
  }
  addBusbarMccb() {
    // Create a map to track nodes by their xPos
    const xPosMap = new Map();
    let nearestBusbar;
    let totalMccbRowHeight = 0;
    // Iterate over each node in the nodeDataArray
    this.nodeDataArray.forEach(node => {
      if (node.category === 'electricalMCCB' && node.text === 'MCCB' || (node.category === "busbary" || node.category === "busbarx" && node.with === "mccb") || node.category === "busbarChamber") {
        const pos = node.pos.split(' ');
        const size = node.size.split(' ');
        const xPos = parseInt(pos[0], 10);

        if (node.category === 'busbarx' && node.with === 'mccb') {
          // Handle busbarx nodes with 'mccb' separately
          // Adjust the xPos based on the busbarChamber width
          const busbarChamberNode = this.nodeDataArray.find(n => n.category === 'busbarChamber' && n.text === 'Busbar Chamber');
          if (busbarChamberNode) {
            const busbarChamberSize = busbarChamberNode.size.split(' ');
            const busbarChamberWidth = parseInt(busbarChamberSize[0], 10);
            const modifiedPos = xPos - busbarChamberWidth / 2;

            // Add the modified node to the map
            if (xPosMap.has(modifiedPos)) {
              xPosMap.get(modifiedPos).push(node);
            } else {
              xPosMap.set(modifiedPos, [node]);
            }
          }
        } else {
          // For other nodes, use their original xPos
          if (xPosMap.has(xPos)) {
            xPosMap.get(xPos).push(node);
          } else {
            xPosMap.set(xPos, [node]);
          }
        }


        // Assuming xPosMap is your map of xPos to nodes array
        xPosMap.forEach((nodes, xPos) => {
          if (nodes.length > 0) {
            nodes.forEach(node => {
              if (node.properties && node.properties.RATED_AMP !== undefined) {
                const mccbNodes = nodes.filter(node => node.category === 'electricalMCCB' && node.text === 'MCCB')
                const nodeAmp = mccbNodes.reduce((total, mccbNode) => total + Number(mccbNode.properties.RATED_AMP), 0);
                const totalWidth = mccbNodes.reduce((total, mccbNode) => {
                  const [width, height] = mccbNode.size.split(' ').map(Number); // Split the string and convert to numbers
                  return total + width; // Sum the width
                }, 0);
                totalMccbRowHeight = totalWidth
                if (this.selectedBusbarType === 'Busbar Support - Flat') {
                  nearestBusbar = this.findNearestBusbar(nodeAmp, this.busBarData.mainHorizontal);
                } else if (this.selectedBusbarType === 'Busbar Support With Grooves') {
                  nearestBusbar = this.findNearestBusbar(nodeAmp, this.busBarData.dropper);
                } else {
                  console.error('Invalid busbar type selected');
                  return;
                }
              } else {

              }
              // Check if busbarSize exists before adding it to nearestBusbar
              if (node.category === 'busbary' || node.category === "busbarx" && node.with === "mccb") {
                node.properties.busbarSize = nearestBusbar
              }

              if (node.category === "busbarx" && node.with === "mccb") {
                node.size = `20 ${totalMccbRowHeight}`;
              }
            });


          }
        });
      }
    });
  }
  // Function to find nearest busbar by ampere value
  findNearestBusbar(targetAmpere: number, busbars: any[]) {
    return busbars.reduce((prev, curr) => {
      return (Math.abs(curr.ampere - targetAmpere) < Math.abs(prev.ampere - targetAmpere) ? curr : prev);
    });
  }
  addmccbampRow() {
    // Create a map to group nodes by their x-position
    const xPosMap = new Map;

    // Iterate through each node in nodeDataArray
    this.nodeDataArray.forEach((node) => {
      // Check if the node is of the desired category and type
      if (node.category === 'electricalMCCB' && node.text === 'MCCB') {
        // Split the position string and parse the x-position
        const pos = node.pos.split(' ');
        const xPos = parseInt(pos[0], 10);

        // Retrieve or initialize the array for this x-position
        if (xPosMap.has(xPos)) {
          xPosMap.get(xPos).push(node);
        } else {
          xPosMap.set(xPos, [node]);
        }
      }
    });

    // Iterate over each x-position and its associated nodes
    xPosMap.forEach((nodes, xPos) => {
      if (nodes.length > 0) {
        // Sort nodes by RATED_AMP in ascending order
        nodes.sort((a, b) => {
          const ratedAmpA = parseInt(a.properties.RATED_AMP, 10);
          const ratedAmpB = parseInt(b.properties.RATED_AMP, 10);
          return ratedAmpA - ratedAmpB;
        });

        // Extract and sort initial y-positions in descending order
        let currentY = Math.min(...nodes.map((node) => parseInt(node.pos.split(' ')[1], 10)));

        // Update positions based on the sorted order
        nodes.forEach((node) => {
          const height = parseInt(node.size.split(' ')[1], 10);
          node.pos = `${xPos} ${currentY}`;
          currentY += height; // Increment currentY for the next node
        });
      }
    });
  }


  addPorts() {
    this.nodeDataArray.forEach(node => {
      const category = node.category;
      const size = node.size; // Use optional chaining to handle undefined node.data
      if (size) {
        const dimensions = size.split(' ');
        const width = parseInt(dimensions[0], 10);
        const height = parseInt(dimensions[1], 10);

        const portArray = [];

        if (category === 'door') {
          if (height < 400) {
            portArray.push({ position: '20 ' + (height / 2 - 5) });
          } else if (height < 800) {
            portArray.push({ position: '20 30' });
            portArray.push({ position: '20 ' + (height - 30) });
          } else {
            portArray.push({ position: '20 30' });
            portArray.push({ position: '20 ' + (height - 30) });
            portArray.push({ position: '20 ' + (height / 2 - 5) });
          }
          console.log('portArray', portArray)
          node.ports.push(...portArray);
        }

        if (category === 'electricalACB' || category === 'electricalMCCB') {
          if (width > 1000) {
            if (height < 800) {
              portArray.push({ position: '20 20' });
              portArray.push({ position: '20 ' + (height - 30) });
              portArray.push({ position: (width - 30) + ' 20' });
              portArray.push({ position: (width - 30) + ' ' + (height - 30) });
            } else if (height < 1100) {
              portArray.push({ position: '20 20' });
              portArray.push({ position: '20 ' + (height - 30) });
              portArray.push({ position: (width - 30) + ' 20' });
              portArray.push({ position: (width - 30) + ' ' + (height - 30) });
              portArray.push({ position: '20 ' + (height / 2) });
              portArray.push({ position: (width - 30) + ' ' + (height / 2) });
            } else {
              const t = height / 3;
              portArray.push({ position: '20 20' });
              portArray.push({ position: '20 ' + (height - 30) });
              portArray.push({ position: (width - 30) + ' 20' });
              portArray.push({ position: (width - 30) + ' ' + (height - 30) });
              portArray.push({ position: '20 ' + (~~t - 10) });
              portArray.push({ position: (width - 30) + ' ' + (~~t - 10) });
              portArray.push({ position: '20 ' + ((~~t * 2) - 10) });
              portArray.push({ position: (width - 30) + ' ' + ((~~t * 2) - 10) });
            }
          } else {
            if (height < 400) {
              portArray.push({ position: '20 ' + (height / 2 - 5) });
            } else if (height < 800) {
              portArray.push({ position: '20 30' });
              portArray.push({ position: '20 ' + (height - 50) });
            } else {
              portArray.push({ position: '20 30' });
              portArray.push({ position: '20 ' + (height - 30) });
              portArray.push({ position: '20 ' + (height / 2 - 5) });
            }
          }
          // Ensure node.ports is initialized
          if (!node.ports) {
            node.ports = [];
          }
          node.ports.push(...portArray);
        }

        if (category === 'cover' || category === 'cableChamber' || category === 'busbarChamber') {
          if (category === 'cableChamber' && node.data?.chamberType === 'Door') {
            if (height < 400) {
              portArray.push({ position: '20 ' + (height / 2 - 5) });
            } else if (height < 800) {
              portArray.push({ position: '20 30' });
              portArray.push({ position: '20 ' + (height - 30) });
            } else {
              portArray.push({ position: '20 30' });
              portArray.push({ position: '20 ' + (height - 30) });
              portArray.push({ position: '20 ' + (height / 2 - 5) });
            }
          } else {
            if (height < 800) {
              portArray.push({ position: '20 20' });
              portArray.push({ position: '20 ' + (height - 30) });
              portArray.push({ position: (width - 30) + ' 20' });
              portArray.push({ position: (width - 30) + ' ' + (height - 30) });
            } else if (height < 1100) {
              portArray.push({ position: '20 20' });
              portArray.push({ position: '20 ' + (height - 30) });
              portArray.push({ position: (width - 30) + ' 20' });
              portArray.push({ position: (width - 30) + ' ' + (height - 30) });
              portArray.push({ position: '20 ' + (height / 2) });
              portArray.push({ position: (width - 30) + ' ' + (height / 2) });
            } else {
              const t = height / 3;
              portArray.push({ position: '20 20' });
              portArray.push({ position: '20 ' + (height - 30) });
              portArray.push({ position: (width - 30) + ' 20' });
              portArray.push({ position: (width - 30) + ' ' + (height - 30) });
              portArray.push({ position: '20 ' + (~~t - 10) });
              portArray.push({ position: (width - 30) + ' ' + (~~t - 10) });
              portArray.push({ position: '20 ' + ((~~t * 2) - 10) });
              portArray.push({ position: (width - 30) + ' ' + ((~~t * 2) - 10) });
            }
          }
          // Ensure node.ports is initialized
          if (!node.ports) {
            node.ports = [];
          }
          node.ports.push(...portArray);
        }
      }
    });
  }

  adjustLastPushedDoor() {
    console.log("Starting adjustLastPushedDoor function.");
    console.log("Initial nodeDataArray:", this.nodeDataArray);

    // Reverse loop over the nodeDataArray to find the last pushed "Door" element
    for (let i = this.nodeDataArray.length - 1; i >= 0; i--) {
      const doorElement = this.nodeDataArray[i] as { [key: string]: any };
      console.log(`Inspecting element at index ${i}:`, doorElement);

      if (doorElement.text === "Door") {
        console.log("Found a door element:", doorElement);

        const doorPosX = parseInt(doorElement.pos.split(' ')[0], 10);
        const doorPosY = parseInt(doorElement.pos.split(' ')[1], 10);
        const doorHeight = parseInt(doorElement.size.split(' ')[1], 10);

        console.log(`Door position: (${doorPosX}, ${doorPosY}), height: ${doorHeight}`);

        if (doorHeight === 100) {
          console.log("Door height is 100, proceeding with modification...");

          let elementAboveDoor: { [key: string]: any } | null = null;

          this.nodeDataArray.forEach((element, index) => {
            const elementTyped = element as { [key: string]: any };
            const elementPosX = parseInt(elementTyped.pos.split(' ')[0], 10);
            const elementPosY = parseInt(elementTyped.pos.split(' ')[1], 10);
            const elementHeight = parseInt(elementTyped.size.split(' ')[1], 10);

            console.log(`Inspecting element at index ${index} for element above door:`, elementTyped);

            if (elementPosX === doorPosX && elementPosY + elementHeight === doorPosY) {
              // Deep copy to ensure we don't modify references
              elementAboveDoor = JSON.parse(JSON.stringify(elementTyped));
              console.log("Found element above the door:", elementAboveDoor);
            }
          });

          if (elementAboveDoor) {
            const originalPos = elementAboveDoor.pos;
            const originalSize = elementAboveDoor.size;

            const elementAboveHeight = parseInt(elementAboveDoor.size.split(' ')[1], 10);
            elementAboveDoor.size = `${elementAboveDoor.size.split(' ')[0]} ${elementAboveHeight - 100}`;
            console.log(`Updated element above door size: ${elementAboveDoor.size}`);

            if (elementAboveDoor.properties && elementAboveDoor.properties.cubicleHeight) {
              elementAboveDoor.properties.cubicleHeight -= 100;
              console.log(`Updated element above door cubicleHeight: ${elementAboveDoor.properties.cubicleHeight}`);
            }

            if (elementAboveDoor.shapeSize && elementAboveDoor.shapeSize.height) {
              elementAboveDoor.shapeSize.height -= 100;
              console.log(`Updated element above door shapeSize.height: ${elementAboveDoor.shapeSize.height}`);
            }

            const elementAboveIndex = this.nodeDataArray.findIndex(
              (el) => el.pos === originalPos && el.size === originalSize
            );

            if (elementAboveIndex !== -1) {
              this.nodeDataArray[elementAboveIndex] = elementAboveDoor;
              console.log(`Updated nodeDataArray at index ${elementAboveIndex} with element above the door:`, elementAboveDoor);
            }

            // Now adjust the door element
            doorElement.size = `${doorElement.size.split(' ')[0]} 200`;
            console.log(`Updated door element size to: ${doorElement.size}`);

            doorElement.pos = `${doorElement.pos.split(' ')[0]} ${doorPosY - 100}`;
            console.log(`Updated door element position to: ${doorElement.pos}`);

            this.nodeDataArray[i] = doorElement;
            console.log(`Updated nodeDataArray at index ${i} with door element:`, doorElement);

            console.log("Updated the last pushed door height to 200 and reduced element above by 100.");
            console.log("Updated nodeDataArray:", this.nodeDataArray);
            break;
          } else {
            console.log("No element found above the door.");
          }
        } else {
          console.log(`Door height is not 100, skipping modification (door height: ${doorHeight}).`);
        }
      } else {
        console.log("Element is not a door, moving to the next.");
      }
    }
    console.log("Finished adjustLastPushedDoor function.");
  }
  updateRotationBasedOnRatedAmp() {
    if (this.selectedRatedAmpMCCB) {
      const ratedAmp = Number(this.selectedRatedAmpMCCB); // Convert to number
      if (!isNaN(ratedAmp)) { // Check if conversion is successful
        if (ratedAmp < 1600) {
          this.selectedRotation = 'Horizontal'; // Set to Horizontal if < 1600
        } else {
          this.selectedRotation = 'Vertical'; // Set to Vertical if >= 1600
        }
      } else {
        console.error('Invalid rated amp value:', this.selectedRatedAmpMCCB);
      }
    }
  }
  associateProfilesWithOuterProfile() {
    // Step 1: Remove all existing 'outerProfile' elements
    this.nodeDataArray = this.nodeDataArray.filter(element => element.category !== 'outerProfile');

    // Step 2: Group 'Busbar Chamber' elements by their Y position and sort by X position
    const groupedProfiles = new Map();
    let selectedMaxTierHeight;

    this.nodeDataArray.forEach((element, index) => {
      const pos = element.pos.split(' ');
      const xPos = parseInt(pos[0], 10);
      const sameXPosElements = this.nodeDataArray.filter((el) => {
        const elPos = el.pos.split(' ');
        return (
          parseInt(elPos[0], 10) === xPos &&
          el.category !== 'outerProfile' &&
          el.category !== 'busbarx' &&
          el.category !== 'busbary' &&
          el.category !== 'Earthbar' &&
          el.category !== 'seprationy' &&
          el.category !== 'seprationx' &&
          el.tool === 'main'
        );
      });
      sameXPosElements.sort((a, b) => parseInt(a.pos.split(' ')[1], 10) - parseInt(b.pos.split(' ')[1], 10));

      // Only process the first group of sameXPosElements
      if (index === 0 && sameXPosElements.length === 4) {
        selectedMaxTierHeight = sameXPosElements.reduce((acc, el) => {
          const sizeParts = el.size.split(' ');
          const height = parseInt(sizeParts[1], 10);
          if (!isNaN(height)) {
            return acc + height;
          } else {

            return acc;
          }
        }, 0);
      }


      if (element.category === "busbarChamber") {
        const [xPos, yPos] = element.pos.split(' ').map(Number);
        const width = Number(element.size.split(' ')[0]);

        if (!groupedProfiles.has(yPos)) {
          groupedProfiles.set(yPos, []);
        }

        groupedProfiles.get(yPos).push({ element, xPos, width });
      }
    });

    // Step 3: Process each Y-position group
    groupedProfiles.forEach((profiles, yPos) => {
      // Sort elements within the group by X position (left to right)
      profiles.sort((a, b) => a.xPos - b.xPos);

      // Initialize position for the new 'outerProfile' elements
      let currentX = profiles[0].xPos; // Start at the position of the first 'Busbar Chamber'
      let remainingWidth = 0;
      let accumulatedWidth = 0;

      // Iterate over profiles to calculate `outerProfile` widths
      for (let i = 0; i < profiles.length; i++) {
        const profile = profiles[i];
        accumulatedWidth += profile.width;

        if (accumulatedWidth > 2400) {
          // Create an `outerProfile` for the accumulated width (excluding the current profile)
          const outerProfile = {
            uuid: this.uniqueKey(),
            text: "Base Frame",
            color: "#bdae91",
            isGroup: true,
            size: `${accumulatedWidth - profile.width} ${selectedMaxTierHeight}`,
            type: "rectangle",
            category: "outerProfile",
            tool: "main",
            selectedOption: null,
            pos: `${currentX} ${yPos}`,
            image: ".../../../../assets/media/icons/kikcad_2D_Icon_Base_Frame.svg",
            tire: "Outgoing",
            page: `${this.currentOutGoingPage}`,
            join: "nextOutgoing"
          };

          this.nodeDataArray.push(outerProfile);

          // Reset accumulatedWidth and set currentX to the position of the current profile
          accumulatedWidth = profile.width;
          currentX = profile.xPos;
        }

        // If this is the last profile, add an `outerProfile` for the remaining width
        if (i === profiles.length - 1) {
          const outerProfile = {
            uuid: this.uniqueKey(),
            text: "Base Frame",
            color: "#bdae91",
            isGroup: true,
            size: `${accumulatedWidth} ${selectedMaxTierHeight}`,
            type: "rectangle",
            category: "outerProfile",
            tool: "main",
            selectedOption: null,
            pos: `${currentX} ${yPos}`,
            image: ".../../../../assets/media/icons/kikcad_2D_Icon_Base_Frame.svg",
            tire: "Outgoing",
            page: `${this.currentOutGoingPage}`,
            join: "nextOutgoing"
          };

          this.nodeDataArray.push(outerProfile);
        }
      }

      // Step 4: Associate each 'Busbar Chamber' element with the first 'outerProfile' UUID
      const firstOuterProfileUuid = this.nodeDataArray.find(
        profile => profile.pos === `${profiles[0].xPos} ${yPos}` && profile.category === 'outerProfile'
      ).uuid;

      profiles.forEach(profile => {
        profile.element.group = firstOuterProfileUuid;
      });
    });

    this.selectedItems = this.nodeDataArray;
  }

  setelmntGroupOuterProfile() {
    // Iterate through all elements in nodeDataArray
    this.nodeDataArray.forEach((outerProfile) => {
      // Check if the item is in the 'outerProfile' category
      if (outerProfile.category === "outerProfile") {
        const [outerStartX, outerStartY] = outerProfile.pos.split(' ').map(Number);
        const [outerWidth, outerHeight] = outerProfile.size.split(' ').map(Number);
        const outerEndX = outerStartX + outerWidth;
        const outerEndY = outerStartY + outerHeight;

        // Find all 'otherProfile' elements within the bounding box of the current 'outerProfile'
        this.nodeDataArray.forEach((element) => {
          if (element.category !== "outerProfile") {
            const [elementX, elementY] = element.pos.split(' ').map(Number);

            // Check if the element's position falls within the 'outerProfile' bounds
            if (
              elementX >= outerStartX &&
              elementX <= outerEndX &&
              elementY >= outerStartY &&
              elementY <= outerEndY
            ) {
              // Set the group property of the element to the outerProfile's UUID
              element.group = outerProfile.uuid;
            }
          }
        });
      }
    });

  }

  uniqueKey() {
    const baseId = "3514ceba1dad";
    const categoryCount = this.nodeDataArray.filter(node => node.category === "outerProfile").length + 1;
    return `${baseId}${categoryCount}`; // Combining baseId, count, and a unique UUID
  }
  configBusbar() {
    // Create a map to group items by their xpos
    const groupedByXpos: { [key: string]: any[] } = {};
    const xPosMap = new Map<number, { elements: any[], totalHeight: number }>();

    // Step 1: Group items by their xpos
    this.nodeDataArray.forEach(element => {
      const pos = element.pos.split(' ');
      const xpos = element.pos.split(' ')[0]; // Get the xpos value

      if (!groupedByXpos[xpos]) {
        groupedByXpos[xpos] = []; // Initialize array if it doesn't exist
      }
      groupedByXpos[xpos].push(element);

      // Get all Busbar Chamber nodes
      const busbarChamberNodes = this.nodeDataArray.filter(n => n.category === 'busbarChamber' || (n.category === 'cover' && n.text === 'Busbar Chamber'));

      // Process each Busbar Chamber node
      busbarChamberNodes.forEach(busbarChamberNode => {
        const busbarChamberSize = busbarChamberNode.size.split(' ');
        const busbarChamberWidth = parseInt(busbarChamberSize[0], 10);
        const busbarChamberXpos = parseInt(busbarChamberNode.pos.split(' ')[0], 10); // Extract xpos of Busbar Chamber

        const endXpos = busbarChamberXpos + busbarChamberWidth / 2;
        if (element.category === 'busbarx') {
          const pos = element.pos.split(' ');
          const xPos = parseInt(pos[0], 10); // Numeric value for x position

          if (xPos >= busbarChamberXpos && xPos <= endXpos) {
            // Add the current element to the xPosMap under the chamber's xpos key
            if (xPosMap.has(busbarChamberXpos)) {
              xPosMap.get(busbarChamberXpos).elements.push(element);
            } else {
              xPosMap.set(busbarChamberXpos, { elements: [element], totalHeight: 0 });
            }
          }
        }
      });
    });

    // Step 2: Iterate over grouped items by xpos
    for (const xpos in groupedByXpos) {
      const items = groupedByXpos[xpos].filter(element =>
        element.category !== 'outerProfile' &&
        element.category !== 'busbary' &&
        element.category !== 'Earthbar' &&
        element.category !== 'seprationy' &&
        element.category !== 'seprationx' &&
        element.tool === 'main'
      );

      // Sort items by their vertical position (y-axis)
      items.sort((a, b) => {
        const aY = parseInt(a.pos.split(' ')[1], 10);
        const bY = parseInt(b.pos.split(' ')[1], 10);
        return aY - bY;
      });

      let totalHeight = 0;
      let stopSumming = false;

      // Iterate through items and sum their heights
      items.forEach(item => {
        // If item category is 'electricalACB' or 'electricalMCCB', always sum its height
        if (item.category === 'electricalACB' || item.category === 'electricalMCCB') {
          const height = parseInt(item.size.split(' ')[1], 10);
          totalHeight += height; // Add height for this item
        } else if (!stopSumming) {
          // Sum other heights if stopSumming is not triggered
          const height = parseInt(item.size.split(' ')[1], 10);
          totalHeight += height;
        }

        // Stop summing when encountering 'electricalACB' or 'electricalMCCB'
        if (item.category === 'electricalACB' || item.category === 'electricalMCCB') {
          stopSumming = true; // This will stop adding heights for other items
        }
      });

      const xposinNu = Number(xpos);


      // Update xPosMap with the new totalHeight and elements
      if (xPosMap.has(xposinNu)) {
        const currentData = xPosMap.get(xposinNu);
        currentData.totalHeight = totalHeight;

        // Ensure the size is an array, split the string if necessary
        let size = currentData.elements[0].size.split(' ').map(Number); // Converts '20 600' to [20, 600]
        size[1] = currentData.totalHeight; // Update the second value in the size array to totalHeight

        currentData.elements[0].size = size.join(' '); // Convert back to string if required

      }
    }
  }



  removeDuplicateElements() {
    // Create a map to track `pos` values and their corresponding nodes
    const posMap = new Map();

    // Iterate through the array while tracking duplicates and logging them
    this.nodeDataArray = this.nodeDataArray.filter(node => {
      if (node.category !== "outerProfile" && node.category !== "busbary" && node.category !== "busbarx") {
        if (posMap.has(node.pos)) {
          // Log the duplicate and the original node
          console.log("Duplicate element found:", node);
          console.log("Original element:", posMap.get(node.pos));
          return false; // Exclude the duplicate
        } else {
          // Add unique `pos` to the map
          posMap.set(node.pos, node);
          return true; // Keep the node
        }
      }
      // Keep elements with excluded categories
      return true;
    });
    console.log("this.nodeDataArray", this.nodeDataArray);
  }
  unContremoveMccb() {
    // Group MCCBs by their RATED_AMP property
    const mccbGroups: { [ratedAmp: string]: any[] } = {};

    // Iterate over the nodeDataArray to group MCCBs by RATED_AMP
    this.nodeDataArray.forEach((node) => {
      if (node.category === 'electricalMCCB' && node.properties?.RATED_AMP) {
        const ratedAmp = node.properties.RATED_AMP;
        if (!mccbGroups[ratedAmp]) {
          mccbGroups[ratedAmp] = [];
        }
        mccbGroups[ratedAmp].push(node);
      }
    });

    // Update the mccbcont value for each MCCB based on the count of its group
    Object.keys(mccbGroups).forEach((ratedAmp) => {
      const group = mccbGroups[ratedAmp];
      const count = group.length;
      group.forEach((mccb) => {
        mccb.mccbcont = count;
      });
    });
    console.log('mccbGroups', mccbGroups)
  }

  AlignAllElements() {
    console.log("this.nodeDataArray", this.nodeDataArray);

    // Step 1: Extract busbarChamber elements
    const busbarChambers = this.nodeDataArray.filter(
      (item) => item.category === "busbarChamber"
    );

    busbarChambers.sort((a, b) => {
      const posAX = Number(a.pos.split(" ")[0]); // pos[0] of 'a'
      const posBX = Number(b.pos.split(" ")[0]); // pos[0] of 'b'
      return posAX - posBX; // Sort by pos[0] in ascending order
    });

    console.log("Sorted busbarChambers by pos[0]:", busbarChambers);

    console.log("busbarChambers", busbarChambers);

    // Step 2: Parse position and size for easier calculations
    busbarChambers.forEach((chamber) => {
      const posArray = chamber.pos.split(" ").map(Number); // pos[0], pos[1]
      const sizeArray = chamber.size.split(" ").map(Number); // size[0], size[1]

      // Assign pos[0], pos[1], size[0], size[1] directly
      chamber.posX = posArray[0]; // pos[0]
      chamber.posY = posArray[1]; // pos[1]
      chamber.sizeX = sizeArray[0]; // size[0]
      chamber.sizeY = sizeArray[1]; // size[1]
      chamber.isMatched = false; // Add a matched flag to each chamber
    });

    // Step 3: Find matched chambers
    const matchedChambers = []; // Array to hold matched chambers
    matchedChambers.push(busbarChambers[0]);

    busbarChambers.forEach((chamber, index) => {
      busbarChambers.forEach((otherChamber, otherIndex) => {
        if (index !== otherIndex) { // Avoid comparing the chamber to itself
          const isMatch = chamber.posX + chamber.sizeX === otherChamber.posX;
          if (isMatch) {
            matchedChambers.push(otherChamber);
          }
        }
      });
    });

    // Step 4: Find unmatched chambers
    const unmatchedChambers = busbarChambers.filter(
      (chamber) => !matchedChambers.includes(chamber)
    );

    console.log("unmatchedChambers", unmatchedChambers);

    // Step 5: Save all chamber.posX + chamber.sizeX values in EndPointsArray
    const EndPointsArray = busbarChambers.map(
      (chamber) => chamber.posX + chamber.sizeX
    );
    console.log("EndPointsArray", EndPointsArray);

    // Step 6: Find nearest and less value in EndPointsArray for each unmatched chamber
    unmatchedChambers.forEach((chamber) => {
      const posX = chamber.posX;

      const closestValue = EndPointsArray.filter((value) => value < posX)
        .reduce(
          (prev, curr) =>
            Math.abs(curr - posX) < Math.abs(prev - posX) ? curr : prev,
          null
        );

      if (closestValue !== null) {
        // Step 7: Update posX for matching elements in this.nodeDataArray
        this.nodeDataArray.forEach((item) => {
          const itemPosArray = item.pos.split(" ").map(Number); // Extract pos[0], pos[1]

          if (itemPosArray[0] === posX && !['outerProfile', 'busbarx'].includes(item.category)) {
            itemPosArray[0] = closestValue; // Update pos[0]
            item.pos = itemPosArray.join(" "); // Update pos as a string
          }
        });

        console.log(`Chamber posX: ${posX}, Nearest Less EndPoint: ${closestValue}`);
      }
    });

    // Log matched and unmatched chambers, and EndPointsArray
    console.log("Matched Chambers:", matchedChambers);
    console.log("Unmatched Chambers:", unmatchedChambers);
    console.log("EndPointsArray:", EndPointsArray);
    console.log("this.nodeDataArray:", this.nodeDataArray);
  }


  processBusbarChamber(pos0) {
    // Step 1: Find the "busbarChamber" element with pos[0] === pos0
    const busbarChamberElement = this.nodeDataArray.find(
      (item) =>
        item.category === "busbarChamber" &&
        Number(item.pos.split(" ")[0]) === pos0
    );

    if (!busbarChamberElement) {
      console.error(`No busbarChamber element found with pos[0] === ${pos0}`);
      return;
    }

    console.log("busbarChamberElement", busbarChamberElement);

    // Step 2: Calculate endpoint
    const busbarSize0 = Number(busbarChamberElement.size.split(" ")[0]);
    const endpoint = busbarSize0 + pos0;

    console.log(`Endpoint: ${endpoint}`);

    // Step 3: Find all matching elements at endpoint, excluding specific categories
    const matchingElements = this.nodeDataArray.filter((item) => {
      const itemPosX = Number(item.pos.split(" ")[0]);
      return (
        itemPosX === endpoint &&
        !["outerProfile", "busbarx"].includes(item.category)
      );
    });

    console.log("Matching elements at endpoint", matchingElements);

    // Step 4: Update size[0] of matching elements
    matchingElements.forEach((item) => {
      const sizeParts = item.size.split(" ").map(Number);
      sizeParts[0] = busbarSize0; // Update size[0] with busbarSize0
      item.size = sizeParts.join(" ");
      console.log(`Updated element: ${JSON.stringify(item)}`);
    });

    console.log("Updated this.nodeDataArray", this.nodeDataArray);
  }

  DoorShiftUndertheTier(startPosition, selectedMaxTierHeight) {
    console.log("this.nodeDataArray", this.nodeDataArray);

    // Step 1: Find door elements with size[1] === 100
    const doorElements = this.nodeDataArray.filter(
      (item) =>
        item.pos.split(" ")[0] == startPosition &&
        item.category === "door" &&
        Number(item.size.split(" ")[1]) === 100
    );

    console.log("Filtered door elements", doorElements);

    if (doorElements.length === 0) {
      console.log("No door elements found. Exiting method.");
      return;
    }

    // Step 1.1: Update the positions of the door elements
    doorElements.forEach((door) => {
      const posParts = door.pos.split(" "); // Split the position string into parts
      posParts[1] = String(Number(posParts[1]) - 100); // Subtract 100 from pos[1]
      door.pos = posParts.join(" "); // Rejoin the position parts into a single string

      // Update size[1]
      const sizeParts = door.size.split(" "); // Split the size string into parts
      sizeParts[1] = "200"; // Set size[1] to 200
      door.size = sizeParts.join(" "); // Rejoin the size parts into a single string
    });

    console.log("Updated door elements' positions", doorElements);

    // Step 2: Find all elements at the same position except specific categories
    const filteredElements = this.nodeDataArray.filter(
      (item) =>
        item.pos.split(" ")[0] == startPosition &&
        !["outerProfile", "busbarx"].includes(item.category)
    );

    console.log("Filtered elements at startPosition", filteredElements);

    // Step 3: Calculate total height
    const totalHeight = filteredElements.reduce(
      (sum, item) => sum + Number(item.size.split(" ")[1]),
      0
    );

    console.log(`Total Height at pos[0] = ${startPosition}:`, totalHeight);

    // Step 4: Check against selectedMaxTierHeight
    if (totalHeight >= selectedMaxTierHeight) {
      // Step 5: Find the maximum pos[0] for category "electricalMCCB"
      const electricalMCCBs = this.nodeDataArray.filter(
        (item) => item.category === "electricalMCCB" &&
          item.pos.split(" ")[0] == startPosition
      );

      if (electricalMCCBs.length === 0) {
        console.error("No electricalMCCB elements found");
      }

      if (electricalMCCBs.length > 0) {
        const maxPosXElement = electricalMCCBs.reduce((maxItem, currentItem) => {
          const maxPosX = Number(maxItem.pos.split(" ")[0]);
          const currentPosX = Number(currentItem.pos.split(" ")[0]);
          return currentPosX > maxPosX ? currentItem : maxItem;
        });

        console.log("Max pos[0] electricalMCCB element", maxPosXElement);

        // Step 6: Create a deep copy of the element, update its values, and replace the original one
        const updatedElement = JSON.parse(JSON.stringify(maxPosXElement)); // Deep copy
        updatedElement.properties.cubicleHeight -= 100;
        updatedElement.shapeSize.height -= 100;

        const sizeParts = updatedElement.size.split(" ");
        sizeParts[1] = String(Number(sizeParts[1]) - 100); // Reduce size[1] by 100
        updatedElement.size = sizeParts.join(" ");

        // Remove the original element from this.nodeDataArray
        this.nodeDataArray = this.nodeDataArray.filter(
          (item) => item.pos !== maxPosXElement.pos
        );

        // Add the updated element to this.nodeDataArray
        this.nodeDataArray.push(updatedElement);

        console.log(
          `Updated and replaced electricalMCCB element at pos[0]: ${updatedElement.properties.cubicleHeight}`
        );
      }
      const CableChamber = this.nodeDataArray.filter(
        (item) => item.category === "cableChamber" &&
          item.pos.split(" ")[0] == startPosition
      );

      if (CableChamber.length === 0) {
        console.error("No electricalMCCB elements found");
      }
      if (CableChamber.length > 0) {
        // Calculate total height of elements at pos[0] === startPosition
        const totalHeightAtPosition = this.nodeDataArray
          .filter((item) => item.pos.split(" ")[0] == startPosition)
          .reduce((sum, item) => sum + Number(item.size.split(" ")[1]), 0);

        console.log(`Total height at pos[0] = ${startPosition}:`, totalHeightAtPosition);

        // Check if the total height is greater than or equal to selectedMaxTierHeight
        if (totalHeightAtPosition >= selectedMaxTierHeight) {
          // Adjust CableChamber size[1]
          CableChamber.forEach((chamber) => {
            const sizeParts = chamber.size.split(" "); // Split the size string into parts
            sizeParts[1] = String(Number(sizeParts[1]) - 100); // Reduce size[1] by 100
            chamber.size = sizeParts.join(" "); // Rejoin the size parts into a single string

            console.log(`Reduced CableChamber size[1] to ${sizeParts[1]} for element at pos[0]: ${startPosition}`);
          });
        }
      }

    }

    console.log("Updated this.nodeDataArray", this.nodeDataArray);
  }

  addMissingVerticalBusbar() {
    console.log("Starting addMissingHorizontalBusbar");

    // Step 1: Filter `electricalMCCB` elements from `this.nodeDataArray`
    const electricalMCCBs = this.nodeDataArray.filter(
      (item) => item.category === "electricalMCCB"
    );

    if (electricalMCCBs.length === 0) {
      console.log("No electricalMCCB elements found.");
      return;
    }

    console.log("Filtered electricalMCCBs:", electricalMCCBs);

    // Step 2: Group `electricalMCCBs` by the same `pos[0]` value
    const groupedMCCBs = electricalMCCBs.reduce((groups, item) => {
      const posX = item.pos.split(" ")[0];
      if (!groups[posX]) groups[posX] = [];
      groups[posX].push(item);
      return groups;
    }, {});

    console.log("Grouped electricalMCCBs by pos[0]:", groupedMCCBs);

    // Step 3: Process each group
    Object.keys(groupedMCCBs).forEach((posX) => {
      const group = groupedMCCBs[posX];

      // Calculate startPosition and endPosition
      const startPosition = Number(posX);
      const endPosition = startPosition + Math.max(...group.map((item) => Number(item.size.split(" ")[0])));

      console.log(`Processing group at pos[0] = ${posX}`);
      console.log(`Start Position: ${startPosition}, End Position: ${endPosition}`);

      // Step 4: Check if there's any `busbarx` element between startPosition and endPosition
      const hasBusbarX = this.nodeDataArray.some((item) => {
        const itemPosX = Number(item.pos.split(" ")[0]);
        return (
          item.category === "busbarx" &&
          itemPosX >= startPosition &&
          itemPosX <= endPosition
        );
      });

      if (hasBusbarX) {
        console.log(`Busbarx already exists between positions ${startPosition} and ${endPosition}. Skipping.`);
        return;
      }

      console.log(`No Busbarx found between positions ${startPosition} and ${endPosition}. Adding new one.`);

      // Step 5: Add a new vertical busbar
      const totalGroupHeight = group.reduce((sum, item) => sum + Number(item.size.split(" ")[1]), 0);
      const newBusbarPos = startPosition + (endPosition - startPosition) / 2;

      const verticalBusBar = {
        "uuid": "9974ceba1dad",
        "text": "Vertical Busbar",
        "color": "#bdae91",
        "size": `20 ${totalGroupHeight}`, // size[0] = 20, size[1] = total height of the group
        "type": "square",
        "category": "busbarx",
        "tool": "main",
        "properties": { "busbarSize": { "amp": "400A - 1600A", "des": "50 x 20 x 400 Single BBS", "orderCode": "BSS051204KIZP", "img": "../../../../../assets/media/busbar-holder-image/BBH Single 50x20x400.jpg" }, "busbarLength": 500, "innerProfile": 400 },
        "image": ".../../../../assets/media/icons/kikcad_2D_Icon_Bus-Bar_VR.svg",
        "pos": `${newBusbarPos} -1100`, // Set the position at the group's midpoint
      };

      console.log("Adding vertical busbar:", verticalBusBar);

      // Add the new busbar to the node data array
      this.nodeDataArray.push(verticalBusBar);
    });

    console.log("Updated this.nodeDataArray:", this.nodeDataArray);
  }

}
